function getDefaultExportFromCjs(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var intersectionObserver = {}, hasRequiredIntersectionObserver;
function requireIntersectionObserver() {
  return hasRequiredIntersectionObserver || (hasRequiredIntersectionObserver = 1, function() {
    if (typeof window != "object")
      return;
    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
      "isIntersecting" in window.IntersectionObserverEntry.prototype || Object.defineProperty(
        window.IntersectionObserverEntry.prototype,
        "isIntersecting",
        {
          get: function() {
            return this.intersectionRatio > 0;
          }
        }
      );
      return;
    }
    function t(m) {
      try {
        return m.defaultView && m.defaultView.frameElement || null;
      } catch {
        return null;
      }
    }
    var e = function(m) {
      for (var h = m, d = t(h); d; )
        h = d.ownerDocument, d = t(h);
      return h;
    }(window.document), r = [], n = null, a = null;
    function o(m) {
      this.time = m.time, this.target = m.target, this.rootBounds = z(m.rootBounds), this.boundingClientRect = z(m.boundingClientRect), this.intersectionRect = z(m.intersectionRect || x()), this.isIntersecting = !!m.intersectionRect;
      var h = this.boundingClientRect, d = h.width * h.height, s = this.intersectionRect, u = s.width * s.height;
      d ? this.intersectionRatio = Number((u / d).toFixed(4)) : this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
    function c(m, h) {
      var d = h || {};
      if (typeof m != "function")
        throw new Error("callback must be a function");
      if (d.root && d.root.nodeType != 1 && d.root.nodeType != 9)
        throw new Error("root must be a Document or Element");
      this._checkForIntersections = _(
        this._checkForIntersections.bind(this),
        this.THROTTLE_TIMEOUT
      ), this._callback = m, this._observationTargets = [], this._queuedEntries = [], this._rootMarginValues = this._parseRootMargin(d.rootMargin), this.thresholds = this._initThresholds(d.threshold), this.root = d.root || null, this.rootMargin = this._rootMarginValues.map(function(s) {
        return s.value + s.unit;
      }).join(" "), this._monitoringDocuments = [], this._monitoringUnsubscribes = [];
    }
    c.prototype.THROTTLE_TIMEOUT = 100, c.prototype.POLL_INTERVAL = null, c.prototype.USE_MUTATION_OBSERVER = !0, c._setupCrossOriginUpdater = function() {
      return n || (n = function(m, h) {
        !m || !h ? a = x() : a = L(m, h), r.forEach(function(d) {
          d._checkForIntersections();
        });
      }), n;
    }, c._resetCrossOriginUpdater = function() {
      n = null, a = null;
    }, c.prototype.observe = function(m) {
      var h = this._observationTargets.some(function(d) {
        return d.element == m;
      });
      if (!h) {
        if (!(m && m.nodeType == 1))
          throw new Error("target must be an Element");
        this._registerInstance(), this._observationTargets.push({ element: m, entry: null }), this._monitorIntersections(m.ownerDocument), this._checkForIntersections();
      }
    }, c.prototype.unobserve = function(m) {
      this._observationTargets = this._observationTargets.filter(function(h) {
        return h.element != m;
      }), this._unmonitorIntersections(m.ownerDocument), this._observationTargets.length == 0 && this._unregisterInstance();
    }, c.prototype.disconnect = function() {
      this._observationTargets = [], this._unmonitorAllIntersections(), this._unregisterInstance();
    }, c.prototype.takeRecords = function() {
      var m = this._queuedEntries.slice();
      return this._queuedEntries = [], m;
    }, c.prototype._initThresholds = function(m) {
      var h = m || [0];
      return Array.isArray(h) || (h = [h]), h.sort().filter(function(d, s, u) {
        if (typeof d != "number" || isNaN(d) || d < 0 || d > 1)
          throw new Error("threshold must be a number between 0 and 1 inclusively");
        return d !== u[s - 1];
      });
    }, c.prototype._parseRootMargin = function(m) {
      var h = m || "0px", d = h.split(/\s+/).map(function(s) {
        var u = /^(-?\d*\.?\d+)(px|%)$/.exec(s);
        if (!u)
          throw new Error("rootMargin must be specified in pixels or percent");
        return { value: parseFloat(u[1]), unit: u[2] };
      });
      return d[1] = d[1] || d[0], d[2] = d[2] || d[0], d[3] = d[3] || d[1], d;
    }, c.prototype._monitorIntersections = function(m) {
      var h = m.defaultView;
      if (h && this._monitoringDocuments.indexOf(m) == -1) {
        var d = this._checkForIntersections, s = null, u = null;
        this.POLL_INTERVAL ? s = h.setInterval(d, this.POLL_INTERVAL) : (E(h, "resize", d, !0), E(m, "scroll", d, !0), this.USE_MUTATION_OBSERVER && "MutationObserver" in h && (u = new h.MutationObserver(d), u.observe(m, {
          attributes: !0,
          childList: !0,
          characterData: !0,
          subtree: !0
        }))), this._monitoringDocuments.push(m), this._monitoringUnsubscribes.push(function() {
          var y = m.defaultView;
          y && (s && y.clearInterval(s), A(y, "resize", d, !0)), A(m, "scroll", d, !0), u && u.disconnect();
        });
        var f = this.root && (this.root.ownerDocument || this.root) || e;
        if (m != f) {
          var v = t(m);
          v && this._monitorIntersections(v.ownerDocument);
        }
      }
    }, c.prototype._unmonitorIntersections = function(m) {
      var h = this._monitoringDocuments.indexOf(m);
      if (h != -1) {
        var d = this.root && (this.root.ownerDocument || this.root) || e, s = this._observationTargets.some(function(v) {
          var y = v.element.ownerDocument;
          if (y == m)
            return !0;
          for (; y && y != d; ) {
            var w = t(y);
            if (y = w && w.ownerDocument, y == m)
              return !0;
          }
          return !1;
        });
        if (!s) {
          var u = this._monitoringUnsubscribes[h];
          if (this._monitoringDocuments.splice(h, 1), this._monitoringUnsubscribes.splice(h, 1), u(), m != d) {
            var f = t(m);
            f && this._unmonitorIntersections(f.ownerDocument);
          }
        }
      }
    }, c.prototype._unmonitorAllIntersections = function() {
      var m = this._monitoringUnsubscribes.slice(0);
      this._monitoringDocuments.length = 0, this._monitoringUnsubscribes.length = 0;
      for (var h = 0; h < m.length; h++)
        m[h]();
    }, c.prototype._checkForIntersections = function() {
      if (!(!this.root && n && !a)) {
        var m = this._rootIsInDom(), h = m ? this._getRootRect() : x();
        this._observationTargets.forEach(function(d) {
          var s = d.element, u = C(s), f = this._rootContainsTarget(s), v = d.entry, y = m && f && this._computeTargetAndRootIntersection(s, u, h), w = null;
          this._rootContainsTarget(s) ? (!n || this.root) && (w = h) : w = x();
          var O = d.entry = new o({
            time: p(),
            target: s,
            boundingClientRect: u,
            rootBounds: w,
            intersectionRect: y
          });
          v ? m && f ? this._hasCrossedThreshold(v, O) && this._queuedEntries.push(O) : v && v.isIntersecting && this._queuedEntries.push(O) : this._queuedEntries.push(O);
        }, this), this._queuedEntries.length && this._callback(this.takeRecords(), this);
      }
    }, c.prototype._computeTargetAndRootIntersection = function(m, h, d) {
      if (window.getComputedStyle(m).display != "none") {
        for (var s = h, u = $(m), f = !1; !f && u; ) {
          var v = null, y = u.nodeType == 1 ? window.getComputedStyle(u) : {};
          if (y.display == "none") return null;
          if (u == this.root || u.nodeType == /* DOCUMENT */
          9)
            if (f = !0, u == this.root || u == e)
              n && !this.root ? !a || a.width == 0 && a.height == 0 ? (u = null, v = null, s = null) : v = a : v = d;
            else {
              var w = $(u), O = w && C(w), U = w && this._computeTargetAndRootIntersection(w, O, d);
              O && U ? (u = w, v = L(O, U)) : (u = null, s = null);
            }
          else {
            var M = u.ownerDocument;
            u != M.body && u != M.documentElement && y.overflow != "visible" && (v = C(u));
          }
          if (v && (s = S(v, s)), !s) break;
          u = u && $(u);
        }
        return s;
      }
    }, c.prototype._getRootRect = function() {
      var m;
      if (this.root && !D(this.root))
        m = C(this.root);
      else {
        var h = D(this.root) ? this.root : e, d = h.documentElement, s = h.body;
        m = {
          top: 0,
          left: 0,
          right: d.clientWidth || s.clientWidth,
          width: d.clientWidth || s.clientWidth,
          bottom: d.clientHeight || s.clientHeight,
          height: d.clientHeight || s.clientHeight
        };
      }
      return this._expandRectByRootMargin(m);
    }, c.prototype._expandRectByRootMargin = function(m) {
      var h = this._rootMarginValues.map(function(s, u) {
        return s.unit == "px" ? s.value : s.value * (u % 2 ? m.width : m.height) / 100;
      }), d = {
        top: m.top - h[0],
        right: m.right + h[1],
        bottom: m.bottom + h[2],
        left: m.left - h[3]
      };
      return d.width = d.right - d.left, d.height = d.bottom - d.top, d;
    }, c.prototype._hasCrossedThreshold = function(m, h) {
      var d = m && m.isIntersecting ? m.intersectionRatio || 0 : -1, s = h.isIntersecting ? h.intersectionRatio || 0 : -1;
      if (d !== s)
        for (var u = 0; u < this.thresholds.length; u++) {
          var f = this.thresholds[u];
          if (f == d || f == s || f < d != f < s)
            return !0;
        }
    }, c.prototype._rootIsInDom = function() {
      return !this.root || I(e, this.root);
    }, c.prototype._rootContainsTarget = function(m) {
      var h = this.root && (this.root.ownerDocument || this.root) || e;
      return I(h, m) && (!this.root || h == m.ownerDocument);
    }, c.prototype._registerInstance = function() {
      r.indexOf(this) < 0 && r.push(this);
    }, c.prototype._unregisterInstance = function() {
      var m = r.indexOf(this);
      m != -1 && r.splice(m, 1);
    };
    function p() {
      return window.performance && performance.now && performance.now();
    }
    function _(m, h) {
      var d = null;
      return function() {
        d || (d = setTimeout(function() {
          m(), d = null;
        }, h));
      };
    }
    function E(m, h, d, s) {
      typeof m.addEventListener == "function" ? m.addEventListener(h, d, s) : typeof m.attachEvent == "function" && m.attachEvent("on" + h, d);
    }
    function A(m, h, d, s) {
      typeof m.removeEventListener == "function" ? m.removeEventListener(h, d, s) : typeof m.detachEvent == "function" && m.detachEvent("on" + h, d);
    }
    function S(m, h) {
      var d = Math.max(m.top, h.top), s = Math.min(m.bottom, h.bottom), u = Math.max(m.left, h.left), f = Math.min(m.right, h.right), v = f - u, y = s - d;
      return v >= 0 && y >= 0 && {
        top: d,
        bottom: s,
        left: u,
        right: f,
        width: v,
        height: y
      } || null;
    }
    function C(m) {
      var h;
      try {
        h = m.getBoundingClientRect();
      } catch {
      }
      return h ? (h.width && h.height || (h = {
        top: h.top,
        right: h.right,
        bottom: h.bottom,
        left: h.left,
        width: h.right - h.left,
        height: h.bottom - h.top
      }), h) : x();
    }
    function x() {
      return {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        width: 0,
        height: 0
      };
    }
    function z(m) {
      return !m || "x" in m ? m : {
        top: m.top,
        y: m.top,
        bottom: m.bottom,
        left: m.left,
        x: m.left,
        right: m.right,
        width: m.width,
        height: m.height
      };
    }
    function L(m, h) {
      var d = h.top - m.top, s = h.left - m.left;
      return {
        top: d,
        left: s,
        height: h.height,
        width: h.width,
        bottom: d + h.height,
        right: s + h.width
      };
    }
    function I(m, h) {
      for (var d = h; d; ) {
        if (d == m) return !0;
        d = $(d);
      }
      return !1;
    }
    function $(m) {
      var h = m.parentNode;
      return m.nodeType == /* DOCUMENT */
      9 && m != e ? t(m) : (h && h.assignedSlot && (h = h.assignedSlot.parentNode), h && h.nodeType == 11 && h.host ? h.host : h);
    }
    function D(m) {
      return m && m.nodeType === 9;
    }
    window.IntersectionObserver = c, window.IntersectionObserverEntry = o;
  }()), intersectionObserver;
}
requireIntersectionObserver();
var isEmail$1 = { exports: {} }, assertString = { exports: {} }, hasRequiredAssertString;
function requireAssertString() {
  return hasRequiredAssertString || (hasRequiredAssertString = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = n;
    function r(a) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(c) {
        return typeof c;
      } : r = function(c) {
        return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
      }, r(a);
    }
    function n(a) {
      var o = typeof a == "string" || a instanceof String;
      if (!o) {
        var c;
        throw a === null ? c = "null" : (c = r(a), c === "object" && a.constructor && a.constructor.hasOwnProperty("name") ? c = a.constructor.name : c = "a ".concat(c)), new TypeError("Expected string but received ".concat(c, "."));
      }
    }
    t.exports = e.default, t.exports.default = e.default;
  }(assertString, assertString.exports)), assertString.exports;
}
var merge = { exports: {} }, hasRequiredMerge;
function requireMerge() {
  return hasRequiredMerge || (hasRequiredMerge = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = r;
    function r() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = arguments.length > 1 ? arguments[1] : void 0;
      for (var o in a)
        typeof n[o] > "u" && (n[o] = a[o]);
      return n;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(merge, merge.exports)), merge.exports;
}
var isByteLength = { exports: {} }, hasRequiredIsByteLength;
function requireIsByteLength() {
  return hasRequiredIsByteLength || (hasRequiredIsByteLength = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = o;
    var r = n(/* @__PURE__ */ requireAssertString());
    function n(c) {
      return c && c.__esModule ? c : { default: c };
    }
    function a(c) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? a = function(_) {
        return typeof _;
      } : a = function(_) {
        return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
      }, a(c);
    }
    function o(c, p) {
      (0, r.default)(c);
      var _, E;
      a(p) === "object" ? (_ = p.min || 0, E = p.max) : (_ = arguments[1], E = arguments[2]);
      var A = encodeURI(c).split(/%..|./).length - 1;
      return A >= _ && (typeof E > "u" || A <= E);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(isByteLength, isByteLength.exports)), isByteLength.exports;
}
var isFQDN = { exports: {} }, hasRequiredIsFQDN;
function requireIsFQDN() {
  return hasRequiredIsFQDN || (hasRequiredIsFQDN = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = c;
    var r = a(/* @__PURE__ */ requireAssertString()), n = a(/* @__PURE__ */ requireMerge());
    function a(p) {
      return p && p.__esModule ? p : { default: p };
    }
    var o = {
      require_tld: !0,
      allow_underscores: !1,
      allow_trailing_dot: !1
    };
    function c(p, _) {
      (0, r.default)(p), _ = (0, n.default)(_, o), _.allow_trailing_dot && p[p.length - 1] === "." && (p = p.substring(0, p.length - 1));
      for (var E = p.split("."), A = 0; A < E.length; A++)
        if (E[A].length > 63)
          return !1;
      if (_.require_tld) {
        var S = E.pop();
        if (!E.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(S) || /[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20\u00A9\uFFFD]/.test(S))
          return !1;
      }
      for (var C, x = 0; x < E.length; x++)
        if (C = E[x], _.allow_underscores && (C = C.replace(/_/g, "")), !/^[a-z\u00a1-\uffff0-9-]+$/i.test(C) || /[\uff01-\uff5e]/.test(C) || C[0] === "-" || C[C.length - 1] === "-")
          return !1;
      return !0;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(isFQDN, isFQDN.exports)), isFQDN.exports;
}
var isIP = { exports: {} }, hasRequiredIsIP;
function requireIsIP() {
  return hasRequiredIsIP || (hasRequiredIsIP = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = c;
    var r = n(/* @__PURE__ */ requireAssertString());
    function n(p) {
      return p && p.__esModule ? p : { default: p };
    }
    var a = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/, o = /^[0-9A-F]{1,4}$/i;
    function c(p) {
      var _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      if ((0, r.default)(p), _ = String(_), _) {
        if (_ === "4") {
          if (!a.test(p))
            return !1;
          var E = p.split(".").sort(function(I, $) {
            return I - $;
          });
          return E[3] <= 255;
        } else if (_ === "6") {
          var A = [p];
          if (p.includes("%") && (A = p.split("%"), A.length !== 2 || !A[0].includes(":") || A[1] === ""))
            return !1;
          var S = A[0].split(":"), C = !1, x = c(S[S.length - 1], 4), z = x ? 7 : 8;
          if (S.length > z)
            return !1;
          if (p === "::")
            return !0;
          p.substr(0, 2) === "::" ? (S.shift(), S.shift(), C = !0) : p.substr(p.length - 2) === "::" && (S.pop(), S.pop(), C = !0);
          for (var L = 0; L < S.length; ++L)
            if (S[L] === "" && L > 0 && L < S.length - 1) {
              if (C)
                return !1;
              C = !0;
            } else if (!(x && L === S.length - 1)) {
              if (!o.test(S[L]))
                return !1;
            }
          return C ? S.length >= 1 : S.length === z;
        }
      } else return c(p, 4) || c(p, 6);
      return !1;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(isIP, isIP.exports)), isIP.exports;
}
var hasRequiredIsEmail;
function requireIsEmail() {
  return hasRequiredIsEmail || (hasRequiredIsEmail = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = u;
    var r = p(/* @__PURE__ */ requireAssertString()), n = p(/* @__PURE__ */ requireMerge()), a = p(/* @__PURE__ */ requireIsByteLength()), o = p(/* @__PURE__ */ requireIsFQDN()), c = p(/* @__PURE__ */ requireIsIP());
    function p(f) {
      return f && f.__esModule ? f : { default: f };
    }
    function _(f, v) {
      return x(f) || C(f, v) || A(f, v) || E();
    }
    function E() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function A(f, v) {
      if (f) {
        if (typeof f == "string") return S(f, v);
        var y = Object.prototype.toString.call(f).slice(8, -1);
        if (y === "Object" && f.constructor && (y = f.constructor.name), y === "Map" || y === "Set") return Array.from(f);
        if (y === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(y)) return S(f, v);
      }
    }
    function S(f, v) {
      (v == null || v > f.length) && (v = f.length);
      for (var y = 0, w = new Array(v); y < v; y++)
        w[y] = f[y];
      return w;
    }
    function C(f, v) {
      if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(f)))) {
        var y = [], w = !0, O = !1, U = void 0;
        try {
          for (var M = f[Symbol.iterator](), H; !(w = (H = M.next()).done) && (y.push(H.value), !(v && y.length === v)); w = !0)
            ;
        } catch (K) {
          O = !0, U = K;
        } finally {
          try {
            !w && M.return != null && M.return();
          } finally {
            if (O) throw U;
          }
        }
        return y;
      }
    }
    function x(f) {
      if (Array.isArray(f)) return f;
    }
    var z = {
      allow_display_name: !1,
      require_display_name: !1,
      allow_utf8_local_part: !0,
      require_tld: !0
    }, L = /^([^\x00-\x1F\x7F-\x9F\cX]+)<(.+)>$/i, I = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i, $ = /^[a-z\d]+$/, D = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i, m = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i, h = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i, d = 254;
    function s(f) {
      var v = f.match(/^"(.+)"$/i), y = v ? v[1] : f;
      if (!y.trim())
        return !1;
      var w = /[\.";<>]/.test(y);
      if (w) {
        if (!v)
          return !1;
        var O = y.split('"').length === y.split('\\"').length;
        if (!O)
          return !1;
      }
      return !0;
    }
    function u(f, v) {
      if ((0, r.default)(f), v = (0, n.default)(v, z), v.require_display_name || v.allow_display_name) {
        var y = f.match(L);
        if (y) {
          var w, O = _(y, 3);
          if (w = O[1], f = O[2], w.endsWith(" ") && (w = w.substr(0, w.length - 1)), !s(w))
            return !1;
        } else if (v.require_display_name)
          return !1;
      }
      if (!v.ignore_max_length && f.length > d)
        return !1;
      var U = f.split("@"), M = U.pop(), H = U.join("@"), K = M.toLowerCase();
      if (v.domain_specific_validation && (K === "gmail.com" || K === "googlemail.com")) {
        H = H.toLowerCase();
        var Q = H.split("+")[0];
        if (!(0, a.default)(Q.replace(".", ""), {
          min: 6,
          max: 30
        }))
          return !1;
        for (var X = Q.split("."), re = 0; re < X.length; re++)
          if (!$.test(X[re]))
            return !1;
      }
      if (!(0, a.default)(H, {
        max: 64
      }) || !(0, a.default)(M, {
        max: 254
      }))
        return !1;
      if (!(0, o.default)(M, {
        require_tld: v.require_tld
      })) {
        if (!v.allow_ip_domain)
          return !1;
        if (!(0, c.default)(M)) {
          if (!M.startsWith("[") || !M.endsWith("]"))
            return !1;
          var l = M.substr(1, M.length - 2);
          if (l.length === 0 || !(0, c.default)(l))
            return !1;
        }
      }
      if (H[0] === '"')
        return H = H.slice(1, H.length - 1), v.allow_utf8_local_part ? h.test(H) : D.test(H);
      for (var b = v.allow_utf8_local_part ? m : I, R = H.split("."), k = 0; k < R.length; k++)
        if (!b.test(R[k]))
          return !1;
      return !0;
    }
    t.exports = e.default, t.exports.default = e.default;
  }(isEmail$1, isEmail$1.exports)), isEmail$1.exports;
}
var isEmailExports = /* @__PURE__ */ requireIsEmail();
const isEmail = /* @__PURE__ */ getDefaultExportFromCjs(isEmailExports);
var isNumeric$1 = { exports: {} }, alpha = {}, hasRequiredAlpha;
function requireAlpha() {
  if (hasRequiredAlpha) return alpha;
  hasRequiredAlpha = 1, Object.defineProperty(alpha, "__esModule", {
    value: !0
  }), alpha.commaDecimal = alpha.dotDecimal = alpha.arabicLocales = alpha.englishLocales = alpha.decimal = alpha.alphanumeric = alpha.alpha = void 0;
  var t = {
    "en-US": /^[A-Z]+$/i,
    "bg-BG": /^[А-Я]+$/i,
    "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[A-ZÆØÅ]+$/i,
    "de-DE": /^[A-ZÄÖÜß]+$/i,
    "el-GR": /^[Α-ώ]+$/i,
    "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
    "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "nb-NO": /^[A-ZÆØÅ]+$/i,
    "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[A-ZÆØÅ]+$/i,
    "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[А-ЯЁ]+$/i,
    "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[A-ZÅÄÖ]+$/i,
    "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
    "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[א-ת]+$/,
    "fa-IR": /^['آابپتثجچهخدذرزژسشصضطظعغفقکگلمنوهی']+$/i
  };
  alpha.alpha = t;
  var e = {
    "en-US": /^[0-9A-Z]+$/i,
    "bg-BG": /^[0-9А-Я]+$/i,
    "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[0-9A-ZÆØÅ]+$/i,
    "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
    "el-GR": /^[0-9Α-ω]+$/i,
    "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
    "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
    "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
    "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[0-9А-ЯЁ]+$/i,
    "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
    "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
    "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[0-9א-ת]+$/,
    "fa-IR": /^['0-9آابپتثجچهخدذرزژسشصضطظعغفقکگلمنوهی۱۲۳۴۵۶۷۸۹۰']+$/i
  };
  alpha.alphanumeric = e;
  var r = {
    "en-US": ".",
    ar: "٫"
  };
  alpha.decimal = r;
  var n = ["AU", "GB", "HK", "IN", "NZ", "ZA", "ZM"];
  alpha.englishLocales = n;
  for (var a, o = 0; o < n.length; o++)
    a = "en-".concat(n[o]), t[a] = t["en-US"], e[a] = e["en-US"], r[a] = r["en-US"];
  var c = ["AE", "BH", "DZ", "EG", "IQ", "JO", "KW", "LB", "LY", "MA", "QM", "QA", "SA", "SD", "SY", "TN", "YE"];
  alpha.arabicLocales = c;
  for (var p, _ = 0; _ < c.length; _++)
    p = "ar-".concat(c[_]), t[p] = t.ar, e[p] = e.ar, r[p] = r.ar;
  var E = ["ar-EG", "ar-LB", "ar-LY"];
  alpha.dotDecimal = E;
  var A = ["bg-BG", "cs-CZ", "da-DK", "de-DE", "el-GR", "en-ZM", "es-ES", "fr-FR", "it-IT", "ku-IQ", "hu-HU", "nb-NO", "nn-NO", "nl-NL", "pl-PL", "pt-PT", "ru-RU", "sl-SI", "sr-RS@latin", "sr-RS", "sv-SE", "tr-TR", "uk-UA"];
  alpha.commaDecimal = A;
  for (var S = 0; S < E.length; S++)
    r[E[S]] = r["en-US"];
  for (var C = 0; C < A.length; C++)
    r[A[C]] = ",";
  return t["pt-BR"] = t["pt-PT"], e["pt-BR"] = e["pt-PT"], r["pt-BR"] = r["pt-PT"], t["pl-Pl"] = t["pl-PL"], e["pl-Pl"] = e["pl-PL"], r["pl-Pl"] = r["pl-PL"], alpha;
}
var hasRequiredIsNumeric;
function requireIsNumeric() {
  return hasRequiredIsNumeric || (hasRequiredIsNumeric = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = c;
    var r = a(/* @__PURE__ */ requireAssertString()), n = /* @__PURE__ */ requireAlpha();
    function a(p) {
      return p && p.__esModule ? p : { default: p };
    }
    var o = /^[0-9]+$/;
    function c(p, _) {
      return (0, r.default)(p), _ && _.no_symbols ? o.test(p) : new RegExp("^[+-]?([0-9]*[".concat((_ || {}).locale ? n.decimal[_.locale] : ".", "])?[0-9]+$")).test(p);
    }
    t.exports = e.default, t.exports.default = e.default;
  }(isNumeric$1, isNumeric$1.exports)), isNumeric$1.exports;
}
var isNumericExports = /* @__PURE__ */ requireIsNumeric();
const isNumeric = /* @__PURE__ */ getDefaultExportFromCjs(isNumericExports);
var isURL$1 = { exports: {} }, hasRequiredIsURL;
function requireIsURL() {
  return hasRequiredIsURL || (hasRequiredIsURL = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = S;
    var r = c(/* @__PURE__ */ requireAssertString()), n = c(/* @__PURE__ */ requireIsFQDN()), a = c(/* @__PURE__ */ requireIsIP()), o = c(/* @__PURE__ */ requireMerge());
    function c(C) {
      return C && C.__esModule ? C : { default: C };
    }
    var p = {
      protocols: ["http", "https", "ftp"],
      require_tld: !0,
      require_protocol: !1,
      require_host: !0,
      require_valid_protocol: !0,
      allow_underscores: !1,
      allow_trailing_dot: !1,
      allow_protocol_relative_urls: !1
    }, _ = /^\[([^\]]+)\](?::([0-9]+))?$/;
    function E(C) {
      return Object.prototype.toString.call(C) === "[object RegExp]";
    }
    function A(C, x) {
      for (var z = 0; z < x.length; z++) {
        var L = x[z];
        if (C === L || E(L) && L.test(C))
          return !0;
      }
      return !1;
    }
    function S(C, x) {
      if ((0, r.default)(C), !C || C.length >= 2083 || /[\s<>]/.test(C) || C.indexOf("mailto:") === 0)
        return !1;
      x = (0, o.default)(x, p);
      var z, L, I, $, D, m, h, d;
      if (h = C.split("#"), C = h.shift(), h = C.split("?"), C = h.shift(), h = C.split("://"), h.length > 1) {
        if (z = h.shift().toLowerCase(), x.require_valid_protocol && x.protocols.indexOf(z) === -1)
          return !1;
      } else {
        if (x.require_protocol)
          return !1;
        if (C.substr(0, 2) === "//") {
          if (!x.allow_protocol_relative_urls)
            return !1;
          h[0] = C.substr(2);
        }
      }
      if (C = h.join("://"), C === "")
        return !1;
      if (h = C.split("/"), C = h.shift(), C === "" && !x.require_host)
        return !0;
      if (h = C.split("@"), h.length > 1 && (x.disallow_auth || (L = h.shift(), L.indexOf(":") >= 0 && L.split(":").length > 2)))
        return !1;
      $ = h.join("@"), m = null, d = null;
      var s = $.match(_);
      return s ? (I = "", d = s[1], m = s[2] || null) : (h = $.split(":"), I = h.shift(), h.length && (m = h.join(":"))), !(m !== null && (D = parseInt(m, 10), !/^[0-9]+$/.test(m) || D <= 0 || D > 65535) || !(0, a.default)(I) && !(0, n.default)(I, x) && (!d || !(0, a.default)(d, 6)) || (I = I || d, x.host_whitelist && !A(I, x.host_whitelist)) || x.host_blacklist && A(I, x.host_blacklist));
    }
    t.exports = e.default, t.exports.default = e.default;
  }(isURL$1, isURL$1.exports)), isURL$1.exports;
}
var isURLExports = /* @__PURE__ */ requireIsURL();
const isURL = /* @__PURE__ */ getDefaultExportFromCjs(isURLExports);
var isFloat$1 = {}, hasRequiredIsFloat;
function requireIsFloat() {
  if (hasRequiredIsFloat) return isFloat$1;
  hasRequiredIsFloat = 1, Object.defineProperty(isFloat$1, "__esModule", {
    value: !0
  }), isFloat$1.default = n, isFloat$1.locales = void 0;
  var t = r(/* @__PURE__ */ requireAssertString()), e = /* @__PURE__ */ requireAlpha();
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function n(o, c) {
    (0, t.default)(o), c = c || {};
    var p = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(c.locale ? e.decimal[c.locale] : ".", "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
    if (o === "" || o === "." || o === "-" || o === "+")
      return !1;
    var _ = parseFloat(o.replace(",", "."));
    return p.test(o) && (!c.hasOwnProperty("min") || _ >= c.min) && (!c.hasOwnProperty("max") || _ <= c.max) && (!c.hasOwnProperty("lt") || _ < c.lt) && (!c.hasOwnProperty("gt") || _ > c.gt);
  }
  var a = Object.keys(e.decimal);
  return isFloat$1.locales = a, isFloat$1;
}
var isFloatExports = /* @__PURE__ */ requireIsFloat();
const isFloat = /* @__PURE__ */ getDefaultExportFromCjs(isFloatExports);
var intlTelInput$2 = { exports: {} }, hasRequiredIntlTelInput$1;
function requireIntlTelInput$1() {
  return hasRequiredIntlTelInput$1 || (hasRequiredIntlTelInput$1 = 1, function(t) {
    (function(e) {
      t.exports ? t.exports = e() : window.intlTelInput = e();
    })(function(e) {
      return function() {
        for (var r = [["Afghanistan (‫افغانستان‬‎)", "af", "93"], ["Albania (Shqipëri)", "al", "355"], ["Algeria (‫الجزائر‬‎)", "dz", "213"], ["American Samoa", "as", "1", 5, ["684"]], ["Andorra", "ad", "376"], ["Angola", "ao", "244"], ["Anguilla", "ai", "1", 6, ["264"]], ["Antigua and Barbuda", "ag", "1", 7, ["268"]], ["Argentina", "ar", "54"], ["Armenia (Հայաստան)", "am", "374"], ["Aruba", "aw", "297"], ["Ascension Island", "ac", "247"], ["Australia", "au", "61", 0], ["Austria (Österreich)", "at", "43"], ["Azerbaijan (Azərbaycan)", "az", "994"], ["Bahamas", "bs", "1", 8, ["242"]], ["Bahrain (‫البحرين‬‎)", "bh", "973"], ["Bangladesh (বাংলাদেশ)", "bd", "880"], ["Barbados", "bb", "1", 9, ["246"]], ["Belarus (Беларусь)", "by", "375"], ["Belgium (België)", "be", "32"], ["Belize", "bz", "501"], ["Benin (Bénin)", "bj", "229"], ["Bermuda", "bm", "1", 10, ["441"]], ["Bhutan (འབྲུག)", "bt", "975"], ["Bolivia", "bo", "591"], ["Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "387"], ["Botswana", "bw", "267"], ["Brazil (Brasil)", "br", "55"], ["British Indian Ocean Territory", "io", "246"], ["British Virgin Islands", "vg", "1", 11, ["284"]], ["Brunei", "bn", "673"], ["Bulgaria (България)", "bg", "359"], ["Burkina Faso", "bf", "226"], ["Burundi (Uburundi)", "bi", "257"], ["Cambodia (កម្ពុជា)", "kh", "855"], ["Cameroon (Cameroun)", "cm", "237"], ["Canada", "ca", "1", 1, ["204", "226", "236", "249", "250", "263", "289", "306", "343", "354", "365", "367", "368", "382", "387", "403", "416", "418", "428", "431", "437", "438", "450", "584", "468", "474", "506", "514", "519", "548", "579", "581", "584", "587", "604", "613", "639", "647", "672", "683", "705", "709", "742", "753", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde (Kabu Verdi)", "cv", "238"], ["Caribbean Netherlands", "bq", "599", 1, ["3", "4", "7"]], ["Cayman Islands", "ky", "1", 12, ["345"]], ["Central African Republic (République centrafricaine)", "cf", "236"], ["Chad (Tchad)", "td", "235"], ["Chile", "cl", "56"], ["China (中国)", "cn", "86"], ["Christmas Island", "cx", "61", 2, ["89164"]], ["Cocos (Keeling) Islands", "cc", "61", 1, ["89162"]], ["Colombia", "co", "57"], ["Comoros (‫جزر القمر‬‎)", "km", "269"], ["Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243"], ["Congo (Republic) (Congo-Brazzaville)", "cg", "242"], ["Cook Islands", "ck", "682"], ["Costa Rica", "cr", "506"], ["Côte d’Ivoire", "ci", "225"], ["Croatia (Hrvatska)", "hr", "385"], ["Cuba", "cu", "53"], ["Curaçao", "cw", "599", 0], ["Cyprus (Κύπρος)", "cy", "357"], ["Czech Republic (Česká republika)", "cz", "420"], ["Denmark (Danmark)", "dk", "45"], ["Djibouti", "dj", "253"], ["Dominica", "dm", "1", 13, ["767"]], ["Dominican Republic (República Dominicana)", "do", "1", 2, ["809", "829", "849"]], ["Ecuador", "ec", "593"], ["Egypt (‫مصر‬‎)", "eg", "20"], ["El Salvador", "sv", "503"], ["Equatorial Guinea (Guinea Ecuatorial)", "gq", "240"], ["Eritrea", "er", "291"], ["Estonia (Eesti)", "ee", "372"], ["Eswatini", "sz", "268"], ["Ethiopia", "et", "251"], ["Falkland Islands (Islas Malvinas)", "fk", "500"], ["Faroe Islands (Føroyar)", "fo", "298"], ["Fiji", "fj", "679"], ["Finland (Suomi)", "fi", "358", 0], ["France", "fr", "33"], ["French Guiana (Guyane française)", "gf", "594"], ["French Polynesia (Polynésie française)", "pf", "689"], ["Gabon", "ga", "241"], ["Gambia", "gm", "220"], ["Georgia (საქართველო)", "ge", "995"], ["Germany (Deutschland)", "de", "49"], ["Ghana (Gaana)", "gh", "233"], ["Gibraltar", "gi", "350"], ["Greece (Ελλάδα)", "gr", "30"], ["Greenland (Kalaallit Nunaat)", "gl", "299"], ["Grenada", "gd", "1", 14, ["473"]], ["Guadeloupe", "gp", "590", 0], ["Guam", "gu", "1", 15, ["671"]], ["Guatemala", "gt", "502"], ["Guernsey", "gg", "44", 1, ["1481", "7781", "7839", "7911"]], ["Guinea (Guinée)", "gn", "224"], ["Guinea-Bissau (Guiné Bissau)", "gw", "245"], ["Guyana", "gy", "592"], ["Haiti", "ht", "509"], ["Honduras", "hn", "504"], ["Hong Kong (香港)", "hk", "852"], ["Hungary (Magyarország)", "hu", "36"], ["Iceland (Ísland)", "is", "354"], ["India (भारत)", "in", "91"], ["Indonesia", "id", "62"], ["Iran (‫ایران‬‎)", "ir", "98"], ["Iraq (‫العراق‬‎)", "iq", "964"], ["Ireland", "ie", "353"], ["Isle of Man", "im", "44", 2, ["1624", "74576", "7524", "7924", "7624"]], ["Israel (‫ישראל‬‎)", "il", "972"], ["Italy (Italia)", "it", "39", 0], ["Jamaica", "jm", "1", 4, ["876", "658"]], ["Japan (日本)", "jp", "81"], ["Jersey", "je", "44", 3, ["1534", "7509", "7700", "7797", "7829", "7937"]], ["Jordan (‫الأردن‬‎)", "jo", "962"], ["Kazakhstan (Казахстан)", "kz", "7", 1, ["33", "7"]], ["Kenya", "ke", "254"], ["Kiribati", "ki", "686"], ["Kosovo", "xk", "383"], ["Kuwait (‫الكويت‬‎)", "kw", "965"], ["Kyrgyzstan (Кыргызстан)", "kg", "996"], ["Laos (ລາວ)", "la", "856"], ["Latvia (Latvija)", "lv", "371"], ["Lebanon (‫لبنان‬‎)", "lb", "961"], ["Lesotho", "ls", "266"], ["Liberia", "lr", "231"], ["Libya (‫ليبيا‬‎)", "ly", "218"], ["Liechtenstein", "li", "423"], ["Lithuania (Lietuva)", "lt", "370"], ["Luxembourg", "lu", "352"], ["Macau (澳門)", "mo", "853"], ["Madagascar (Madagasikara)", "mg", "261"], ["Malawi", "mw", "265"], ["Malaysia", "my", "60"], ["Maldives", "mv", "960"], ["Mali", "ml", "223"], ["Malta", "mt", "356"], ["Marshall Islands", "mh", "692"], ["Martinique", "mq", "596"], ["Mauritania (‫موريتانيا‬‎)", "mr", "222"], ["Mauritius (Moris)", "mu", "230"], ["Mayotte", "yt", "262", 1, ["269", "639"]], ["Mexico (México)", "mx", "52"], ["Micronesia", "fm", "691"], ["Moldova (Republica Moldova)", "md", "373"], ["Monaco", "mc", "377"], ["Mongolia (Монгол)", "mn", "976"], ["Montenegro (Crna Gora)", "me", "382"], ["Montserrat", "ms", "1", 16, ["664"]], ["Morocco (‫المغرب‬‎)", "ma", "212", 0], ["Mozambique (Moçambique)", "mz", "258"], ["Myanmar (Burma) (မြန်မာ)", "mm", "95"], ["Namibia (Namibië)", "na", "264"], ["Nauru", "nr", "674"], ["Nepal (नेपाल)", "np", "977"], ["Netherlands (Nederland)", "nl", "31"], ["New Caledonia (Nouvelle-Calédonie)", "nc", "687"], ["New Zealand", "nz", "64"], ["Nicaragua", "ni", "505"], ["Niger (Nijar)", "ne", "227"], ["Nigeria", "ng", "234"], ["Niue", "nu", "683"], ["Norfolk Island", "nf", "672"], ["North Korea (조선 민주주의 인민 공화국)", "kp", "850"], ["North Macedonia (Северна Македонија)", "mk", "389"], ["Northern Mariana Islands", "mp", "1", 17, ["670"]], ["Norway (Norge)", "no", "47", 0], ["Oman (‫عُمان‬‎)", "om", "968"], ["Pakistan (‫پاکستان‬‎)", "pk", "92"], ["Palau", "pw", "680"], ["Palestine (‫فلسطين‬‎)", "ps", "970"], ["Panama (Panamá)", "pa", "507"], ["Papua New Guinea", "pg", "675"], ["Paraguay", "py", "595"], ["Peru (Perú)", "pe", "51"], ["Philippines", "ph", "63"], ["Poland (Polska)", "pl", "48"], ["Portugal", "pt", "351"], ["Puerto Rico", "pr", "1", 3, ["787", "939"]], ["Qatar (‫قطر‬‎)", "qa", "974"], ["Réunion (La Réunion)", "re", "262", 0], ["Romania (România)", "ro", "40"], ["Russia (Россия)", "ru", "7", 0], ["Rwanda", "rw", "250"], ["Saint Barthélemy", "bl", "590", 1], ["Saint Helena", "sh", "290"], ["Saint Kitts and Nevis", "kn", "1", 18, ["869"]], ["Saint Lucia", "lc", "1", 19, ["758"]], ["Saint Martin (Saint-Martin (partie française))", "mf", "590", 2], ["Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508"], ["Saint Vincent and the Grenadines", "vc", "1", 20, ["784"]], ["Samoa", "ws", "685"], ["San Marino", "sm", "378"], ["São Tomé and Príncipe (São Tomé e Príncipe)", "st", "239"], ["Saudi Arabia (‫المملكة العربية السعودية‬‎)", "sa", "966"], ["Senegal (Sénégal)", "sn", "221"], ["Serbia (Србија)", "rs", "381"], ["Seychelles", "sc", "248"], ["Sierra Leone", "sl", "232"], ["Singapore", "sg", "65"], ["Sint Maarten", "sx", "1", 21, ["721"]], ["Slovakia (Slovensko)", "sk", "421"], ["Slovenia (Slovenija)", "si", "386"], ["Solomon Islands", "sb", "677"], ["Somalia (Soomaaliya)", "so", "252"], ["South Africa", "za", "27"], ["South Korea (대한민국)", "kr", "82"], ["South Sudan (‫جنوب السودان‬‎)", "ss", "211"], ["Spain (España)", "es", "34"], ["Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94"], ["Sudan (‫السودان‬‎)", "sd", "249"], ["Suriname", "sr", "597"], ["Svalbard and Jan Mayen", "sj", "47", 1, ["79"]], ["Sweden (Sverige)", "se", "46"], ["Switzerland (Schweiz)", "ch", "41"], ["Syria (‫سوريا‬‎)", "sy", "963"], ["Taiwan (台灣)", "tw", "886"], ["Tajikistan", "tj", "992"], ["Tanzania", "tz", "255"], ["Thailand (ไทย)", "th", "66"], ["Timor-Leste", "tl", "670"], ["Togo", "tg", "228"], ["Tokelau", "tk", "690"], ["Tonga", "to", "676"], ["Trinidad and Tobago", "tt", "1", 22, ["868"]], ["Tunisia (‫تونس‬‎)", "tn", "216"], ["Turkey (Türkiye)", "tr", "90"], ["Turkmenistan", "tm", "993"], ["Turks and Caicos Islands", "tc", "1", 23, ["649"]], ["Tuvalu", "tv", "688"], ["U.S. Virgin Islands", "vi", "1", 24, ["340"]], ["Uganda", "ug", "256"], ["Ukraine (Україна)", "ua", "380"], ["United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "ae", "971"], ["United Kingdom", "gb", "44", 0], ["United States", "us", "1", 0], ["Uruguay", "uy", "598"], ["Uzbekistan (Oʻzbekiston)", "uz", "998"], ["Vanuatu", "vu", "678"], ["Vatican City (Città del Vaticano)", "va", "39", 1, ["06698"]], ["Venezuela", "ve", "58"], ["Vietnam (Việt Nam)", "vn", "84"], ["Wallis and Futuna (Wallis-et-Futuna)", "wf", "681"], ["Western Sahara (‫الصحراء الغربية‬‎)", "eh", "212", 1, ["5288", "5289"]], ["Yemen (‫اليمن‬‎)", "ye", "967"], ["Zambia", "zm", "260"], ["Zimbabwe", "zw", "263"], ["Åland Islands", "ax", "358", 1, ["18"]]], n = 0; n < r.length; n++) {
          var a = r[n];
          r[n] = {
            name: a[0],
            iso2: a[1],
            dialCode: a[2],
            priority: a[3] || 0,
            areaCodes: a[4] || null
          };
        }
        function o(h) {
          for (var d = 1; d < arguments.length; d++) {
            var s = arguments[d] != null ? Object(arguments[d]) : {}, u = Object.keys(s);
            typeof Object.getOwnPropertySymbols == "function" && u.push.apply(u, Object.getOwnPropertySymbols(s).filter(function(f) {
              return Object.getOwnPropertyDescriptor(s, f).enumerable;
            })), u.forEach(function(f) {
              c(h, f, s[f]);
            });
          }
          return h;
        }
        function c(h, d, s) {
          return d = A(d), d in h ? Object.defineProperty(h, d, {
            value: s,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : h[d] = s, h;
        }
        function p(h, d) {
          if (!(h instanceof d))
            throw new TypeError("Cannot call a class as a function");
        }
        function _(h, d) {
          for (var s = 0; s < d.length; s++) {
            var u = d[s];
            u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(h, A(u.key), u);
          }
        }
        function E(h, d, s) {
          return d && _(h.prototype, d), Object.defineProperty(h, "prototype", {
            writable: !1
          }), h;
        }
        function A(h) {
          var d = S(h, "string");
          return typeof d == "symbol" ? d : String(d);
        }
        function S(h, d) {
          if (typeof h != "object" || h === null) return h;
          var s = h[Symbol.toPrimitive];
          if (s !== e) {
            var u = s.call(h, d);
            if (typeof u != "object") return u;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(h);
        }
        var C = {
          getInstance: function(d) {
            var s = d.getAttribute("data-intl-tel-input-id");
            return window.intlTelInputGlobals.instances[s];
          },
          instances: {},
          // using a global like this allows us to mock it in the tests
          documentReady: function() {
            return document.readyState === "complete";
          }
        };
        typeof window == "object" && (window.intlTelInputGlobals = C);
        var x = 0, z = {
          // whether or not to allow the dropdown
          allowDropdown: !0,
          // auto insert dial code (A) on init, (B) on user selecting a country, (C) on calling setCountry
          // also listen for blur/submit and auto remove dial code if that's all there is
          autoInsertDialCode: !1,
          // add a placeholder in the input with an example number for the selected country
          autoPlaceholder: "polite",
          // modify the parentClass
          customContainer: "",
          // modify the auto placeholder
          customPlaceholder: null,
          // append menu to specified element
          dropdownContainer: null,
          // don't display these countries
          excludeCountries: [],
          // format the input value during initialisation and on setNumber
          formatOnDisplay: !0,
          // geoIp lookup function
          geoIpLookup: null,
          // inject a hidden input with this name, and on submit, populate it with the result of getNumber
          hiddenInput: "",
          // initial country
          initialCountry: "",
          // localized country names e.g. { 'de': 'Deutschland' }
          localizedCountries: null,
          // national vs international formatting for numbers e.g. placeholders and displaying existing numbers
          nationalMode: !0,
          // display only these countries
          onlyCountries: [],
          // number type to use for placeholders
          placeholderNumberType: "MOBILE",
          // the countries at the top of the list. defaults to united states and united kingdom
          preferredCountries: ["us", "gb"],
          // display the country dial code next to the selected flag
          separateDialCode: !1,
          // option to hide the flags - must be used with separateDialCode, or allowDropdown=false
          showFlags: !0,
          // specify the path to the libphonenumber script to enable validation/formatting
          utilsScript: ""
        }, L = ["800", "822", "833", "844", "855", "866", "877", "880", "881", "882", "883", "884", "885", "886", "887", "888", "889"], I = function(d, s) {
          for (var u = Object.keys(d), f = 0; f < u.length; f++)
            s(u[f], d[u[f]]);
        }, $ = function(d) {
          I(window.intlTelInputGlobals.instances, function(s) {
            window.intlTelInputGlobals.instances[s][d]();
          });
        }, D = /* @__PURE__ */ function() {
          function h(d, s) {
            var u = this;
            p(this, h), this.id = x++, this.telInput = d, this.activeItem = null, this.highlightedItem = null;
            var f = s || {};
            this.options = {}, I(z, function(v, y) {
              u.options[v] = f.hasOwnProperty(v) ? f[v] : y;
            }), this.hadInitialPlaceholder = !!d.getAttribute("placeholder");
          }
          return E(h, [{
            key: "_init",
            value: function() {
              var s = this;
              this.options.nationalMode && (this.options.autoInsertDialCode = !1), this.options.separateDialCode && (this.options.autoInsertDialCode = !1);
              var u = this.options.allowDropdown && !this.options.separateDialCode;
              if (!this.options.showFlags && u && (this.options.showFlags = !0), this.isMobile = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), this.isMobile && (document.body.classList.add("iti-mobile"), this.options.dropdownContainer || (this.options.dropdownContainer = document.body)), this.isRTL = !!this.telInput.closest("[dir=rtl]"), typeof Promise < "u") {
                var f = new Promise(function(y, w) {
                  s.resolveAutoCountryPromise = y, s.rejectAutoCountryPromise = w;
                }), v = new Promise(function(y, w) {
                  s.resolveUtilsScriptPromise = y, s.rejectUtilsScriptPromise = w;
                });
                this.promise = Promise.all([f, v]);
              } else
                this.resolveAutoCountryPromise = this.rejectAutoCountryPromise = function() {
                }, this.resolveUtilsScriptPromise = this.rejectUtilsScriptPromise = function() {
                };
              this.selectedCountryData = {}, this._processCountryData(), this._generateMarkup(), this._setInitialState(), this._initListeners(), this._initRequests();
            }
          }, {
            key: "_processCountryData",
            value: function() {
              this._processAllCountries(), this._processCountryCodes(), this._processPreferredCountries(), this.options.localizedCountries && this._translateCountriesByLocale(), (this.options.onlyCountries.length || this.options.localizedCountries) && this.countries.sort(this._countryNameSort);
            }
          }, {
            key: "_addCountryCode",
            value: function(s, u, f) {
              u.length > this.countryCodeMaxLen && (this.countryCodeMaxLen = u.length), this.countryCodes.hasOwnProperty(u) || (this.countryCodes[u] = []);
              for (var v = 0; v < this.countryCodes[u].length; v++)
                if (this.countryCodes[u][v] === s)
                  return;
              var y = f !== e ? f : this.countryCodes[u].length;
              this.countryCodes[u][y] = s;
            }
          }, {
            key: "_processAllCountries",
            value: function() {
              if (this.options.onlyCountries.length) {
                var s = this.options.onlyCountries.map(function(f) {
                  return f.toLowerCase();
                });
                this.countries = r.filter(function(f) {
                  return s.indexOf(f.iso2) > -1;
                });
              } else if (this.options.excludeCountries.length) {
                var u = this.options.excludeCountries.map(function(f) {
                  return f.toLowerCase();
                });
                this.countries = r.filter(function(f) {
                  return u.indexOf(f.iso2) === -1;
                });
              } else
                this.countries = r;
            }
          }, {
            key: "_translateCountriesByLocale",
            value: function() {
              for (var s = 0; s < this.countries.length; s++) {
                var u = this.countries[s].iso2.toLowerCase();
                this.options.localizedCountries.hasOwnProperty(u) && (this.countries[s].name = this.options.localizedCountries[u]);
              }
            }
          }, {
            key: "_countryNameSort",
            value: function(s, u) {
              return s.name < u.name ? -1 : s.name > u.name ? 1 : 0;
            }
          }, {
            key: "_processCountryCodes",
            value: function() {
              this.countryCodeMaxLen = 0, this.dialCodes = {}, this.countryCodes = {};
              for (var s = 0; s < this.countries.length; s++) {
                var u = this.countries[s];
                this.dialCodes[u.dialCode] || (this.dialCodes[u.dialCode] = !0), this._addCountryCode(u.iso2, u.dialCode, u.priority);
              }
              for (var f = 0; f < this.countries.length; f++) {
                var v = this.countries[f];
                if (v.areaCodes)
                  for (var y = this.countryCodes[v.dialCode][0], w = 0; w < v.areaCodes.length; w++) {
                    for (var O = v.areaCodes[w], U = 1; U < O.length; U++) {
                      var M = v.dialCode + O.substr(0, U);
                      this._addCountryCode(y, M), this._addCountryCode(v.iso2, M);
                    }
                    this._addCountryCode(v.iso2, v.dialCode + O);
                  }
              }
            }
          }, {
            key: "_processPreferredCountries",
            value: function() {
              this.preferredCountries = [];
              for (var s = 0; s < this.options.preferredCountries.length; s++) {
                var u = this.options.preferredCountries[s].toLowerCase(), f = this._getCountryData(u, !1, !0);
                f && this.preferredCountries.push(f);
              }
            }
          }, {
            key: "_createEl",
            value: function(s, u, f) {
              var v = document.createElement(s);
              return u && I(u, function(y, w) {
                return v.setAttribute(y, w);
              }), f && f.appendChild(v), v;
            }
          }, {
            key: "_generateMarkup",
            value: function() {
              !this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete")) && this.telInput.setAttribute("autocomplete", "off");
              var s = this.options, u = s.allowDropdown, f = s.separateDialCode, v = s.showFlags, y = s.customContainer, w = s.hiddenInput, O = s.dropdownContainer, U = "iti";
              u && (U += " iti--allow-dropdown"), f && (U += " iti--separate-dial-code"), v && (U += " iti--show-flags"), y && (U += " ".concat(y));
              var M = this._createEl("div", {
                class: U
              });
              this.telInput.parentNode.insertBefore(M, this.telInput);
              var H = u || v || f;
              if (H && (this.flagsContainer = this._createEl("div", {
                class: "iti__flag-container"
              }, M)), M.appendChild(this.telInput), H && (this.selectedFlag = this._createEl("div", o({
                class: "iti__selected-flag"
              }, u && {
                role: "combobox",
                "aria-haspopup": "listbox",
                "aria-controls": "iti-".concat(this.id, "__country-listbox"),
                "aria-expanded": "false",
                "aria-label": "Telephone country code"
              }), this.flagsContainer)), v && (this.selectedFlagInner = this._createEl("div", {
                class: "iti__flag"
              }, this.selectedFlag)), this.selectedFlag && this.telInput.disabled && this.selectedFlag.setAttribute("aria-disabled", "true"), f && (this.selectedDialCode = this._createEl("div", {
                class: "iti__selected-dial-code"
              }, this.selectedFlag)), u && (this.telInput.disabled || this.selectedFlag.setAttribute("tabindex", "0"), this.dropdownArrow = this._createEl("div", {
                class: "iti__arrow"
              }, this.selectedFlag), this.countryList = this._createEl("ul", {
                class: "iti__country-list iti__hide",
                id: "iti-".concat(this.id, "__country-listbox"),
                role: "listbox",
                "aria-label": "List of countries"
              }), this.preferredCountries.length && (this._appendListItems(this.preferredCountries, "iti__preferred", !0), this._createEl("li", {
                class: "iti__divider",
                role: "separator",
                "aria-disabled": "true"
              }, this.countryList)), this._appendListItems(this.countries, "iti__standard"), O ? (this.dropdown = this._createEl("div", {
                class: "iti iti--container"
              }), this.dropdown.appendChild(this.countryList)) : this.flagsContainer.appendChild(this.countryList)), w) {
                var K = w, Q = this.telInput.getAttribute("name");
                if (Q) {
                  var X = Q.lastIndexOf("[");
                  X !== -1 && (K = "".concat(Q.substr(0, X), "[").concat(K, "]"));
                }
                this.hiddenInput = this._createEl("input", {
                  type: "hidden",
                  name: K
                }), M.appendChild(this.hiddenInput);
              }
            }
          }, {
            key: "_appendListItems",
            value: function(s, u, f) {
              for (var v = "", y = 0; y < s.length; y++) {
                var w = s[y], O = f ? "-preferred" : "";
                v += "<li class='iti__country ".concat(u, "' tabIndex='-1' id='iti-").concat(this.id, "__item-").concat(w.iso2).concat(O, "' role='option' data-dial-code='").concat(w.dialCode, "' data-country-code='").concat(w.iso2, "' aria-selected='false'>"), this.options.showFlags && (v += "<div class='iti__flag-box'><div class='iti__flag iti__".concat(w.iso2, "'></div></div>")), v += "<span class='iti__country-name'>".concat(w.name, "</span>"), v += "<span class='iti__dial-code'>+".concat(w.dialCode, "</span>"), v += "</li>";
              }
              this.countryList.insertAdjacentHTML("beforeend", v);
            }
          }, {
            key: "_setInitialState",
            value: function() {
              var s = this.telInput.getAttribute("value"), u = this.telInput.value, f = s && s.charAt(0) === "+" && (!u || u.charAt(0) !== "+"), v = f ? s : u, y = this._getDialCode(v), w = this._isRegionlessNanp(v), O = this.options, U = O.initialCountry, M = O.autoInsertDialCode;
              y && !w ? this._updateFlagFromNumber(v) : U !== "auto" && (U ? this._setFlag(U.toLowerCase()) : y && w ? this._setFlag("us") : (this.defaultCountry = this.preferredCountries.length ? this.preferredCountries[0].iso2 : this.countries[0].iso2, v || this._setFlag(this.defaultCountry)), !v && M && (this.telInput.value = "+".concat(this.selectedCountryData.dialCode))), v && this._updateValFromNumber(v);
            }
          }, {
            key: "_initListeners",
            value: function() {
              this._initKeyListeners(), this.options.autoInsertDialCode && this._initBlurListeners(), this.options.allowDropdown && this._initDropdownListeners(), this.hiddenInput && this._initHiddenInputListener();
            }
          }, {
            key: "_initHiddenInputListener",
            value: function() {
              var s = this;
              this._handleHiddenInputSubmit = function() {
                s.hiddenInput.value = s.getNumber();
              }, this.telInput.form && this.telInput.form.addEventListener("submit", this._handleHiddenInputSubmit);
            }
          }, {
            key: "_getClosestLabel",
            value: function() {
              for (var s = this.telInput; s && s.tagName !== "LABEL"; )
                s = s.parentNode;
              return s;
            }
          }, {
            key: "_initDropdownListeners",
            value: function() {
              var s = this;
              this._handleLabelClick = function(f) {
                s.countryList.classList.contains("iti__hide") ? s.telInput.focus() : f.preventDefault();
              };
              var u = this._getClosestLabel();
              u && u.addEventListener("click", this._handleLabelClick), this._handleClickSelectedFlag = function() {
                s.countryList.classList.contains("iti__hide") && !s.telInput.disabled && !s.telInput.readOnly && s._showDropdown();
              }, this.selectedFlag.addEventListener("click", this._handleClickSelectedFlag), this._handleFlagsContainerKeydown = function(f) {
                var v = s.countryList.classList.contains("iti__hide");
                v && ["ArrowUp", "Up", "ArrowDown", "Down", " ", "Enter"].indexOf(f.key) !== -1 && (f.preventDefault(), f.stopPropagation(), s._showDropdown()), f.key === "Tab" && s._closeDropdown();
              }, this.flagsContainer.addEventListener("keydown", this._handleFlagsContainerKeydown);
            }
          }, {
            key: "_initRequests",
            value: function() {
              var s = this;
              this.options.utilsScript && !window.intlTelInputUtils ? window.intlTelInputGlobals.documentReady() ? window.intlTelInputGlobals.loadUtils(this.options.utilsScript) : window.addEventListener("load", function() {
                window.intlTelInputGlobals.loadUtils(s.options.utilsScript);
              }) : this.resolveUtilsScriptPromise(), this.options.initialCountry === "auto" ? this._loadAutoCountry() : this.resolveAutoCountryPromise();
            }
          }, {
            key: "_loadAutoCountry",
            value: function() {
              window.intlTelInputGlobals.autoCountry ? this.handleAutoCountry() : window.intlTelInputGlobals.startedLoadingAutoCountry || (window.intlTelInputGlobals.startedLoadingAutoCountry = !0, typeof this.options.geoIpLookup == "function" && this.options.geoIpLookup(function(s) {
                window.intlTelInputGlobals.autoCountry = s.toLowerCase(), setTimeout(function() {
                  return $("handleAutoCountry");
                });
              }, function() {
                return $("rejectAutoCountryPromise");
              }));
            }
          }, {
            key: "_initKeyListeners",
            value: function() {
              var s = this;
              this._handleKeyupEvent = function() {
                s._updateFlagFromNumber(s.telInput.value) && s._triggerCountryChange();
              }, this.telInput.addEventListener("keyup", this._handleKeyupEvent), this._handleClipboardEvent = function() {
                setTimeout(s._handleKeyupEvent);
              }, this.telInput.addEventListener("cut", this._handleClipboardEvent), this.telInput.addEventListener("paste", this._handleClipboardEvent);
            }
          }, {
            key: "_cap",
            value: function(s) {
              var u = this.telInput.getAttribute("maxlength");
              return u && s.length > u ? s.substr(0, u) : s;
            }
          }, {
            key: "_initBlurListeners",
            value: function() {
              var s = this;
              this._handleSubmitOrBlurEvent = function() {
                s._removeEmptyDialCode();
              }, this.telInput.form && this.telInput.form.addEventListener("submit", this._handleSubmitOrBlurEvent), this.telInput.addEventListener("blur", this._handleSubmitOrBlurEvent);
            }
          }, {
            key: "_removeEmptyDialCode",
            value: function() {
              if (this.telInput.value.charAt(0) === "+") {
                var s = this._getNumeric(this.telInput.value);
                (!s || this.selectedCountryData.dialCode === s) && (this.telInput.value = "");
              }
            }
          }, {
            key: "_getNumeric",
            value: function(s) {
              return s.replace(/\D/g, "");
            }
          }, {
            key: "_trigger",
            value: function(s) {
              var u = document.createEvent("Event");
              u.initEvent(s, !0, !0), this.telInput.dispatchEvent(u);
            }
          }, {
            key: "_showDropdown",
            value: function() {
              this.countryList.classList.remove("iti__hide"), this.selectedFlag.setAttribute("aria-expanded", "true"), this._setDropdownPosition(), this.activeItem && (this._highlightListItem(this.activeItem, !1), this._scrollTo(this.activeItem, !0)), this._bindDropdownListeners(), this.dropdownArrow.classList.add("iti__arrow--up"), this._trigger("open:countrydropdown");
            }
          }, {
            key: "_toggleClass",
            value: function(s, u, f) {
              f && !s.classList.contains(u) ? s.classList.add(u) : !f && s.classList.contains(u) && s.classList.remove(u);
            }
          }, {
            key: "_setDropdownPosition",
            value: function() {
              var s = this;
              if (this.options.dropdownContainer && this.options.dropdownContainer.appendChild(this.dropdown), !this.isMobile) {
                var u = this.telInput.getBoundingClientRect(), f = window.pageYOffset || document.documentElement.scrollTop, v = u.top + f, y = this.countryList.offsetHeight, w = v + this.telInput.offsetHeight + y < f + window.innerHeight, O = v - y > f;
                if (this._toggleClass(this.countryList, "iti__country-list--dropup", !w && O), this.options.dropdownContainer) {
                  var U = !w && O ? 0 : this.telInput.offsetHeight;
                  this.dropdown.style.top = "".concat(v + U, "px"), this.dropdown.style.left = "".concat(u.left + document.body.scrollLeft, "px"), this._handleWindowScroll = function() {
                    return s._closeDropdown();
                  }, window.addEventListener("scroll", this._handleWindowScroll);
                }
              }
            }
          }, {
            key: "_getClosestListItem",
            value: function(s) {
              for (var u = s; u && u !== this.countryList && !u.classList.contains("iti__country"); )
                u = u.parentNode;
              return u === this.countryList ? null : u;
            }
          }, {
            key: "_bindDropdownListeners",
            value: function() {
              var s = this;
              this._handleMouseoverCountryList = function(y) {
                var w = s._getClosestListItem(y.target);
                w && s._highlightListItem(w, !1);
              }, this.countryList.addEventListener("mouseover", this._handleMouseoverCountryList), this._handleClickCountryList = function(y) {
                var w = s._getClosestListItem(y.target);
                w && s._selectListItem(w);
              }, this.countryList.addEventListener("click", this._handleClickCountryList);
              var u = !0;
              this._handleClickOffToClose = function() {
                u || s._closeDropdown(), u = !1;
              }, document.documentElement.addEventListener("click", this._handleClickOffToClose);
              var f = "", v = null;
              this._handleKeydownOnDropdown = function(y) {
                y.preventDefault(), y.key === "ArrowUp" || y.key === "Up" || y.key === "ArrowDown" || y.key === "Down" ? s._handleUpDownKey(y.key) : y.key === "Enter" ? s._handleEnterKey() : y.key === "Escape" ? s._closeDropdown() : /^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(y.key) && (v && clearTimeout(v), f += y.key.toLowerCase(), s._searchForCountry(f), v = setTimeout(function() {
                  f = "";
                }, 1e3));
              }, document.addEventListener("keydown", this._handleKeydownOnDropdown);
            }
          }, {
            key: "_handleUpDownKey",
            value: function(s) {
              var u = s === "ArrowUp" || s === "Up" ? this.highlightedItem.previousElementSibling : this.highlightedItem.nextElementSibling;
              u && (u.classList.contains("iti__divider") && (u = s === "ArrowUp" || s === "Up" ? u.previousElementSibling : u.nextElementSibling), this._highlightListItem(u, !0));
            }
          }, {
            key: "_handleEnterKey",
            value: function() {
              this.highlightedItem && this._selectListItem(this.highlightedItem);
            }
          }, {
            key: "_searchForCountry",
            value: function(s) {
              for (var u = 0; u < this.countries.length; u++)
                if (this._startsWith(this.countries[u].name, s)) {
                  var f = this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(this.countries[u].iso2));
                  this._highlightListItem(f, !1), this._scrollTo(f, !0);
                  break;
                }
            }
          }, {
            key: "_startsWith",
            value: function(s, u) {
              return s.substr(0, u.length).toLowerCase() === u;
            }
          }, {
            key: "_updateValFromNumber",
            value: function(s) {
              var u = s;
              if (this.options.formatOnDisplay && window.intlTelInputUtils && this.selectedCountryData) {
                var f = this.options.nationalMode || u.charAt(0) !== "+" && !this.options.separateDialCode, v = intlTelInputUtils.numberFormat, y = v.NATIONAL, w = v.INTERNATIONAL, O = f ? y : w;
                u = intlTelInputUtils.formatNumber(u, this.selectedCountryData.iso2, O);
              }
              u = this._beforeSetNumber(u), this.telInput.value = u;
            }
          }, {
            key: "_updateFlagFromNumber",
            value: function(s) {
              var u = s, f = this.selectedCountryData.dialCode, v = f === "1";
              u && v && u.charAt(0) !== "+" && (u.charAt(0) !== "1" && (u = "1".concat(u)), u = "+".concat(u)), this.options.separateDialCode && f && u.charAt(0) !== "+" && (u = "+".concat(f).concat(u));
              var y = this._getDialCode(u, !0), w = this._getNumeric(u), O = null;
              if (y) {
                var U = this.countryCodes[this._getNumeric(y)], M = U.indexOf(this.selectedCountryData.iso2) !== -1 && w.length <= y.length - 1, H = f === "1" && this._isRegionlessNanp(w);
                if (!H && !M) {
                  for (var K = 0; K < U.length; K++)
                    if (U[K]) {
                      O = U[K];
                      break;
                    }
                }
              } else u.charAt(0) === "+" && w.length ? O = "" : (!u || u === "+") && (O = this.defaultCountry);
              return O !== null ? this._setFlag(O) : !1;
            }
          }, {
            key: "_isRegionlessNanp",
            value: function(s) {
              var u = this._getNumeric(s);
              if (u.charAt(0) === "1") {
                var f = u.substr(1, 3);
                return L.indexOf(f) !== -1;
              }
              return !1;
            }
          }, {
            key: "_highlightListItem",
            value: function(s, u) {
              var f = this.highlightedItem;
              f && f.classList.remove("iti__highlight"), this.highlightedItem = s, this.highlightedItem.classList.add("iti__highlight"), this.selectedFlag.setAttribute("aria-activedescendant", s.getAttribute("id")), u && this.highlightedItem.focus();
            }
          }, {
            key: "_getCountryData",
            value: function(s, u, f) {
              for (var v = u ? r : this.countries, y = 0; y < v.length; y++)
                if (v[y].iso2 === s)
                  return v[y];
              if (f)
                return null;
              throw new Error("No country data for '".concat(s, "'"));
            }
          }, {
            key: "_setFlag",
            value: function(s) {
              var u = this.options, f = u.allowDropdown, v = u.separateDialCode, y = u.showFlags, w = this.selectedCountryData.iso2 ? this.selectedCountryData : {};
              if (this.selectedCountryData = s ? this._getCountryData(s, !1, !1) : {}, this.selectedCountryData.iso2 && (this.defaultCountry = this.selectedCountryData.iso2), y && this.selectedFlagInner.setAttribute("class", "iti__flag iti__".concat(s)), this._setSelectedCountryFlagTitleAttribute(s, v), v) {
                var O = this.selectedCountryData.dialCode ? "+".concat(this.selectedCountryData.dialCode) : "";
                this.selectedDialCode.innerHTML = O;
                var U = this.selectedFlag.offsetWidth || this._getHiddenSelectedFlagWidth();
                this.isRTL ? this.telInput.style.paddingRight = "".concat(U + 6, "px") : this.telInput.style.paddingLeft = "".concat(U + 6, "px");
              }
              if (this._updatePlaceholder(), f) {
                var M = this.activeItem;
                if (M && (M.classList.remove("iti__active"), M.setAttribute("aria-selected", "false")), s) {
                  var H = this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(s, "-preferred")) || this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(s));
                  H.setAttribute("aria-selected", "true"), H.classList.add("iti__active"), this.activeItem = H;
                }
              }
              return w.iso2 !== s;
            }
          }, {
            key: "_setSelectedCountryFlagTitleAttribute",
            value: function(s, u) {
              if (this.selectedFlag) {
                var f;
                s && !u ? f = "".concat(this.selectedCountryData.name, ": +").concat(this.selectedCountryData.dialCode) : s ? f = this.selectedCountryData.name : f = "Unknown", this.selectedFlag.setAttribute("title", f);
              }
            }
          }, {
            key: "_getHiddenSelectedFlagWidth",
            value: function() {
              var s = this.telInput.parentNode.cloneNode();
              s.style.visibility = "hidden", document.body.appendChild(s);
              var u = this.flagsContainer.cloneNode();
              s.appendChild(u);
              var f = this.selectedFlag.cloneNode(!0);
              u.appendChild(f);
              var v = f.offsetWidth;
              return s.parentNode.removeChild(s), v;
            }
          }, {
            key: "_updatePlaceholder",
            value: function() {
              var s = this.options.autoPlaceholder === "aggressive" || !this.hadInitialPlaceholder && this.options.autoPlaceholder === "polite";
              if (window.intlTelInputUtils && s) {
                var u = intlTelInputUtils.numberType[this.options.placeholderNumberType], f = this.selectedCountryData.iso2 ? intlTelInputUtils.getExampleNumber(this.selectedCountryData.iso2, this.options.nationalMode, u) : "";
                f = this._beforeSetNumber(f), typeof this.options.customPlaceholder == "function" && (f = this.options.customPlaceholder(f, this.selectedCountryData)), this.telInput.setAttribute("placeholder", f);
              }
            }
          }, {
            key: "_selectListItem",
            value: function(s) {
              var u = this._setFlag(s.getAttribute("data-country-code"));
              this._closeDropdown(), this._updateDialCode(s.getAttribute("data-dial-code")), this.telInput.focus();
              var f = this.telInput.value.length;
              this.telInput.setSelectionRange(f, f), u && this._triggerCountryChange();
            }
          }, {
            key: "_closeDropdown",
            value: function() {
              this.countryList.classList.add("iti__hide"), this.selectedFlag.setAttribute("aria-expanded", "false"), this.selectedFlag.removeAttribute("aria-activedescendant"), this.dropdownArrow.classList.remove("iti__arrow--up"), document.removeEventListener("keydown", this._handleKeydownOnDropdown), document.documentElement.removeEventListener("click", this._handleClickOffToClose), this.countryList.removeEventListener("mouseover", this._handleMouseoverCountryList), this.countryList.removeEventListener("click", this._handleClickCountryList), this.options.dropdownContainer && (this.isMobile || window.removeEventListener("scroll", this._handleWindowScroll), this.dropdown.parentNode && this.dropdown.parentNode.removeChild(this.dropdown)), this._trigger("close:countrydropdown");
            }
          }, {
            key: "_scrollTo",
            value: function(s, u) {
              var f = this.countryList, v = window.pageYOffset || document.documentElement.scrollTop, y = f.offsetHeight, w = f.getBoundingClientRect().top + v, O = w + y, U = s.offsetHeight, M = s.getBoundingClientRect().top + v, H = M + U, K = M - w + f.scrollTop, Q = y / 2 - U / 2;
              if (M < w)
                u && (K -= Q), f.scrollTop = K;
              else if (H > O) {
                u && (K += Q);
                var X = y - U;
                f.scrollTop = K - X;
              }
            }
          }, {
            key: "_updateDialCode",
            value: function(s) {
              var u = this.telInput.value, f = "+".concat(s), v;
              if (u.charAt(0) === "+") {
                var y = this._getDialCode(u);
                y ? v = u.replace(y, f) : v = f, this.telInput.value = v;
              } else this.options.autoInsertDialCode && (u ? v = f + u : v = f, this.telInput.value = v);
            }
          }, {
            key: "_getDialCode",
            value: function(s, u) {
              var f = "";
              if (s.charAt(0) === "+")
                for (var v = "", y = 0; y < s.length; y++) {
                  var w = s.charAt(y);
                  if (!isNaN(parseInt(w, 10))) {
                    if (v += w, u)
                      this.countryCodes[v] && (f = s.substr(0, y + 1));
                    else if (this.dialCodes[v]) {
                      f = s.substr(0, y + 1);
                      break;
                    }
                    if (v.length === this.countryCodeMaxLen)
                      break;
                  }
                }
              return f;
            }
          }, {
            key: "_getFullNumber",
            value: function() {
              var s = this.telInput.value.trim(), u = this.selectedCountryData.dialCode, f, v = this._getNumeric(s);
              return this.options.separateDialCode && s.charAt(0) !== "+" && u && v ? f = "+".concat(u) : f = "", f + s;
            }
          }, {
            key: "_beforeSetNumber",
            value: function(s) {
              var u = s;
              if (this.options.separateDialCode) {
                var f = this._getDialCode(u);
                if (f) {
                  f = "+".concat(this.selectedCountryData.dialCode);
                  var v = u[f.length] === " " || u[f.length] === "-" ? f.length + 1 : f.length;
                  u = u.substr(v);
                }
              }
              return this._cap(u);
            }
          }, {
            key: "_triggerCountryChange",
            value: function() {
              this._trigger("countrychange");
            }
          }, {
            key: "handleAutoCountry",
            value: function() {
              this.options.initialCountry === "auto" && (this.defaultCountry = window.intlTelInputGlobals.autoCountry, this.telInput.value || this.setCountry(this.defaultCountry), this.resolveAutoCountryPromise());
            }
          }, {
            key: "handleUtils",
            value: function() {
              window.intlTelInputUtils && (this.telInput.value && this._updateValFromNumber(this.telInput.value), this._updatePlaceholder()), this.resolveUtilsScriptPromise();
            }
          }, {
            key: "destroy",
            value: function() {
              var s = this.telInput.form;
              if (this.options.allowDropdown) {
                this._closeDropdown(), this.selectedFlag.removeEventListener("click", this._handleClickSelectedFlag), this.flagsContainer.removeEventListener("keydown", this._handleFlagsContainerKeydown);
                var u = this._getClosestLabel();
                u && u.removeEventListener("click", this._handleLabelClick);
              }
              this.hiddenInput && s && s.removeEventListener("submit", this._handleHiddenInputSubmit), this.options.autoInsertDialCode && (s && s.removeEventListener("submit", this._handleSubmitOrBlurEvent), this.telInput.removeEventListener("blur", this._handleSubmitOrBlurEvent)), this.telInput.removeEventListener("keyup", this._handleKeyupEvent), this.telInput.removeEventListener("cut", this._handleClipboardEvent), this.telInput.removeEventListener("paste", this._handleClipboardEvent), this.telInput.removeAttribute("data-intl-tel-input-id");
              var f = this.telInput.parentNode;
              f.parentNode.insertBefore(this.telInput, f), f.parentNode.removeChild(f), delete window.intlTelInputGlobals.instances[this.id];
            }
          }, {
            key: "getExtension",
            value: function() {
              return window.intlTelInputUtils ? intlTelInputUtils.getExtension(this._getFullNumber(), this.selectedCountryData.iso2) : "";
            }
          }, {
            key: "getNumber",
            value: function(s) {
              if (window.intlTelInputUtils) {
                var u = this.selectedCountryData.iso2;
                return intlTelInputUtils.formatNumber(this._getFullNumber(), u, s);
              }
              return "";
            }
          }, {
            key: "getNumberType",
            value: function() {
              return window.intlTelInputUtils ? intlTelInputUtils.getNumberType(this._getFullNumber(), this.selectedCountryData.iso2) : -99;
            }
          }, {
            key: "getSelectedCountryData",
            value: function() {
              return this.selectedCountryData;
            }
          }, {
            key: "getValidationError",
            value: function() {
              if (window.intlTelInputUtils) {
                var s = this.selectedCountryData.iso2;
                return intlTelInputUtils.getValidationError(this._getFullNumber(), s);
              }
              return -99;
            }
          }, {
            key: "isValidNumber",
            value: function() {
              var s = this._getFullNumber().trim();
              return window.intlTelInputUtils ? intlTelInputUtils.isValidNumber(s, this.selectedCountryData.iso2) : null;
            }
          }, {
            key: "isPossibleNumber",
            value: function() {
              var s = this._getFullNumber().trim();
              return window.intlTelInputUtils ? intlTelInputUtils.isPossibleNumber(s, this.selectedCountryData.iso2) : null;
            }
          }, {
            key: "setCountry",
            value: function(s) {
              var u = s.toLowerCase();
              this.selectedCountryData.iso2 !== u && (this._setFlag(u), this._updateDialCode(this.selectedCountryData.dialCode), this._triggerCountryChange());
            }
          }, {
            key: "setNumber",
            value: function(s) {
              var u = this._updateFlagFromNumber(s);
              this._updateValFromNumber(s), u && this._triggerCountryChange();
            }
          }, {
            key: "setPlaceholderNumberType",
            value: function(s) {
              this.options.placeholderNumberType = s, this._updatePlaceholder();
            }
          }]), h;
        }();
        C.getCountryData = function() {
          return r;
        };
        var m = function(d, s, u) {
          var f = document.createElement("script");
          f.onload = function() {
            $("handleUtils"), s && s();
          }, f.onerror = function() {
            $("rejectUtilsScriptPromise"), u && u();
          }, f.className = "iti-load-utils", f.async = !0, f.src = d, document.body.appendChild(f);
        };
        return C.loadUtils = function(h) {
          if (!window.intlTelInputUtils && !window.intlTelInputGlobals.startedLoadingUtilsScript) {
            if (window.intlTelInputGlobals.startedLoadingUtilsScript = !0, typeof Promise < "u")
              return new Promise(function(d, s) {
                return m(h, d, s);
              });
            m(h);
          }
          return null;
        }, C.defaults = z, C.version = "18.2.1", function(h, d) {
          var s = new D(h, d);
          return s._init(), h.setAttribute("data-intl-tel-input-id", s.id), window.intlTelInputGlobals.instances[s.id] = s, s;
        };
      }();
    });
  }(intlTelInput$2)), intlTelInput$2.exports;
}
var intlTelInput$1, hasRequiredIntlTelInput;
function requireIntlTelInput() {
  return hasRequiredIntlTelInput || (hasRequiredIntlTelInput = 1, intlTelInput$1 = requireIntlTelInput$1()), intlTelInput$1;
}
var intlTelInputExports = requireIntlTelInput();
const intlTelInput = /* @__PURE__ */ getDefaultExportFromCjs(intlTelInputExports);
/*! js-cookie v3.0.1 | MIT */
function assign(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      t[n] = r[n];
  }
  return t;
}
var defaultConverter = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function init(t, e) {
  function r(a, o, c) {
    if (!(typeof document > "u")) {
      c = assign({}, e, c), typeof c.expires == "number" && (c.expires = new Date(Date.now() + c.expires * 864e5)), c.expires && (c.expires = c.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var p = "";
      for (var _ in c)
        c[_] && (p += "; " + _, c[_] !== !0 && (p += "=" + c[_].split(";")[0]));
      return document.cookie = a + "=" + t.write(o, a) + p;
    }
  }
  function n(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], c = {}, p = 0; p < o.length; p++) {
        var _ = o[p].split("="), E = _.slice(1).join("=");
        try {
          var A = decodeURIComponent(_[0]);
          if (c[A] = t.read(E, A), a === A)
            break;
        } catch {
        }
      }
      return a ? c[a] : c;
    }
  }
  return Object.create(
    {
      set: r,
      get: n,
      remove: function(a, o) {
        r(
          a,
          "",
          assign({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return init(this.converter, assign({}, this.attributes, a));
      },
      withConverter: function(a) {
        return init(assign({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(t) }
    }
  );
}
var api = init(defaultConverter, { path: "/" });
function updateOrSetQueryStringParam(t, e, r) {
  if (typeof r > "u") return t;
  var n = new RegExp("([?&])" + e + "=.*?(&|$)", "i"), a = t.indexOf("?") !== -1 ? "&" : "?";
  return t.match(n) ? t.replace(n, "$1" + e + "=" + r + "$2") : t + a + e + "=" + r;
}
function getUrlVars(t) {
  var e = [], r = t.split("?")[1];
  if (!r) return e;
  for (var n = r.split("&"), a = 0; a < n.length; a++) {
    var o = n[a].split("=");
    e.push({ key: o[0], value: o[1] });
  }
  return e;
}
const widgetId = () => window.AXLData?.widgetId, inIframe = () => {
  try {
    return window.self !== window.top;
  } catch {
    return !0;
  }
}, isInsideWidget = (t) => (t || (t = widgetId()), t && inIframe()), buildProperHref = (t) => t.startsWith("/") ? document.location.protocol + "//" + document.location.host + t : t, emulateClick = (t, e) => {
  if (t != "") {
    if (isInsideWidget()) {
      window.parent.postMessage({
        type: "emulateClick",
        href: buildProperHref(t),
        target: e,
        from: widgetId()
      }, "*");
      return;
    }
    var r = document.createElement("a");
    document.body.appendChild(r), r.href = t, e && (r.target = e), setTimeout(() => {
      r.click(), r.remove();
    }, 10);
  }
}, injectScript = (t, e = "head", r = !1) => new Promise((n, a) => {
  try {
    const c = e == "head" ? document.getElementsByTagName("head")[0] : document.body;
    var o = document.createElement("script");
    o.type = "text/javascript", o.src = t, o.async = r, o.onerror = (p) => a(p), o.onload = () => n(), c.appendChild(o);
  } catch (c) {
    a(c);
  }
}), makeIframesLazy = () => {
  const t = document.querySelectorAll("iframe");
  if ("IntersectionObserver" in window) {
    const e = new IntersectionObserver((r, n) => {
      r.forEach((a) => {
        if (a.isIntersecting) {
          const o = a.target;
          o.src = o.dataset.src || "", n.unobserve(o);
        }
      });
    }, {
      rootMargin: "100% 0px 0px 0px",
      threshold: 0
    });
    t.forEach((r) => {
      r.dataset.src || (r.dataset.src = r.src, r.src = ""), e.observe(r);
    });
  } else
    t.forEach((e) => {
      const r = e;
      r.src = r.dataset.src || "";
    });
}, injectStyle = (t) => new Promise((e, r) => {
  try {
    const a = document.getElementsByTagName("head")[0];
    var n = document.createElement("link");
    n.rel = "stylesheet", n.type = "text/css", n.href = t, n.media = "all", n.onerror = (o) => r(o), n.onload = () => e(), a.appendChild(n);
  } catch (a) {
    r(a);
  }
}), replaceAXLVariables = (t, e, r) => {
  if (!r || r.length == 0) return t;
  var n = AXLReplaceTagsRegex.find((a) => a.type == e);
  return n ? (r = r.replace(/[+]/g, "%2B"), t.replace(n.regex, r)) : t;
};
var AXLReplaceTags = /* @__PURE__ */ ((t) => (t[t.Id = 0] = "Id", t[t.FirstName = 1] = "FirstName", t[t.LastName = 2] = "LastName", t[t.Email = 3] = "Email", t[t.Phone = 4] = "Phone", t))(AXLReplaceTags || {});
const AXLReplaceTagsRegex = [
  {
    type: 0,
    regex: new RegExp("[#{]ID[}#]", "g")
  },
  {
    type: 1,
    regex: new RegExp("[#{]FirstName[}#]", "g")
  },
  {
    type: 2,
    regex: new RegExp("[#{]LastName[}#]", "g")
  },
  {
    type: 3,
    regex: new RegExp("[#{]Email[}#]", "g")
  },
  {
    type: 4,
    regex: new RegExp("[#{]Phone[}#]", "g")
  }
];
var AXLWebsiteEventEnum = /* @__PURE__ */ ((t) => (t.CheckoutSuccess = "CheckoutSuccess", t.CheckoutError = "CheckoutFail", t.CheckoutInit = "CheckoutInit", t.CheckoutStarted = "CheckoutStarted", t.FormSubmit = "FormSubmit", t))(AXLWebsiteEventEnum || {});
let phoneUtilsPromise;
const phoneUtilsStart = () => (phoneUtilsPromise || (phoneUtilsPromise = import("./utils-DVWO0ATS.mjs").catch(() => {
})), phoneUtilsPromise), phoneUtilsWait = () => phoneUtilsPromise ? Promise.race([phoneUtilsPromise, new Promise((t) => setTimeout(t, 1500))]) : Promise.resolve(), phoneUtilsAvailable = () => typeof window.intlTelInputUtils < "u";
function ezInitForms(t, e) {
  const r = document.querySelectorAll(".ez-form form, form.ez-form");
  if (!(!r || r.length == 0))
    for (var n = 0; n < r.length; n++) new EZForm(r[n], t, e);
}
const CountryCookieName = "ez-country";
class EZForm {
  constructor(e, r, n) {
    this.form = e, this.formParams = r, this.isAuthorized = n, this.isSubmitting = !1, this.currentCountry = api.get(CountryCookieName) || "us", this.loader = null, this.anyFieldHiddenDueToAuth = !1, this.fieldChangeHandler = (o) => {
      var c = o.currentTarget;
      if (c.touched) {
        var p = this.fieldIsValid(c);
        if (p.available === !1) {
          this.fieldHideError(c), this.fieldKeyUpHandler(o);
          return;
        }
        if (p.isValid)
          this.fieldHideError(c);
        else {
          this.fieldShowError(p);
          return;
        }
        this.fieldKeyUpHandler(o);
      }
    }, this.fieldKeyUpHandler = (o) => {
      var c = o.currentTarget;
      c.nodeName.toUpperCase() != "TEXTAREA" && o instanceof KeyboardEvent && o.key == "Enter" && this.submit();
    }, this.fieldAddEnterKeyListener = (o) => {
      o.nodeName.toUpperCase() != "TEXTAREA" && o.addEventListener("keyup", (c) => {
        c.key == "Enter" && this.submit();
      });
    }, this.phoneResult = (o) => {
      var c = o.intlTelInput, p = (o.value || "").toString().trim();
      if (!p) return { isValid: !0, available: !0, value: "" };
      if (!c || !phoneUtilsAvailable()) {
        var _ = p.charAt(0) == "+", E = p.replace(/\D/g, "").slice(0, 15), A = _ && E.length ? "+" + E : E;
        return { isValid: E.length > 0, available: !1, value: A };
      }
      var S = c.isValidNumber() === !0;
      return { isValid: S, available: !0, value: S ? c.getNumber() : "" };
    }, this.fieldIsValid = (o) => {
      o.classList.remove("invalid");
      var c = { dom: o, name: o.name, isValid: !0, message: "" };
      if (o.required && o.value.length == 0) return { ...c, isValid: !1, message: this.localize.words.required };
      if (o.required && o.getAttribute("type") == "checkbox" && !o.checked)
        return { ...c, isValid: !1, message: this.localize.words.required };
      var p = o.getAttribute("validation");
      if (!p || o.type == "hidden" || !o.required && o.value.length == 0) return c;
      switch (p) {
        case "email":
          return o.value = o.value?.trim(), {
            ...c,
            isValid: isEmail(o.value),
            message: this.localize.words.invalidEmail
          };
        case "phone":
          var _ = this.phoneResult(o);
          return {
            ...c,
            isValid: _.isValid,
            available: _.available,
            message: this.localize.words.invalidPhone
          };
        case "number":
          return {
            ...c,
            isValid: isNumeric(o.value) || isFloat(o.value),
            message: this.localize.words.invalidNumber
          };
        case "url":
          return {
            ...c,
            isValid: isURL(o.value),
            message: this.localize.words.invalidUrl
          };
      }
    }, this.fieldShowError = (o) => {
      if (o.dom.getAttribute("type") == "checkbox" ? o.dom.parentElement?.classList.add("invalid") : o.dom.classList.add("invalid"), o.message) {
        var c = o.dom.closest(".form-control");
        if (c) {
          o.dom.errorField && o.dom.errorField.remove();
          var p = document.createElement("div");
          p.classList.add("field-error"), p.innerText = o.message || "", c.appendChild(p), o.dom.errorField = p;
        }
      }
    }, this.fieldHideError = (o) => {
      var c = o.closest(".form-control");
      c?.querySelectorAll(".field-error").forEach((p) => p.remove());
    }, this.sendFormCallBack = async ({ status: o, data: c }) => {
      if (this.formResponse = c, this.setIsSubmitting(!1), o != 200) {
        var p;
        !c.message && c.errors && c.errors.length > 0 ? p = c.errors.map((E) => E.message).join(`
`) : c.message && (p = c.message), this.showError(p, 3);
        return;
      }
      typeof window.fbq < "u" && window.fbq("track", "Lead"), typeof window._axlOnSuccessFormSubmit == "function" && window._axlOnSuccessFormSubmit(this.formData);
      var _ = window.AXLWebsite;
      _ && _.dispatch("FormSubmit", this.formData), this.showMessage(this.formMessageToShow), await this.execJS(), this.execRedirect(), this.submitButton && typeof this.submitButton._onSuccessFormSubmit == "function" && this.submitButton._onSuccessFormSubmit(this.submitButton);
    }, this.initSubmit(), this.initFields(), this.hideFieldsIfAuthorized(), this.initButtonSubmit();
    var a = window.AXLData?.formSettings?.loc;
    this.localize = new FormLocalization(a);
  }
  get fields() {
    return Array.from(this.form.elements);
  }
  get submitButton() {
    return this.form.querySelector("[type='submit']");
  }
  initSubmit() {
    this.form.addEventListener("submit", (e) => {
      e.preventDefault(), this.submit();
    });
  }
  initButtonSubmit() {
    this.submitButton?.addEventListener("click", (e) => {
      e.preventDefault(), this.submit();
    });
  }
  initFields() {
    this.fields.forEach((e) => {
      var r = e.getAttribute("validation");
      if (r == "phone") {
        var n = e.getAttribute("default-country-code");
        e.value = n ? `+${n}` : "", this.initPhoneField(e, n == null);
      }
      if (e.type.toLowerCase() == "checkbox") {
        var a = e.getAttribute("default-checked");
        a && (e.checked = !0);
      }
      e.addEventListener("blur", (o) => {
        e.touched = !0, this.fieldChangeHandler(o);
      }), e.addEventListener("keyup", this.fieldChangeHandler.bind(this)), e.addEventListener("change", this.fieldChangeHandler.bind(this));
    });
  }
  hideFieldsIfAuthorized() {
    typeof this.isAuthorized == "function" && this.isAuthorized() && this.fields.forEach((e) => {
      var r = e.closest(".form-control");
      if (r) {
        var n = r.getAttribute("hide-if-auth") == "true";
        n && (r.remove(), this.anyFieldHiddenDueToAuth = !0);
      }
    });
  }
  attachPhoneMask(e) {
    var r = () => {
      if (!phoneUtilsAvailable()) {
        var n = e.value || "";
        if (n) {
          var a = n.charAt(0) == "+", o = n.replace(/\D/g, "").slice(0, 15), c = a ? o.length ? "+" + o : "+" : o;
          if (c != n) {
            var p = e.selectionStart == null ? n.length : e.selectionStart, _ = n.slice(0, p).replace(/\D/g, "");
            a && p > 0 && (_ = "+" + _), e.value = c;
            var E = Math.min(_.length, c.length);
            try {
              e.setSelectionRange(E, E);
            } catch {
            }
          }
        }
      }
    };
    e.addEventListener("input", r);
  }
  initPhoneField(e, r = !1) {
    phoneUtilsStart(), this.attachPhoneMask(e);
    var n = {
      autoPlaceholder: "polite",
      nationalMode: !0,
      dropdownContainer: document.getElementsByClassName("ez-wrapper")[0] || document.body
    };
    r && (n.initialCountry = "auto"), e.intlTelInput = intlTelInput(e, n), window.its = e.intlTelInput, r && this.getCountryName().then((a) => {
      this.currentCountry = a, e.intlTelInput.setCountry(a);
    });
  }
  async getCountryName() {
    try {
      var e = api.get(CountryCookieName);
      if (e)
        return e.toLowerCase();
      var r = await fetch("https://ipinfo.io", {
        headers: { Accept: "application/json" }
      }), n = await r.json(), a = n && n.country ? n.country : "us";
      return api.set(CountryCookieName, a.toLowerCase(), { expires: 7 }), a.toLowerCase();
    } catch {
      return "us";
    }
  }
  get accelPixel() {
    var e = window.ao;
    return e || null;
  }
  get formMessageToShow() {
    const e = this.form.getAttribute("form-message");
    return e && e.length > 0 ? e : "";
  }
  showMessage(e) {
    var r = document.createElement("div");
    r.className = "ez-form-message", this.form.appendChild(r), r.innerText = e || "Thank you!";
  }
  showError(e, r) {
    var n = document.createElement("div");
    n.className = "form-error", this.form?.appendChild(n), n.innerText = e, setTimeout(() => {
      n.remove();
    }, (r || 3) * 1e3);
  }
  addVariablesToString(e) {
    const r = (_) => _.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    for (var n of this.formData.fields) {
      var a = n.value ?? "";
      if (typeof a == "string" && (a = a.replace(/[+]/g, "%2B")), typeof a == "boolean") {
        if (!n.key) continue;
        e = e.replace(new RegExp(`(#|{)(${r(n.key)})(#|})`, "g"), a ? "true" : "false");
      } else {
        var o = n.key ? r(n.key) : "", c = n.name ? r(n.name) : "", p = o && c ? `${o}|${c}` : o || c;
        if (!p) continue;
        e = e.replace(new RegExp(`(#|{)(${p})(#|})`, "g"), a);
      }
    }
    return this.formResponse?.body?.contactId && (e = replaceAXLVariables(e, AXLReplaceTags.Id, this.formResponse.body.contactId)), e;
  }
  async execJS() {
    var e = this.form.getAttribute("form-js");
    if (e)
      try {
        var r = new Function(e);
        await r();
      } catch (n) {
        console.error("Error in form JS function", n);
      }
  }
  execRedirect() {
    let e = this.form.getAttribute("form-redirect");
    if (!e || e.length == 0) return;
    if (e = this.addVariablesToString(e), this.form.getAttribute("form-redirect-add-url-params"))
      for (var n of getUrlVars(document.location.href))
        e = updateOrSetQueryStringParam(e, n.key, n.value);
    if (this.formParams && this.formParams.contactQueryCookieName && this.formResponse?.body?.contactId && (e = updateOrSetQueryStringParam(e, this.formParams.contactQueryCookieName, this.formResponse.body.contactId)), isInsideWidget()) {
      emulateClick(e, null);
      return;
    }
    document.location.href = e;
  }
  async submit() {
    if (!this.isSubmitting) {
      this.setIsSubmitting(!0), await phoneUtilsWait(), this.fields.forEach((_) => this.fieldHideError(_));
      var e = [];
      for (var r of this.fields)
        e.push(this.fieldIsValid(r));
      var n = e.filter((_) => _.isValid !== !0);
      if (n.length > 0) {
        n.forEach((_) => this.fieldShowError(_)), this.setIsSubmitting(!1), n[0].dom.parentElement?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        return;
      }
      var a = {
        name: this.form.getAttribute("form-name"),
        fields: []
      };
      for (var r of this.fields) {
        let E = r.getAttribute("type") == "checkbox" ? r.checked : r.value;
        r.intlTelInput && (E = this.phoneResult(r).value), a.fields.push({
          key: r.getAttribute("name"),
          name: r.getAttribute("label"),
          value: E
        });
      }
      if (this.anyFieldHiddenDueToAuth && a.fields.push({
        key: "isAuthorized",
        name: "isAuthorized",
        value: "true"
      }), this.formData = a, this.accelPixel)
        this.accelPixel.track("form", this.formData, this.sendFormCallBack);
      else if (this.formParams?.onSubmit)
        try {
          var { status: o, data: c } = await this.formParams?.onSubmit(this.formData);
          await this.sendFormCallBack({ status: o, data: c });
        } catch {
          this.showError("Error submitting form. Please try again later.");
        }
      else if (this.formParams?.submitUrl)
        try {
          var p = await fetch(this.formParams.submitUrl, {
            method: "POST",
            headers: { Accept: "application/json" },
            body: JSON.stringify(this.formData)
          }), c = await p.json();
          await this.sendFormCallBack({ status: p.status, data: c });
        } catch {
          this.showError("Error submitting form. Please try again later.");
        }
      else {
        if (!this.accelPixel) {
          console.warn("Can't find Accel Pixel. This is sad. Configure your Accel Pixel to send forms"), this.setIsSubmitting(!1);
          return;
        }
        if (!this.accelPixel.track) {
          console.warn("Track form is not configured."), this.setIsSubmitting(!1);
          return;
        }
      }
    }
  }
  setIsSubmitting(e) {
    e ? (this.submitButton?.setAttribute("disabled", "disabled"), this.isSubmitting = !0, this.createLoader()) : (this.submitButton?.removeAttribute("disabled"), this.isSubmitting = !1, this.destroyLoader());
  }
  createLoader() {
    this.loader = document.createElement("div"), this.loader.className = "spin-loader-wrapper";
    var e = document.createElement("div");
    e.className = "spin-loader", this.loader.appendChild(e), this.form.appendChild(this.loader);
  }
  destroyLoader() {
    this.loader && (this.loader.remove(), this.loader = null);
  }
}
class FormLocalization {
  constructor(e) {
    if (this.words = new FormLocalizationWordsEn(), e)
      this.words = e;
    else {
      var r = Intl.NumberFormat()?.resolvedOptions()?.locale;
      switch (r || (r = navigator.language || "us"), r.indexOf("-") > -1 && (r = r.split("-")[0]), r) {
        case "en":
          this.words = new FormLocalizationWordsEn();
          break;
        case "ru":
          this.words = new FormLocalizationWordsRu();
          break;
      }
    }
  }
}
class FormLocalizationWordsEn {
  constructor() {
    this.invalidEmail = "Enter valid email", this.invalidPhone = "Enter international phone number", this.invalidNumber = "Enter valid number", this.invalidUrl = "Enter valid URL", this.required = "This field is required";
  }
}
class FormLocalizationWordsRu {
  constructor() {
    this.invalidEmail = "Введите корректный email", this.invalidPhone = "Введите телефон в международном формате", this.invalidNumber = "Введите корректное число", this.invalidUrl = "Введите корректный URL", this.required = "Обязательно для заполнения";
  }
}
const zoomImage = (t, e) => {
  var r = document.body.style.overflow, n = document.createElement("div");
  n.classList.add("ez-zoom-image-holder");
  const a = () => {
    n.classList.add("hide"), setTimeout(() => {
      n.remove(), document.body.style.overflow = r;
    }, 300);
  };
  var o = document.createElement("div");
  o.classList.add("backdrop"), o.addEventListener("click", a), n.append(o);
  var c = document.createElement("img");
  c.src = t, c.addEventListener("click", a), n.append(c), e.append(n), document.body.style.overflow = "hidden", c.height < window.innerHeight && c.classList.add("center");
}, PLAYER_URL_REGEX = /src\s*=\s*\\?["'][^"'\\]*?\/v\/([a-zA-Z0-9_-]+)[\\"'?&#]/gi, getPlayerVideoIds = (t) => {
  if (!t)
    return [];
  const e = [];
  let r;
  for (PLAYER_URL_REGEX.lastIndex = 0; (r = PLAYER_URL_REGEX.exec(t)) != null; )
    e.indexOf(r[1]) == -1 && e.push(r[1]);
  return e;
}, parseVideoMomentSettings = (t) => {
  if (!t)
    return {};
  if (t.charAt(0) != "{")
    return { time: t };
  try {
    const e = JSON.parse(t);
    return { time: e.time, target: e.target ?? e.videoId };
  } catch {
    return {};
  }
}, toVideoMomentSettings = (t) => JSON.stringify(t), SRC_REGEX = /src\s*=\s*\\?["']([^"'\\]+)/i, PLAYER_PATH_REGEX$1 = /\/v\/[a-zA-Z0-9_-]+/, DEFAULT_EMBED_WIDTH = 560, DEFAULT_EMBED_HEIGHT = 315, isOurPlayerEmbed = (t) => {
  const e = getEmbedSrc(t);
  return e != null && PLAYER_PATH_REGEX$1.test(e);
}, getPlayerParam = (t, e) => {
  const r = getEmbedSrc(t);
  if (r == null)
    return null;
  const n = r.split("?")[1];
  if (!n)
    return null;
  const a = n.split(/&amp;|&/).map((o) => o.split("=")).filter((o) => decode(o[0]) == e)[0];
  return a && a.length > 1 ? decode(a[1]) : null;
}, setPlayerParam = (t, e, r) => {
  const n = getEmbedSrc(t);
  if (t == null || n == null)
    return t || "";
  const [a, o] = n.split("?"), c = (o || "").indexOf("&amp;") > -1 ? "&amp;" : "&", p = (o || "").split(/&amp;|&/).filter((E) => E.length > 0 && decode(E.split("=")[0]) != e);
  r != null && p.push(`${e}=${encodeURIComponent(r)}`);
  const _ = p.length > 0 ? `${a}?${p.join(c)}` : a;
  return t.replace(n, _);
}, buildPlayerEmbedCode = (t, e) => {
  const r = `${t}/v/${e}?showTitle=true&showControls=true`;
  return `<iframe width="${DEFAULT_EMBED_WIDTH}" height="${DEFAULT_EMBED_HEIGHT}" src="${r}" frameBorder=0 allow="accelerometer; fullscreen; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>`;
}, decode = (t) => {
  try {
    return decodeURIComponent(t);
  } catch {
    return t;
  }
}, getEmbedSrc = (t) => {
  if (!t)
    return null;
  const e = t.match(SRC_REGEX);
  return e ? e[1] : null;
}, SECONDS_IN_MINUTE = 60, MINUTES_IN_HOUR = 60, toTimecodeParts = (t) => {
  const e = parseTimecode(t) ?? 0;
  return {
    hours: Math.floor(e / (SECONDS_IN_MINUTE * MINUTES_IN_HOUR)),
    minutes: Math.floor(e / SECONDS_IN_MINUTE) % MINUTES_IN_HOUR,
    seconds: e % SECONDS_IN_MINUTE
  };
}, fromTimecodeParts = (t) => {
  const e = Math.max(0, Math.floor(t.hours || 0)), r = Math.max(0, Math.floor(t.minutes || 0)), n = Math.max(0, Math.floor(t.seconds || 0)), a = (o) => o < 10 ? `0${o}` : `${o}`;
  return e > 0 ? `${e}:${a(r)}:${a(n)}` : `${r}:${a(n)}`;
}, TIMECODE_PART_REGEX = /^\d{1,3}$/, MAX_TIMECODE_PARTS = 3, parseTimecode = (t) => {
  if (t == null || t === "")
    return null;
  if (typeof t == "number")
    return t >= 0 ? Math.floor(t) : null;
  let e = t;
  try {
    e = decodeURIComponent(t);
  } catch {
  }
  const r = e.trim().split(":");
  if (r.length > MAX_TIMECODE_PARTS)
    return null;
  let n = 0;
  for (const a of r) {
    const o = a.trim();
    if (!TIMECODE_PART_REGEX.test(o))
      return null;
    n = n * SECONDS_IN_MINUTE + parseInt(o, 10);
  }
  return n;
}, formatTimecode = (t) => fromTimecodeParts(toTimecodeParts(t)), TIMECODE_HREF_REGEX = /^#t=([^&]+)(?:&(?:v|b)=([\w-]+))?$/i, PLAYER_PATH_REGEX = /^\/v\/[\w-]+$/, TIMECODE_COPY_CLASS = "ez-timecode-copy", TIMECODE_COPIED_CLASS = "ez-timecode-copied", TIMECODE_COPIED_LIFETIME_MS = 2e3, TIMECODE_COPY_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>';
let videoWords = {
  copyTimecodeLink: "Copy the link to this moment",
  timecodeLinkCopied: "Link copied"
}, timecodeLinksStarted = !1, openedTimecode = null;
const parseTimecodeHref = (t) => {
  if (!t)
    return null;
  const e = TIMECODE_HREF_REGEX.exec(t.trim());
  if (!e)
    return null;
  const r = parseTimecode(e[1]);
  return r == null ? null : { seconds: r, target: e[2] };
}, playingIframes = [];
let videoTrackingStarted = !1;
const onPlayerMessage = (t) => {
  const e = (r) => {
    const n = r.data;
    if (!n || n.source != "AccelPlayer")
      return;
    const a = getPlayerIframeOf(r);
    a != null && t(n, a, r);
  };
  return window.addEventListener("message", e), () => window.removeEventListener("message", e);
}, getPlayerIframeOf = (t) => {
  const e = t.source;
  return e == null ? null : getPlayerIframes().filter((r) => r.contentWindow == e)[0] || null;
}, initVideoTracking = () => {
  videoTrackingStarted || (videoTrackingStarted = !0, onPlayerMessage((t, e) => {
    const r = playingIframes.indexOf(e), n = t.event == "onPlay" || t.event == "onStart" || t.event == "onProgress" && t.value?.playing == !0;
    n && r == -1 ? playingIframes.push(e) : !n && (t.event == "onPause" || t.event == "onStop") && r > -1 && playingIframes.splice(r, 1);
  }));
}, sendToPlayer = (t, e, r) => {
  t?.postMessage(r === void 0 ? { action: e } : { action: e, value: r }, "*");
}, pausePlayingVideos = () => {
  const t = playingIframes.filter((e) => document.body.contains(e));
  return t.forEach((e) => sendToPlayer(e.contentWindow, "pause")), t;
}, playVideos = (t) => {
  t.forEach((e) => sendToPlayer(e.contentWindow, "play"));
}, pauseOtherVideos = (t) => {
  getPlayerIframes().filter((e) => e != t).forEach((e) => sendToPlayer(e.contentWindow, "pause"));
}, onVideoTimeReached = (t, e, r, n) => {
  const a = onPlayerMessage((o, c) => {
    if (o.event != "onProgress")
      return;
    const p = o.value?.currentTime;
    typeof p != "number" || p < t || c == findPlayerIframe(e, r) && (a(), n());
  });
}, initTimecodeLinks = (t, e) => {
  e && (videoWords = e), addTimecodeCopyButtons(t), openTimecodeFromUrl(), !timecodeLinksStarted && (timecodeLinksStarted = !0, window.addEventListener("hashchange", openTimecodeFromUrl));
}, openTimecodeFromUrl = () => {
  if (openedTimecode != null && openedTimecode.url == location.href && document.body.contains(openedTimecode.iframe))
    return;
  const t = parseTimecodeHref(location.hash);
  if (t == null)
    return;
  const e = getTimecodeLinks("body").filter((a) => a.timecode.seconds == t.seconds && a.timecode.target == t.target)[0], r = findPlayerIframe(t.target, e?.element ?? document.body);
  if (r == null)
    return;
  openedTimecode = { url: location.href, iframe: r }, r.scrollIntoView({ block: "center" });
  const n = onPlayerMessage((a, o) => {
    if (o != r)
      return;
    const c = a.event == "onReady" || a.action == "currentTime";
    !c && a.event != "onUnavailable" || (n(), c && startPlayerAt(r, e ? "playAt" : "playAtLimited", t.seconds));
  });
  sendToPlayer(r.contentWindow, "getCurrentTime");
}, addTimecodeCopyButtons = (t) => {
  getTimecodeLinks(t).filter((e) => !e.element.nextElementSibling?.classList.contains(TIMECODE_COPY_CLASS)).forEach((e) => e.element.insertAdjacentElement("afterend", createTimecodeCopyButton(e.element)));
}, createTimecodeCopyButton = (t) => {
  const e = document.createElement("button");
  e.type = "button", e.className = TIMECODE_COPY_CLASS, e.title = videoWords.copyTimecodeLink, e.setAttribute("aria-label", videoWords.copyTimecodeLink), e.dataset.copied = videoWords.timecodeLinkCopied, e.innerHTML = TIMECODE_COPY_ICON;
  let r = 0;
  return e.addEventListener("click", async (n) => {
    n.preventDefault(), n.stopPropagation(), await copyText(new URL(t.getAttribute("href") || "", location.href).href) && (window.clearTimeout(r), e.classList.add(TIMECODE_COPIED_CLASS), r = window.setTimeout(() => e.classList.remove(TIMECODE_COPIED_CLASS), TIMECODE_COPIED_LIFETIME_MS));
  }), e;
}, copyText = async (t) => {
  try {
    return await navigator.clipboard.writeText(t), !0;
  } catch {
    return copyTextBySelection(t);
  }
}, copyTextBySelection = (t) => {
  const e = document.createElement("textarea");
  e.value = t, e.setAttribute("readonly", ""), e.style.position = "fixed", e.style.top = "0", e.style.opacity = "0", document.body.appendChild(e), e.select();
  try {
    return document.execCommand("copy");
  } catch {
    return !1;
  } finally {
    document.body.removeChild(e);
  }
}, getTimecodeLinks = (t) => {
  const e = Array.prototype.slice.call(document.querySelectorAll(`${t} .ez [href]`)), r = [];
  return e.forEach((n) => {
    const a = parseTimecodeHref(n.getAttribute("href"));
    a != null && r.push({ element: n, timecode: a });
  }), r;
}, playVideoAt = (t, e) => {
  const r = findPlayerIframe(t.target, e);
  r != null && startPlayerAt(r, "playAt", t.seconds);
}, startPlayerAt = (t, e, r) => {
  t.contentWindow && (sendToPlayer(t.contentWindow, e, r), t.scrollIntoView({ behavior: "smooth", block: "center" }));
}, getPlayerIframes = () => Array.prototype.slice.call(document.querySelectorAll('iframe[src*="/v/"], iframe[data-src*="/v/"]')).filter((t) => isPlayerSrc(getPlayerSrc(t))), getPlayerSrc = (t) => t.getAttribute("src") || t.dataset.src || "", findPlayerIframe = (t, e) => {
  const r = getPlayerIframes();
  if (r.length == 0)
    return null;
  if (t) {
    const a = document.getElementById(t)?.querySelector("iframe");
    return a != null && isPlayerSrc(getPlayerSrc(a)) ? a : r.filter((o) => getPlayerVideoId(getPlayerSrc(o)) == t)[0] || null;
  }
  const n = r.filter((a) => (e.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING) != 0);
  return n.length > 0 ? n[n.length - 1] : r[0];
}, isPlayerSrc = (t) => getPlayerVideoId(t) != null, getPlayerVideoId = (t) => {
  try {
    const e = new URL(t, document.baseURI).pathname;
    return PLAYER_PATH_REGEX.test(e) ? e.substring(3) : null;
  } catch {
    return null;
  }
}, MINI_PLAYER_CLASS = "ez-video-mini", MINI_PLAYER_PLACEHOLDER_CLASS = "ez-video-mini-placeholder", MINI_PLAYER_CLOSE_CLASS = "ez-video-mini-close", MINI_PLAYER_RESIZE_CLASS = "ez-video-mini-resize", MINI_PLAYER_WIDTH_KEY = "video-mini-width", MINI_PLAYER_CORNER_KEY = "video-mini-corner", MINI_PLAYER_MOVE_CLASS = "ez-video-mini-move", MINI_PLAYER_ARROW_UP = "↑", MINI_PLAYER_ARROW_DOWN = "↓", MINI_PLAYER_ARROW_LEFT = "←", MINI_PLAYER_ARROW_RIGHT = "→", MINI_PLAYER_EDGE = 20, MINI_PLAYER_MIN_WIDTH = 220, MINI_PLAYER_MAX_SCREEN_SHARE = 0.8, MINI_PLAYER_DEFAULT_WIDTH = 320, MINI_PLAYER_RATIO = 9 / 16;
let shownMiniPlayer = null, miniPlayerStarted = !1;
const initVideoMiniPlayer = () => {
  if (miniPlayerStarted || typeof IntersectionObserver > "u")
    return;
  miniPlayerStarted = !0;
  const t = [], e = (n) => {
    let a = t.filter((o) => o.iframe == n)[0];
    return a == null && (a = {
      iframe: n,
      enabled: !1,
      playing: !1,
      dismissed: !1,
      visible: !0,
      placeholder: null,
      close: null,
      resize: null,
      moveVertical: null,
      moveHorizontal: null,
      onResizeWindow: null,
      observer: r
    }, t.push(a), r.observe(n)), a;
  }, r = new IntersectionObserver((n) => {
    n.forEach((a) => {
      const o = t.filter((c) => c.iframe == a.target || c.placeholder == a.target)[0];
      o != null && (o.visible = a.isIntersecting, o.visible && (o.dismissed = !1), apply(o));
    });
  }, { threshold: 0 });
  onPlayerMessage((n, a) => {
    const o = e(a);
    n.event == "onReady" && (o.enabled = n.miniPlayerEnabled == !0);
    const c = n.event != "onProgress" || n.value?.playing == !0;
    (n.event == "onPlay" || n.event == "onStart" || n.event == "onProgress") && c && (!o.playing && n.byAutoplay != !0 && pauseOtherVideos(o.iframe), o.playing = !0), (n.event == "onPause" || n.event == "onStop" || n.event == "onUnavailable") && (o.playing = !1), apply(o);
  });
}, apply = (t) => {
  if (!document.body.contains(t.iframe)) {
    hide(t);
    return;
  }
  const e = shownMiniPlayer == null || shownMiniPlayer == t, r = t.enabled && t.playing && !t.visible && !t.dismissed && e;
  r != (t.placeholder != null) && (r ? show(t) : hide(t));
}, show = (t) => {
  if (shownMiniPlayer != null && shownMiniPlayer != t)
    return;
  const e = t.iframe.getBoundingClientRect(), r = document.createElement("div");
  r.className = MINI_PLAYER_PLACEHOLDER_CLASS, r.style.width = `${e.width}px`, r.style.height = `${e.height}px`, t.iframe.parentElement?.insertBefore(r, t.iframe), t.placeholder = r, t.observer.unobserve(t.iframe), t.observer.observe(r);
  const n = document.createElement("div");
  n.className = MINI_PLAYER_CLOSE_CLASS, n.innerHTML = "&times;", n.addEventListener("click", () => {
    t.dismissed = !0, apply(t);
  }), document.body.appendChild(n), t.close = n, t.moveVertical = addMoveButton(t, !0), t.moveHorizontal = addMoveButton(t, !1);
  const a = document.createElement("div");
  a.className = MINI_PLAYER_RESIZE_CLASS, a.addEventListener("pointerdown", (o) => startResizing(t, o)), document.body.appendChild(a), t.resize = a, t.iframe.classList.add(MINI_PLAYER_CLASS), layout(t, getStoredWidth()), t.onResizeWindow = () => layout(t, t.iframe.getBoundingClientRect().width), window.addEventListener("resize", t.onResizeWindow), shownMiniPlayer = t;
}, startResizing = (t, e) => {
  e.preventDefault();
  const r = e.clientX, n = t.iframe.getBoundingClientRect().width, a = getStoredCorner().indexOf("left") > -1, o = (p) => {
    const _ = a ? p.clientX - r : r - p.clientX;
    layout(t, n + _);
  }, c = () => {
    window.removeEventListener("pointermove", o), window.removeEventListener("pointerup", c), storeWidth(t.iframe.getBoundingClientRect().width);
  };
  window.addEventListener("pointermove", o), window.addEventListener("pointerup", c);
}, layout = (t, e) => {
  const r = Math.round(Math.max(MINI_PLAYER_MIN_WIDTH, Math.min(e, getMaxWidth()))), n = Math.round(r * MINI_PLAYER_RATIO);
  t.iframe.style.setProperty("width", `${r}px`, "important"), t.iframe.style.setProperty("height", `${n}px`, "important");
  const a = t.iframe.getBoundingClientRect(), o = Math.round(a.width), c = Math.round(a.height), p = getStoredCorner(), _ = p.indexOf("top") == 0, E = p.indexOf("left") > -1;
  place(t.iframe, _, E, MINI_PLAYER_EDGE, MINI_PLAYER_EDGE), t.close != null && place(t.close, _, E, MINI_PLAYER_EDGE + c + 6, MINI_PLAYER_EDGE + 4);
  const A = Math.max(34, o - 54);
  t.moveVertical != null && (place(t.moveVertical, _, E, MINI_PLAYER_EDGE + c + 6, MINI_PLAYER_EDGE + A), t.moveVertical.innerHTML = _ ? MINI_PLAYER_ARROW_DOWN : MINI_PLAYER_ARROW_UP), t.moveHorizontal != null && (place(t.moveHorizontal, _, E, MINI_PLAYER_EDGE + c + 6, MINI_PLAYER_EDGE + A + 30), t.moveHorizontal.innerHTML = E ? MINI_PLAYER_ARROW_RIGHT : MINI_PLAYER_ARROW_LEFT), t.resize != null && place(t.resize, _, E, MINI_PLAYER_EDGE, MINI_PLAYER_EDGE + o - 22);
}, place = (t, e, r, n, a) => {
  t.style.setProperty(e ? "top" : "bottom", `${n}px`, "important"), t.style.setProperty(e ? "bottom" : "top", "auto", "important"), t.style.setProperty(r ? "left" : "right", `${a}px`, "important"), t.style.setProperty(r ? "right" : "left", "auto", "important");
}, addMoveButton = (t, e) => {
  const r = document.createElement("div");
  return r.className = MINI_PLAYER_MOVE_CLASS, r.addEventListener("click", () => {
    const n = getStoredCorner(), a = n.indexOf("top") == 0, o = n.indexOf("left") > -1;
    storeCorner(`${(e ? !a : a) ? "top" : "bottom"}-${(e ? o : !o) ? "left" : "right"}`), layout(t, t.iframe.getBoundingClientRect().width);
  }), document.body.appendChild(r), r;
}, getStoredCorner = () => {
  try {
    const t = localStorage.getItem(MINI_PLAYER_CORNER_KEY);
    return t == "top-left" || t == "top-right" || t == "bottom-left" ? t : "bottom-right";
  } catch {
    return "bottom-right";
  }
}, storeCorner = (t) => {
  try {
    localStorage.setItem(MINI_PLAYER_CORNER_KEY, t);
  } catch {
  }
}, getMaxWidth = () => {
  const t = window.innerWidth * MINI_PLAYER_MAX_SCREEN_SHARE, e = (window.innerHeight - MINI_PLAYER_EDGE * 2) / MINI_PLAYER_RATIO;
  return Math.max(MINI_PLAYER_MIN_WIDTH, Math.min(t, e));
}, getStoredWidth = () => {
  try {
    const t = parseInt(localStorage.getItem(MINI_PLAYER_WIDTH_KEY) || "", 10);
    return isNaN(t) ? MINI_PLAYER_DEFAULT_WIDTH : t;
  } catch {
    return MINI_PLAYER_DEFAULT_WIDTH;
  }
}, storeWidth = (t) => {
  try {
    localStorage.setItem(MINI_PLAYER_WIDTH_KEY, Math.round(t).toString());
  } catch {
  }
}, hide = (t) => {
  t.iframe.classList.remove(MINI_PLAYER_CLASS), t.iframe.style.removeProperty("width"), t.iframe.style.removeProperty("height"), shownMiniPlayer == t && (shownMiniPlayer = null), t.placeholder != null && (t.observer.unobserve(t.placeholder), t.placeholder.parentElement?.removeChild(t.placeholder), t.placeholder = null, t.observer.observe(t.iframe)), t.close?.parentElement?.removeChild(t.close), t.close = null, t.resize?.parentElement?.removeChild(t.resize), t.resize = null, t.moveVertical?.parentElement?.removeChild(t.moveVertical), t.moveVertical = null, t.moveHorizontal?.parentElement?.removeChild(t.moveHorizontal), t.moveHorizontal = null, t.onResizeWindow != null && (window.removeEventListener("resize", t.onResizeWindow), t.onResizeWindow = null);
}, POPUP_HOLDER_CLASS = "ez-popup-holder", POPUP_CLASS = "ez-popup", POPUP_CLOSE_CLASS = "ez-popup-close", POPUP_SHOWN_CLASS = "shown", POPUP_BACKDROP_CLASS = "ez-popup-backdrop", POPUP_AUTO_SHOW_ATTR = "ez-popup-auto-show", POPUP_STACK_ON_OPEN_ATTR = "ez-popup-stack-on-open", POPUP_VIDEO_TIME_ATTR = "ez-popup-video-time", POPUP_VIDEO_ID_ATTR = "ez-popup-video-id", POPUP_VIDEO_PAUSE_ATTR = "ez-popup-video-pause";
let videosPausedByPopup = [];
const BODY_POPUP_SHOW_CLASS = "ez-popup-shown", BODY_MIN_HEIGHT_CACHE = "bodyMinHeightCache", BACKDROP_BOUND = "popupBackdropBound", popupStack = [];
let popupZCounter = 0, bodyScrollCache = 0;
const holderOf = (t) => t.closest(`.${POPUP_HOLDER_CLASS}`), pruneStack = () => {
  for (let t = popupStack.length - 1; t >= 0; t--) {
    const e = popupStack[t];
    document.contains(e) && e.classList.contains(POPUP_SHOWN_CLASS) || popupStack.splice(t, 1);
  }
}, topPopup = () => (pruneStack(), popupStack[popupStack.length - 1] || null), initPopupTimers = (t) => {
  const e = document.querySelectorAll(`${t} .${POPUP_CLASS}`);
  for (let r = 0; r < e.length; r++) {
    const n = e[r], a = n.getAttribute(POPUP_AUTO_SHOW_ATTR);
    if (a) {
      const c = parseInt(a || "0");
      c > 0 && setTimeout(() => {
        showPopup(n.id);
      }, c * 1e3);
    }
    const o = n.getAttribute(POPUP_VIDEO_TIME_ATTR);
    if (o) {
      const c = parseTimecode(o);
      c != null && onVideoTimeReached(
        c,
        n.getAttribute(POPUP_VIDEO_ID_ATTR) || void 0,
        n,
        () => showPopup(n.id)
      );
    }
  }
}, hidePopup = (t) => {
  pruneStack();
  const e = typeof t == "string" ? popupStack.filter((a) => a.id == t).pop() : popupStack[popupStack.length - 1];
  if (!e)
    return;
  popupStack.splice(popupStack.indexOf(e), 1), e.classList.remove(POPUP_SHOWN_CLASS);
  const r = holderOf(e);
  if (r && !popupStack.some((a) => holderOf(a) == r)) {
    r.classList.remove(POPUP_SHOWN_CLASS), r.style.zIndex = "";
    const a = r.querySelector(`.${POPUP_BACKDROP_CLASS}`);
    a && a.classList.remove(POPUP_SHOWN_CLASS);
  }
  const n = e.querySelector("." + POPUP_CLOSE_CLASS);
  if (n && n.remove(), isInsideWidget() && r) {
    const a = document.querySelector("body");
    a && (r.style.overflow = "auto", a.style.minHeight = e[BODY_MIN_HEIGHT_CACHE] || "", window.dispatchEvent(new Event("resize")));
  }
  popupStack.length == 0 && (videosPausedByPopup.length > 0 && (playVideos(videosPausedByPopup), videosPausedByPopup = []), popupZCounter = 0, document.body.classList.remove(BODY_POPUP_SHOW_CLASS), document.body.style.position = "", document.body.style.top = "", window.scrollTo(0, bodyScrollCache));
}, showPopup = (t) => {
  const e = document.getElementById(t);
  if (!e || e.classList.contains(POPUP_CLASS) == !1)
    return;
  const r = holderOf(e);
  if (!r || r.classList.contains(POPUP_HOLDER_CLASS) == !1 || topPopup() == e)
    return;
  if (e.getAttribute(POPUP_STACK_ON_OPEN_ATTR) == null)
    for (; popupStack.length > 0; )
      hidePopup();
  r.classList.add(POPUP_SHOWN_CLASS);
  const n = r.querySelector(`.${POPUP_BACKDROP_CLASS}`);
  n && (n[BACKDROP_BOUND] || (n[BACKDROP_BOUND] = !0, n.addEventListener("click", () => hidePopup())), n.classList.add(POPUP_SHOWN_CLASS)), e.classList.add(POPUP_SHOWN_CLASS), e.getAttribute(POPUP_VIDEO_PAUSE_ATTR) && (videosPausedByPopup = videosPausedByPopup.concat(pausePlayingVideos())), popupStack.push(e), popupStack.length == 1 && (bodyScrollCache = window.pageYOffset || document.documentElement.scrollTop, document.body.classList.add(BODY_POPUP_SHOW_CLASS), document.body.style.position = "fixed", document.body.style.top = `-${bodyScrollCache}px`), popupZCounter++;
  const a = parseInt(getComputedStyle(r).zIndex);
  r.style.zIndex = String((isNaN(a) ? 0 : a) + popupZCounter);
  const o = document.createElement("div");
  if (o.classList.add(POPUP_CLOSE_CLASS), o.innerHTML = "×", o.addEventListener("click", () => hidePopup(e.id)), e.appendChild(o), isInsideWidget()) {
    const c = document.querySelector("body");
    c && (r.style.overflow = "hidden", e[BODY_MIN_HEIGHT_CACHE] = c.style.minHeight, c.style.minHeight = e.scrollHeight + 40 + "px", window.dispatchEvent(new Event("resize")));
  }
}, ensureCheckout = async () => {
  await window.AXLEnsureCheckout?.();
}, BOUND_ATTR = "ezclickbound", isOwnClick = (t, e) => {
  const r = e.target;
  if (!r || typeof r.closest != "function") return !0;
  const n = r.closest(`[${BOUND_ATTR}]`);
  return !n || n == t;
}, isActivationKey = (t) => t.key == "Enter" || t.key == " " || t.key == "Spacebar", onActivationKey = (t, e) => {
  t.addEventListener("keydown", (r) => {
    t.getAttribute("tabindex") != null && r.target == t && isActivationKey(r) && (r.preventDefault(), e());
  });
}, initClicks = (t) => {
  const e = document.querySelectorAll(`${t} [${ACTION_ATTR}], ${t} .ez [href]`);
  for (var r = 0; r < e.length; r++) {
    const n = e[r], a = n.getAttribute("href"), o = n.getAttribute("type") == "submit";
    if (o && n.removeAttribute("href"), n.setAttribute(BOUND_ATTR, ""), !a)
      o ? n._onSuccessFormSubmit = () => clickActionHandler(n) : (n.addEventListener("click", (c) => {
        isOwnClick(n, c) && clickActionHandler(n);
      }), onActivationKey(n, () => clickActionHandler(n)));
    else {
      const c = parseTimecodeHref(a);
      c ? n.addEventListener("click", (p) => {
        p.preventDefault(), playVideoAt(c, n);
      }) : o ? n._onSuccessFormSubmit = () => emulateClick(a || "", n.getAttribute("target")) : (n.addEventListener("click", (p) => {
        isOwnClick(n, p) && (p.preventDefault(), emulateClick(a || "", n.getAttribute("target")));
      }), onActivationKey(n, () => emulateClick(a || "", n.getAttribute("target"))));
    }
  }
}, copyToClipboard = async (t) => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(t);
      return;
    }
  } catch (r) {
    console.error(r);
  }
  const e = document.createElement("textarea");
  e.value = t, e.setAttribute("readonly", ""), e.style.position = "fixed", e.style.opacity = "0", document.body.appendChild(e), e.select();
  try {
    document.execCommand("copy");
  } catch (r) {
    console.error(r);
  } finally {
    e.remove();
  }
}, clickActionHandler = (t) => {
  if (!t)
    return;
  const e = JSON.parse(t.getAttribute(ACTION_ATTR) || "");
  e.length > 0 && clickActionRun(0, e, t);
}, clickActionRun = async (index, actions, target) => {
  const currentAction = actions[index];
  if (currentAction)
    switch (currentAction.type) {
      case "link":
        const linkTo = replaceAXLVariables(currentAction.href || "", AXLReplaceTags.Id, axl_contactId());
        emulateClick(linkTo || "", currentAction.blank ? "_blank" : null);
        break;
      case "file":
        if (!currentAction.data)
          break;
        var fileUrl = `${axl_fileDownloadUrl()}/${currentAction.data}`;
        try {
          if (typeof axl_clickActions.fileDownload == "function") {
            var fileUrlResult = await axl_clickActions.fileDownload(currentAction.data);
            fileUrlResult && (fileUrl = fileUrlResult);
          }
        } catch (t) {
          console.error(t);
        }
        target.setAttribute("download", "true"), emulateClick(`${fileUrl}`, "_blank"), await clickActionRun(index + 1, actions, target);
        break;
      case "addToCart":
        var fastCheckout = currentAction.data2 == !0;
        await ensureCheckout(), await window.accel_checkout.cart.addToCart(currentAction.data, 1, fastCheckout), await clickActionRun(index + 1, actions, target);
        break;
      case "removeFromCart":
        var fullRemove = currentAction.data2 == !0;
        await ensureCheckout(), await window.accel_checkout.cart.removeFromCart(currentAction.data, fullRemove), await clickActionRun(index + 1, actions, target);
        break;
      case "goToCheckout":
        var checkoutUrl = `${axl_base_uri}/checkout`;
        isInsideWidget() && (axl_contactQueryStringParam && axl_contactId() && (checkoutUrl = updateOrSetQueryStringParam(checkoutUrl, axl_contactQueryStringParam, axl_contactId())), axl_guestQueryStringParam && axl_guestId() && (checkoutUrl = updateOrSetQueryStringParam(checkoutUrl, axl_guestQueryStringParam, axl_guestId()))), emulateClick(checkoutUrl, null);
        break;
      case "moveToSection":
        if (currentAction.data) {
          const t = document.getElementById(currentAction.data);
          if (t) {
            const e = document.querySelector(".ez-wrapper");
            if (e) {
              const r = t.offsetTop - e.offsetTop;
              document.body.scrollTop = r, document.documentElement.scrollTop = r;
            } else
              t.scrollIntoView({ block: "start" });
          }
        }
        await clickActionRun(index + 1, actions, target);
        break;
      case "redirectToCourseStep":
        window.goToCourseStep(currentAction.data, currentAction.blank);
        break;
      case "videoSeek":
        const videoSeek = parseVideoMomentSettings(currentAction.data), videoSeconds = parseTimecode(videoSeek.time);
        videoSeconds != null && playVideoAt({ seconds: videoSeconds, target: videoSeek.target }, target);
        break;
      case "imageZoom":
        var src = null;
        if (target.nodeName == "IMG")
          src = target.getAttribute("src");
        else {
          var img = target.querySelector("img");
          src = img.getAttribute("src");
        }
        if (!src)
          break;
        var container = target.closest(".ez-wrapper") || document.getElementsByClassName("ez-wrapper")[0];
        container && src && src.length > 0 && zoomImage(src, container);
        break;
      case "refreshPage":
        window.location.reload();
        break;
      case "runJS":
        const js = currentAction.data;
        try {
          if (js) {
            var replaced = replaceAXLVariables(js, AXLReplaceTags.Id, axl_contactId());
            eval(decodeURIComponent(replaced));
          }
        } finally {
          await clickActionRun(index + 1, actions, target);
          break;
        }
      case "runCustomEvent":
        try {
          axl_clickActions.runCustomEvent != null && await axl_clickActions.runCustomEvent(currentAction);
        } finally {
          await clickActionRun(index + 1, actions, target);
          break;
        }
      case "openContent":
        try {
          axl_clickActions.openContent != null && await axl_clickActions.openContent(currentAction);
        } finally {
          await clickActionRun(index + 1, actions, target);
          break;
        }
      case "copyToClipboard":
        if (currentAction.data) {
          const t = replaceAXLVariables(currentAction.data, AXLReplaceTags.Id, axl_contactId());
          await copyToClipboard(t);
        }
        await clickActionRun(index + 1, actions, target);
        break;
      case "showPopup":
        showPopup(currentAction.data), await clickActionRun(index + 1, actions, target);
        break;
      default:
        await clickActionRun(index + 1, actions, target);
    }
}, PLAYER_CLASS = "ez-audio-player", INIT_ATTR = "data-ez-audio-player-init";
let wakeLock = null, playingCount = 0;
const formatTime = (t) => {
  if (!isFinite(t) || t < 0) return "0:00";
  const e = Math.floor(t / 60), r = Math.floor(t % 60);
  return `${e}:${r.toString().padStart(2, "0")}`;
}, requestWakeLock = async () => {
  try {
    "wakeLock" in navigator && !wakeLock && (wakeLock = await navigator.wakeLock.request("screen"));
  } catch {
  }
}, releaseWakeLock = async () => {
  try {
    wakeLock && (await wakeLock.release(), wakeLock = null);
  } catch {
  }
}, onGlobalPlay = () => {
  playingCount++, requestWakeLock();
}, onGlobalPause = () => {
  playingCount = Math.max(0, playingCount - 1), playingCount === 0 && releaseWakeLock();
}, setupMediaSession = (t) => {
  "mediaSession" in navigator && (navigator.mediaSession.metadata = new MediaMetadata({ title: "Audio" }), navigator.mediaSession.setActionHandler("play", () => {
    t.play();
  }), navigator.mediaSession.setActionHandler("pause", () => {
    t.pause();
  }), navigator.mediaSession.setActionHandler("seekbackward", (e) => {
    t.currentTime = Math.max(0, t.currentTime - (e.seekOffset ?? 10));
  }), navigator.mediaSession.setActionHandler("seekforward", (e) => {
    const r = e.seekOffset ?? 10;
    t.currentTime = Math.min(t.duration || 0, t.currentTime + r);
  }));
}, createPlayButton = () => {
  const t = document.createElement("button");
  return t.type = "button", t.className = "ez-audio-play", t.setAttribute("aria-label", "Play"), t.innerHTML = `
		<svg class="ez-audio-icon-play" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>
		<svg class="ez-audio-icon-pause" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 5h4v14H6zm8 0h4v14h-4z"/></svg>
	`, t;
}, setupCustomPlayer = (t, e) => {
  e.removeAttribute("controls");
  const r = document.createElement("div");
  r.className = PLAYER_CLASS;
  const n = createPlayButton(), a = document.createElement("span");
  a.className = "ez-audio-time ez-audio-time-current", a.textContent = "0:00";
  const o = document.createElement("input");
  o.type = "range", o.className = "ez-audio-seek", o.min = "0", o.max = "0", o.step = "any", o.value = "0", o.setAttribute("aria-label", "Seek");
  const c = document.createElement("span");
  c.className = "ez-audio-time ez-audio-time-remaining", c.textContent = "-0:00", r.append(n, a, o, c, e), t.appendChild(r);
  const _ = `ez-audio-pos:${e.getAttribute("axlfileid") || e.src}`;
  let E = !1, A = null;
  const S = (L) => {
    n.classList.toggle("is-playing", L), n.setAttribute("aria-label", L ? "Pause" : "Play");
  }, C = () => {
    a.textContent = formatTime(e.currentTime);
    const L = (e.duration || 0) - e.currentTime;
    c.textContent = `-${formatTime(L)}`;
  }, x = () => {
    !E && isFinite(e.duration) && (o.max = String(e.duration), o.value = String(e.currentTime)), C();
  }, z = () => {
    A || (A = setTimeout(() => {
      try {
        sessionStorage.setItem(_, String(e.currentTime));
      } catch {
      }
      A = null;
    }, 2e3));
  };
  n.addEventListener("click", () => {
    e.paused ? e.play() : e.pause();
  }), o.addEventListener("input", () => {
    E = !0, e.currentTime = parseFloat(o.value), C();
  }), o.addEventListener("change", () => {
    E = !1;
  }), e.addEventListener("loadedmetadata", () => {
    o.max = String(e.duration || 0), C();
    try {
      const L = sessionStorage.getItem(_);
      if (L) {
        const I = parseFloat(L);
        I > 0 && e.duration > 0 && I < e.duration - 1 && (e.currentTime = I, x());
      }
    } catch {
    }
  }), e.addEventListener("timeupdate", () => {
    x(), z(), "mediaSession" in navigator && navigator.mediaSession.setPositionState && navigator.mediaSession.setPositionState({
      duration: e.duration || 0,
      position: e.currentTime,
      playbackRate: e.playbackRate
    });
  }), e.addEventListener("play", () => {
    onGlobalPlay(), S(!0), "mediaSession" in navigator && (navigator.mediaSession.playbackState = "playing");
  }), e.addEventListener("pause", () => {
    onGlobalPause(), S(!1), "mediaSession" in navigator && (navigator.mediaSession.playbackState = "paused");
  }), e.addEventListener("ended", () => {
    onGlobalPause(), S(!1), o.value = "0", C();
    try {
      sessionStorage.removeItem(_);
    } catch {
    }
  }), setupMediaSession(e);
}, initAudios = (t) => {
  const e = document.querySelectorAll(`${t} .ez-audio`);
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    if (n.getAttribute(INIT_ATTR)) continue;
    const a = n.querySelector("audio");
    if (a) {
      if (!a.src) {
        const o = a.getAttribute("axlfileid");
        o && (a.src = `${axl_fileDownloadUrl()}/${o}`);
      }
      a.src && (setupCustomPlayer(n, a), n.setAttribute(INIT_ATTR, "true"));
    }
  }
}, initHtmlEmbeds = (t) => {
  for (var e = document.querySelectorAll(`${t} .ez-html`), r = 0; r < e.length; r++) {
    const n = e[r];
    try {
      const a = n.querySelector(".ez-html-content[content]");
      if (!a)
        continue;
      let o = decodeURIComponent(a.getAttribute("content") || "");
      o = o.replace(/&nbsp;/g, " "), n.innerHTML = o;
      const c = (p) => {
        var _ = n.querySelectorAll("script");
        const E = _[p];
        if (!E)
          return !0;
        const A = document.createElement("script");
        Array.from(E.attributes).forEach((S) => A.setAttribute(S.name, S.value)), A.appendChild(document.createTextNode(E.innerHTML)), E.parentNode && E.parentNode.replaceChild(A, E), A.getAttribute("onload") ? c(p + 1) : A.onload = () => {
          c(p + 1);
        };
      };
      c(0);
    } catch {
      n.remove();
    }
  }
}, initMenuToggle = (t) => {
  const e = document.querySelectorAll(`${t} .ez-menu-collapse-btn`);
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    n && n.addEventListener("click", showMenu);
  }
}, showMenu = (t) => {
  const e = t.currentTarget;
  if (!e) return;
  const r = e.closest(".ez-menu");
  r && r.classList.toggle("shown");
  const n = e.closest(".ez-section");
  n && n.classList.toggle("menu-shown");
}, initPseudoClicks = (t) => {
  for (var e = document.querySelectorAll(`${t} [${PSEUDO_CLICK_ATTR}]`), r = 0; r < e.length; r++) {
    const n = e[r];
    if (n != null) {
      const a = n.getAttribute("href"), o = n.getAttribute("target");
      a && (n.onclick = () => {
        emulateClick(a, o);
      });
    }
  }
}, checkConditionCache = [], isInFilter = async (t) => {
  const e = axl_contactId() || "";
  var r = checkConditionCache.find((n) => n.contactId == e && n.filterId == t)?.result;
  return typeof r > "u" && (r = await axl_userIsInFilter(e, t), checkConditionCache.push({ contactId: e, filterId: t, result: r || !1 })), r;
}, initConditions = async (t) => {
  const e = document.querySelectorAll(`${t} [${CONDITION_ATTR}]`);
  for (var r = 0; r < e.length; r++) {
    const _ = e[r];
    _.style.visibility = "hidden";
  }
  window.dispatchEvent(new Event("resize"));
  for (var r = 0; r < e.length; r++) {
    const E = e[r], A = JSON.parse(E.getAttribute(CONDITION_ATTR) || "[]");
    for (var n = 0; n < A.length; n++) {
      const S = A[n];
      if (!E)
        continue;
      const C = axl_contactId() != null;
      switch (S.type) {
        case "userIsAuth":
          (S.case == "showOnlyIf" && !C || S.case == "hideIf" && C) && E.remove();
          break;
        case "userIsNotAuth":
          (S.case == "showOnlyIf" && C || S.case == "hideIf" && !C) && E.remove();
          break;
        case "urlParam":
          const x = document.location.search, z = new URLSearchParams(x);
          if (S.data && typeof S.data == "object" && S.data.key && S.data.value) {
            var a = z.get(S.data?.key.trim()) == S.data.value.trim();
            (S.case == "showOnlyIf" && !a || S.case == "hideIf" && a) && E.remove();
          }
          break;
        case "urlContains":
          var o = document.location.href.indexOf(S.data) > -1;
          (S.case == "showOnlyIf" && !o || S.case == "hideIf" && o) && E.remove();
          break;
        case "userUnderFilter":
          if (!C && S.case == "showOnlyIf") {
            E.remove();
            break;
          }
          var c = await isInFilter(S.data);
          (S.case == "showOnlyIf" && c != !0 || S.case == "hideIf" && c == !0) && E.remove();
          break;
        case "userNotUnderFilter":
          if (!C && S.case == "hideIf") {
            E.remove();
            break;
          }
          var c = await isInFilter(S.data);
          (S.case == "showOnlyIf" && c != !1 || S.case == "hideIf" && c == !1) && E.remove();
          break;
        case "dateTime":
          try {
            let D = JSON.parse(S.data);
            if (!D.date) break;
            let m = new Date(D.date), h = getComputedStyle(E).display, d = h, s = null, u = null;
            if (S.case == "showOnlyIf")
              switch (D.condition) {
                case "<":
                  u = m, d = "none";
                  break;
                case ">":
                  s = m, d = h;
                  break;
                case "period":
                  D.date2 && (s = m, u = new Date(D.date2), d = h);
                  break;
              }
            else if (S.case == "hideIf")
              switch (D.condition) {
                case "<":
                  s = m, d = h;
                  break;
                case ">":
                  u = m, d = "none";
                  break;
                case "period":
                  D.date2 && (u = m, s = new Date(D.date2), d = "none");
                  break;
              }
            checkConditionDateTime(E, h, s, u);
            let f = setInterval(() => {
              var v = checkConditionDateTime(E, h, s, u);
            }, 1e3);
          } catch {
            console.warn("Invalid condition data", S.data);
            break;
          }
          break;
        case "timeOfTheDay":
          try {
            let D = JSON.parse(S.data);
            if (!D.date) break;
            let m = D.date, h = getComputedStyle(E).display, d = h, s = null, u = null;
            if (S.case == "showOnlyIf")
              switch (D.condition) {
                case "<":
                  u = m, d = "none";
                  break;
                case ">":
                  s = m, d = h;
                  break;
                case "period":
                  D.date2 && (s = m, u = D.date2, d = h);
                  break;
              }
            else if (S.case == "hideIf")
              switch (D.condition) {
                case "<":
                  s = m, d = h;
                  break;
                case ">":
                  u = m, d = "none";
                  break;
                case "period":
                  D.date2 && (s = D.date2, u = m, d = "none");
                  break;
              }
            checkConditionTime(E, h, s, u);
            let f = setInterval(() => {
              var v = checkConditionTime(E, h, s, u);
            }, 1e3);
          } catch {
            console.warn("Invalid condition data", S.data);
            break;
          }
          break;
        case "videoTime":
          const L = parseVideoMomentSettings(S.data), I = parseTimecode(L.time);
          if (I == null) {
            console.warn("Invalid condition data", S.data);
            break;
          }
          applyVideoTimeCondition(
            E,
            I,
            L.target,
            S.case == "showOnlyIf"
            /* showOnlyIf */
          );
          break;
        case "weekDay":
          let $ = JSON.parse(S.data);
          if (!$.weekDays) break;
          var p = (/* @__PURE__ */ new Date()).getDay();
          $.weekDays.indexOf(p) == -1 ? S.case == "showOnlyIf" && E.remove() : S.case == "hideIf" && E.remove();
          break;
      }
    }
    E.style.visibility = "";
  }
  window.dispatchEvent(new Event("resize"));
}, applyVideoTimeCondition = (t, e, r, n) => {
  const a = getComputedStyle(t).display, o = a == "none" ? "" : a, c = (p) => {
    const _ = p == n ? o : "none";
    t.style.display != _ && (t.style.display = _, window.dispatchEvent(new Event("resize")));
  };
  c(!1), onVideoTimeReached(e, r, t, () => c(!0));
}, checkConditionDateTime = (t, e, r, n) => {
  var a = getComputedStyle(t).display, o = a, c = (/* @__PURE__ */ new Date()).getTime();
  if (r && n) {
    var p = n.getTime() < r.getTime();
    p ? c > n.getTime() && c < r.getTime() ? o = "none" : o = e : c > r.getTime() && c < n.getTime() ? o = e : o = "none";
  } else r ? c >= r.getTime() ? o = e : o = "none" : n && (c < n.getTime() ? o = e : o = "none");
  return a != o && window.dispatchEvent(new Event("resize")), t.style.display = o, o;
}, checkConditionTime = (t, e, r, n) => {
  var a = getComputedStyle(t).display, o = a, c = /* @__PURE__ */ new Date(), p = c.getUTCHours() * 60 + c.getUTCMinutes(), _ = parseInt(r?.split(":")[0] || "0") * 60 + parseInt(r?.split(":")[1] || "0"), E = parseInt(n?.split(":")[0] || "0") * 60 + parseInt(n?.split(":")[1] || "0");
  if (n == "00:00" && (E = 24 * 60), r && n) {
    var A = E > _;
    A ? p >= _ && p < E ? o = e : o = "none" : p < E || p >= _ ? o = e : o = "none";
  } else r ? p >= _ ? o = e : o = "none" : n && (p < E ? o = e : o = "none");
  return a != o && window.dispatchEvent(new Event("resize")), t.style.display = o, o;
}, QUIZ_ID_ATTR = "ez-quiz-id", triggerResize = (t) => {
  window.dispatchEvent(new CustomEvent("resize", {
    detail: {
      height: t.scrollHeight
    }
  }));
}, initQuiz = (t) => {
  var e = document.querySelectorAll(`${t} .ez-quiz`);
  if (e.length == 0) return;
  const r = window.AXLData?.quizSettings;
  if (!r) {
    console.error("Couldn't init quiz. AXLData.quizSettings is undefined", t);
    return;
  }
  injectStyle(r.styleSrc), injectScript(r.scriptSrc).then(() => {
    for (var n = 0; n < e.length; n++) {
      const a = e[n], o = a.parentElement;
      try {
        const c = a.getAttribute(QUIZ_ID_ATTR);
        a.quiz = new window.AccelQuiz({
          container: a,
          quizId: c,
          lang: r.lang,
          loc: r.loc,
          config: r.config,
          onRedirect: (p, _) => emulateClick(p, _ ? "_blank" : "_self"),
          // trigger to recalc widget viewport
          onMounted: () => triggerResize(o ?? a),
          onPageSwitched: () => {
            setTimeout(() => {
              triggerResize(o ?? a);
            }, 200);
          },
          onCompleted: (p) => {
            window.AXLWebsite && window.AXLWebsite.dispatch(AXLWebsiteEventEnum.FormSubmit, p), setTimeout(() => {
              triggerResize(o ?? a);
            }, 200);
          },
          onContactChanged: (p) => {
            window.ao?.setContactId(p);
          }
        });
      } catch {
        a.remove();
      }
    }
  });
}, sc$1 = (t) => (t || "").replace(/[<>{}";]/g, "").trim(), parseProps$2 = (t) => {
  const e = (r, n = "") => t.getAttribute(r) || n;
  return {
    slidesPerView: parseInt(e("data-slides-per-view", "1")) || 1,
    spaceBetween: parseInt(e("data-space-between", "20")) || 20,
    autoplay: e("data-autoplay") === "true",
    autoplayDelay: parseInt(e("data-autoplay-delay", "3000")) || 3e3,
    loop: e("data-loop") === "true",
    showNavigation: e("data-show-navigation", "true") === "true",
    showPagination: e("data-show-pagination", "true") === "true",
    paginationType: e("data-pagination-type", "bullets"),
    effect: e("data-effect", "slide"),
    speed: parseInt(e("data-speed", "300")) || 300,
    navColor: e("data-nav-color", "#333333"),
    navSize: e("data-nav-size", "24px"),
    paginationColor: e("data-pagination-color", "#cccccc"),
    paginationActiveColor: e("data-pagination-active-color", "#1890ff"),
    slideMinHeight: e("data-slide-min-height", "200px")
  };
};
let sliderStyleInjected = !1;
const ensureBaseStyle = () => {
  if (sliderStyleInjected) return;
  sliderStyleInjected = !0;
  const t = document.createElement("style");
  t.textContent = `
		.ez-slider-vp { position: relative; overflow: hidden; width: 100%; box-sizing: border-box; }
		.ez-slider-track { display: flex; will-change: transform; }
		.ez-slider-cell { flex: 0 0 auto; box-sizing: border-box; }
		.ez-slider-cell > * { height: 100%; }
		.ez-slider-fade .ez-slider-track { display: block; position: relative; }
		.ez-slider-fade .ez-slider-cell { position: absolute; inset: 0; width: 100% !important; opacity: 0; transition: opacity var(--ez-slider-speed, 300ms) ease; }
		.ez-slider-fade .ez-slider-cell.is-active { position: relative; opacity: 1; }
		.ez-slider-nav { position: absolute; top: 50%; transform: translateY(-50%); z-index: 2; cursor: pointer; user-select: none; line-height: 1; background: transparent; border: none; padding: 4px; }
		.ez-slider-nav.prev { left: 8px; }
		.ez-slider-nav.next { right: 8px; }
		.ez-slider-dots { display: flex; justify-content: center; gap: 8px; padding-top: 10px; }
		.ez-slider-dots .ez-slider-dot { width: 9px; height: 9px; border-radius: 50%; border: none; padding: 0; cursor: pointer; }
		.ez-slider-fraction { text-align: center; padding-top: 10px; font-size: 13px; }
		.ez-slider-progress { height: 4px; margin-top: 10px; border-radius: 2px; overflow: hidden; }
		.ez-slider-progress > span { display: block; height: 100%; width: 0; transition: width var(--ez-slider-speed, 300ms) ease; }
	`, document.head.appendChild(t);
}, hydrate$1 = (t, e) => {
  const r = Array.from(
    t.querySelectorAll(":scope > .ez-slide, :scope > div > .ez-slide")
  );
  if (r.length === 0) return;
  ensureBaseStyle();
  const n = e.effect === "slide" || e.effect === "coverflow", a = !n, o = n ? Math.max(1, e.slidesPerView) : 1, c = n ? e.spaceBetween : 0, p = document.createElement("div");
  p.className = "ez-slider-vp" + (a ? " ez-slider-fade" : ""), p.style.setProperty("--ez-slider-speed", `${e.speed}ms`);
  const _ = document.createElement("div");
  _.className = "ez-slider-track", n && (_.style.gap = `${c}px`), _.style.transition = `transform ${e.speed}ms ease`;
  const E = r.map((y) => {
    const w = document.createElement("div");
    return w.className = "ez-slider-cell", w.style.minHeight = sc$1(e.slideMinHeight || "200px"), n && (w.style.width = o > 1 ? `calc((100% - ${(o - 1) * c}px) / ${o})` : "100%"), w.appendChild(y), _.appendChild(w), w;
  });
  p.appendChild(_), t.innerHTML = "", t.style.position = "relative", t.appendChild(p);
  const A = E.length, S = n ? Math.max(0, A - o) : A - 1;
  let C = 0, x, z;
  if (e.showNavigation) {
    x = document.createElement("button"), x.type = "button", x.className = "ez-slider-nav prev", x.innerHTML = "&#10094;", z = document.createElement("button"), z.type = "button", z.className = "ez-slider-nav next", z.innerHTML = "&#10095;";
    const y = sc$1(e.navColor || "#333"), w = sc$1(e.navSize || "24px");
    [x, z].forEach((O) => {
      O.style.color = y, O.style.fontSize = w;
    }), p.appendChild(x), p.appendChild(z);
  }
  let L, I, $;
  const D = sc$1(e.paginationColor || "#ccc"), m = sc$1(e.paginationActiveColor || "#1890ff");
  if (e.showPagination)
    if (e.paginationType === "fraction")
      I = document.createElement("div"), I.className = "ez-slider-fraction", I.style.color = m, t.appendChild(I);
    else if (e.paginationType === "progressbar") {
      const y = document.createElement("div");
      y.className = "ez-slider-progress", y.style.background = D, $ = document.createElement("span"), $.style.background = m, y.appendChild($), t.appendChild(y);
    } else {
      L = document.createElement("div"), L.className = "ez-slider-dots";
      for (let y = 0; y < (n ? S + 1 : A); y++) {
        const w = document.createElement("button");
        w.type = "button", w.className = "ez-slider-dot", w.style.background = D;
        const O = y;
        w.addEventListener("click", () => u(O, !0)), L.appendChild(w);
      }
      t.appendChild(L);
    }
  const h = () => {
    if (a)
      E.forEach((y, w) => y.classList.toggle("is-active", w === C));
    else {
      const y = E[0]?.getBoundingClientRect().width || 0, w = C * (y + c);
      _.style.transform = `translateX(-${w}px)`;
    }
    if (L && Array.from(L.children).forEach((y, w) => {
      y.style.background = w === C ? m : D;
    }), I) {
      const y = n ? S + 1 : A;
      I.textContent = `${C + 1} / ${y}`;
    }
    if ($) {
      const y = n ? S + 1 : A;
      $.style.width = y > 1 ? `${C / (y - 1) * 100}%` : "100%";
    }
  }, d = (y) => e.loop ? y < 0 ? S : y > S ? 0 : y : Math.max(0, Math.min(S, y));
  let s = null;
  function u(y, w = !1) {
    C = d(y), h(), w && s && s();
  }
  x?.addEventListener("click", () => u(C - 1, !0)), z?.addEventListener("click", () => u(C + 1, !0));
  let f = 0, v = !1;
  if (p.addEventListener("touchstart", (y) => {
    f = y.touches[0].clientX, v = !0;
  }, { passive: !0 }), p.addEventListener("touchend", (y) => {
    if (!v) return;
    v = !1;
    const w = y.changedTouches[0].clientX - f;
    Math.abs(w) > 40 && u(w < 0 ? C + 1 : C - 1, !0);
  }), e.autoplay && S > 0) {
    let y = window.setInterval(() => {
      C = d(C + 1), h();
    }, e.autoplayDelay);
    s = () => {
      y && (window.clearInterval(y), y = 0);
    };
  }
  window.addEventListener("resize", () => h()), h();
}, initSlider = (t) => {
  document.querySelectorAll(`${t} [data-ez-slider="wrapper"]`).forEach((r) => {
    if (r.dataset.ezInit === "slider") return;
    const n = parseProps$2(r);
    r.querySelectorAll(":scope > .ez-slide, :scope > div > .ez-slide").length !== 0 && (r.dataset.ezInit = "slider", hydrate$1(r, n));
  });
}, STYLE_ID = "ez-accordion-styles", sc = (t) => (t || "").replace(/[<>{}";]/g, "").trim(), parseProps$1 = (t) => {
  const e = (r, n) => sc(t.getAttribute(r) || "") || n;
  return {
    allowMultiple: t.getAttribute("data-allow-multiple") !== "false",
    defaultOpenFirst: t.getAttribute("data-default-open-first") !== "false",
    expandIcon: e("data-expand-icon", "arrow"),
    headerBgColor: e("data-header-bg-color", "#fafafa"),
    headerTextColor: e("data-header-text-color", "#333333"),
    headerFontFamily: e("data-header-font-family", ""),
    headerPaddingV: e("data-header-padding-v", "12px"),
    headerPaddingH: e("data-header-padding-h", "16px"),
    headerBorderColor: e("data-header-border-color", "#d9d9d9"),
    bodyBgColor: e("data-body-bg-color", "#ffffff"),
    bodyPaddingV: e("data-body-padding-v", "16px"),
    bodyPaddingH: e("data-body-padding-h", "16px"),
    borderRadius: e("data-border-radius", "8px"),
    animationSpeed: e("data-animation-speed", "0.3s")
  };
}, parseDurationMs = (t) => {
  const e = parseFloat(t);
  return isNaN(e) ? 300 : t.endsWith("ms") ? e : e * 1e3;
}, ensureStyles = () => {
  if (document.getElementById(STYLE_ID)) return;
  const t = document.createElement("style");
  t.id = STYLE_ID, t.textContent = `
		[data-ez-accordion="wrapper"] {
			overflow: hidden;
			border-radius: var(--ez-acc-radius, 8px);
			border: 1px solid var(--ez-acc-border-color, #d9d9d9);
		}
		.ez-acc-header {
			margin: 0;
			background: var(--ez-acc-header-bg, #fafafa);
			color: var(--ez-acc-header-color, #333333);
			font-family: var(--ez-acc-header-font, inherit);
			padding: var(--ez-acc-header-pad-v, 12px) var(--ez-acc-header-pad-h, 16px);
			cursor: pointer;
			user-select: none;
			display: flex;
			align-items: center;
			gap: 10px;
			border-bottom: 1px solid var(--ez-acc-border-color, #d9d9d9);
			font-weight: 500;
			transition: background var(--ez-acc-speed, 0.3s);
		}
		.ez-acc-header:hover { filter: brightness(0.97); }
		.ez-acc-header .ez-acc-icon { transition: transform var(--ez-acc-speed, 0.3s); flex-shrink: 0; font-size: 12px; }
		.ez-acc-header[data-open="true"] .ez-acc-icon { transform: rotate(90deg); }
		.ez-acc-header[data-open="true"] .ez-acc-icon-plus { transform: rotate(45deg); }
		.ez-acc-body {
			background: var(--ez-acc-body-bg, #ffffff);
			overflow: hidden;
			transition: max-height var(--ez-acc-speed, 0.3s) ease, padding var(--ez-acc-speed, 0.3s) ease;
			max-height: 0;
			padding: 0 var(--ez-acc-body-pad-h, 16px);
		}
		.ez-acc-body[data-open="true"] { padding: var(--ez-acc-body-pad-v, 16px) var(--ez-acc-body-pad-h, 16px); }
		.ez-acc-panel:last-child .ez-acc-header { border-bottom: var(--ez-acc-last-border, none); }
	`, document.head.appendChild(t);
}, applyVariables = (t, e, r) => {
  const n = {
    "--ez-acc-header-bg": e.headerBgColor,
    "--ez-acc-header-color": e.headerTextColor,
    "--ez-acc-header-font": e.headerFontFamily,
    "--ez-acc-header-pad-v": e.headerPaddingV,
    "--ez-acc-header-pad-h": e.headerPaddingH,
    "--ez-acc-border-color": e.headerBorderColor,
    "--ez-acc-body-bg": e.bodyBgColor,
    "--ez-acc-body-pad-v": e.bodyPaddingV,
    "--ez-acc-body-pad-h": e.bodyPaddingH,
    "--ez-acc-speed": e.animationSpeed,
    "--ez-acc-radius": e.borderRadius,
    "--ez-acc-last-border": r > 1 ? `1px solid ${e.headerBorderColor}` : "none"
  };
  Object.keys(n).forEach((a) => t.style.setProperty(a, n[a]));
}, setPanelOpen = (t, e, r) => {
  if (window.clearTimeout(t.releaseTimer), t.header.setAttribute("data-open", e ? "true" : "false"), t.body.setAttribute("data-open", e ? "true" : "false"), !r) {
    t.body.style.maxHeight = e ? "none" : "0px";
    return;
  }
  if (t.body.style.maxHeight = `${t.body.scrollHeight}px`, e) {
    t.releaseTimer = window.setTimeout(() => t.body.style.maxHeight = "none", t.durationMs + 50);
    return;
  }
  t.body.offsetHeight, t.body.style.maxHeight = "0px";
}, readPanels = (t) => Array.from(
  t.querySelectorAll(":scope > .ez-accordion-item, :scope > div > .ez-accordion-item")
).map((r, n) => {
  const a = r.querySelector(".ez-accordion-item-header"), o = a?.textContent?.trim();
  a?.remove();
  const c = r.querySelector(".ez-accordion-item-body");
  if (c) {
    const p = document.createDocumentFragment();
    for (; c.firstChild; ) p.appendChild(c.firstChild);
    r.innerHTML = "", r.appendChild(p);
  }
  return {
    title: o || r.getAttribute("data-accordion-title") || `Panel ${n + 1}`,
    content: r,
    isOpen: r.getAttribute("data-accordion-open") === "true"
  };
}), applyOpenState = (t, e) => {
  if (e.defaultOpenFirst ? t.length > 0 && !t.some((r) => r.isOpen) && (t[0].isOpen = !0) : t.forEach((r) => r.isOpen = !1), !e.allowMultiple) {
    const r = t.findIndex((n) => n.isOpen);
    t.forEach((n, a) => n.isOpen = a === r);
  }
}, hydrate = (t, e) => {
  const r = readPanels(t);
  if (r.length === 0) return;
  const n = parseDurationMs(e.animationSpeed);
  applyOpenState(r, e), ensureStyles(), t.innerHTML = "", applyVariables(t, e, r.length);
  const a = () => {
    if (e.expandIcon === "none") return null;
    const c = document.createElement("span");
    return c.className = e.expandIcon === "plus" ? "ez-acc-icon ez-acc-icon-plus" : "ez-acc-icon", c.textContent = e.expandIcon === "plus" ? "+" : "▸", c;
  }, o = [];
  r.forEach((c) => {
    const p = document.createElement("div");
    p.className = "ez-acc-panel";
    const _ = document.createElement("h3");
    _.className = "ez-acc-header";
    const E = a();
    E && _.appendChild(E);
    const A = document.createElement("span");
    A.textContent = c.title, _.appendChild(A);
    const S = document.createElement("div");
    S.className = "ez-acc-body", S.appendChild(c.content);
    const C = { header: _, body: S, durationMs: n, releaseTimer: 0 };
    o.push(C), _.addEventListener("click", () => {
      const x = _.getAttribute("data-open") !== "true";
      x && !e.allowMultiple && o.forEach((z) => {
        z !== C && setPanelOpen(z, !1, !0);
      }), setPanelOpen(C, x, !0);
    }), p.appendChild(_), p.appendChild(S), t.appendChild(p);
  }), o.forEach((c, p) => setPanelOpen(c, r[p].isOpen, !1));
}, initAccordion = (t) => {
  document.querySelectorAll(`${t} [data-ez-accordion="wrapper"]`).forEach((r) => {
    r.dataset.ezInit === "accordion" || r.querySelectorAll(":scope > .ez-accordion-item, :scope > div > .ez-accordion-item").length === 0 || (r.dataset.ezInit = "accordion", hydrate(r, parseProps$1(r)));
  });
}, defaultWords = {
  notConfigured: "Application is not configured",
  noInstance: "The installed application instance is not specified",
  unavailable: "Application is unavailable",
  loadError: "Loading error",
  guest: "Guest"
}, getWords = () => {
  const t = window.AXLData?.vendorAppBlockSettings?.loc;
  return { ...defaultWords, ...t };
}, contactCookieName = "a_c", collectionQuery = (t) => {
  const e = new URLSearchParams();
  return e.set("limit", String(t.limit || 200)), t.filter && Object.keys(t.filter).length > 0 && e.set("filter", JSON.stringify(t.filter)), t.sort && e.set("sort", t.sort), t.sortCast && e.set("sortCast", t.sortCast), t.desc !== void 0 && e.set("desc", String(t.desc)), t.cursorSort && e.set("cursorSort", t.cursorSort), t.cursorDocId && e.set("cursorDocId", t.cursorDocId), e.toString();
}, getVisitor = () => {
  const t = window.AXLData?.vendorAppBlockSettings?.visitor, e = t?.contactId || api.get(contactCookieName) || "";
  return { isAuthorized: !!t?.isAuthorized || !!e, contactId: e };
}, rememberVisitor = (t) => {
  const e = window.AXLData?.vendorAppBlockSettings;
  e && (e.visitor = { isAuthorized: !0, contactId: t }), window.ao?.setContactId(t);
}, parseProps = (t) => {
  const e = (o, c = "") => t.getAttribute(o) || c;
  let r = {};
  try {
    r = JSON.parse(e("data-config", "{}"));
  } catch {
    r = {};
  }
  const n = e("data-css-override", "");
  let a = "";
  try {
    a = n ? decodeURIComponent(n) : "";
  } catch {
    a = "";
  }
  return {
    appSlug: e("data-app-slug", ""),
    schoolLinkId: e("data-school-link-id", ""),
    surfaceKind: e("data-surface-kind", "site-block"),
    config: r,
    minHeight: parseInt(e("data-min-height", "0"), 10) || 0,
    showHeader: e("data-show-header", "false") === "true",
    cssOverride: a
  };
}, RUNTIME_SDK = `
<script>
(function () {
  var pending = Object.create(null), rpcSeq = 0, readyCbs = [], contextCbs = [], ctx = null;
  function nextId() { return 'r' + (++rpcSeq); }
  var queryOptionNames = ['filter', 'sort', 'sortCast', 'desc', 'limit', 'cursorSort', 'cursorDocId'];
  function warnUnknownQueryOptions(method, opts) {
    if (!opts || typeof opts !== 'object') return opts;
    var unknown = Object.keys(opts).filter(function (key) { return queryOptionNames.indexOf(key) < 0; });
    if (unknown.length) console.warn('[xl] ' + method + ': unknown option(s) ' + unknown.join(', ') + ' are ignored. Supported: ' + queryOptionNames.join(', ') + '.');
    return opts;
  }

  function call(kind, args) {
    var id = nextId();
    return new Promise(function (res, rej) {
      pending[id] = { res: res, rej: rej };
      window.parent.postMessage(Object.assign({ kind: kind, rpcId: id }, args || {}), '*');
    });
  }
  window.addEventListener('message', function (e) {
    var m = e.data;
    if (!m || typeof m !== 'object') return;
    if (m.kind === 'xl.ready') {
      var wasReady = !!ctx;
      ctx = m.context;
      window.xl.user = ctx.user; window.xl.school = ctx.school; window.xl.app = ctx.app;
      window.xl.surface = ctx.surface || null; window.xl.protocolVersion = m.protocolVersion;
      window.xl.block = { config: (ctx.surface && ctx.surface.config) || {} };
      if (wasReady) {
        for (var c = 0; c < contextCbs.length; c++) try { contextCbs[c](ctx); } catch (_) {}
        return;
      }
      for (var i = 0; i < readyCbs.length; i++) try { readyCbs[i](ctx); } catch (_) {}
      readyCbs = [];
      return;
    }
    if (m.kind === 'xl.rpc.ok' && pending[m.rpcId]) { var p = pending[m.rpcId]; delete pending[m.rpcId]; p.res(m.result); return; }
    if (m.kind === 'xl.rpc.error' && pending[m.rpcId]) { var pe = pending[m.rpcId]; delete pending[m.rpcId]; var err = new Error(m.message || 'RPC error'); err.code = m.code; pe.rej(err); return; }
  });
  function xlReady(cb) {
    if (typeof cb === 'function') { if (ctx) cb(ctx); else readyCbs.push(cb); }
    return xlReady;
  }
  xlReady.then = function (onFulfilled, onRejected) {
    return new Promise(function (resolve) { xlReady(resolve); }).then(onFulfilled, onRejected);
  };
  function locale() { return (ctx && ctx.school && ctx.school.locale) || 'ru'; }
  function tz() { return (ctx && ctx.school && ctx.school.timezone) || undefined; }
  window.xl = {
    user: null, school: null, app: null, surface: null, protocolVersion: null,
    block: { config: {} },
    ready: xlReady,
    onContextChange: function (cb) {
      if (typeof cb !== 'function') return function () {};
      contextCbs.push(cb);
      return function () { var i = contextCbs.indexOf(cb); if (i >= 0) contextCbs.splice(i, 1); };
    },
    format: {
      date: function (d, opts) { var o = opts || {}, hasC = o.weekday || o.year || o.month || o.day; var base = hasC ? { timeZone: tz() } : { dateStyle: 'medium', timeZone: tz() }; return new Intl.DateTimeFormat(locale(), Object.assign(base, o)).format(new Date(d)); },
      time: function (d, opts) { var o = opts || {}, hasC = o.hour || o.minute || o.second; var base = hasC ? { timeZone: tz() } : { timeStyle: 'short', timeZone: tz() }; return new Intl.DateTimeFormat(locale(), Object.assign(base, o)).format(new Date(d)); },
      dateTime: function (d, opts) { return new Intl.DateTimeFormat(locale(), Object.assign({ dateStyle: 'medium', timeStyle: 'short', timeZone: tz() }, opts || {})).format(new Date(d)); },
      number: function (n, opts) { return new Intl.NumberFormat(locale(), opts || {}).format(Number(n)); },
      plural: function (n, forms) { if (!forms) return String(n); var rule = new Intl.PluralRules(locale()).select(Number(n)); return forms[rule] || forms.other || String(n); },
      relativeTime: function (d) { var diff = (new Date(d).getTime() - Date.now()) / 1000; var rtf = new Intl.RelativeTimeFormat(locale(), { numeric: 'auto' }); var abs = Math.abs(diff); if (abs < 60) return rtf.format(Math.round(diff), 'second'); if (abs < 3600) return rtf.format(Math.round(diff / 60), 'minute'); if (abs < 86400) return rtf.format(Math.round(diff / 3600), 'hour'); if (abs < 86400 * 30) return rtf.format(Math.round(diff / 86400), 'day'); if (abs < 86400 * 365) return rtf.format(Math.round(diff / (86400 * 30)), 'month'); return rtf.format(Math.round(diff / (86400 * 365)), 'year'); },
    },
    storage: {
      get: function (collection, docId) { return call('xl.storage.get', { collection: collection, docId: docId }); },
      query: function (collection, opts) { return call('xl.storage.query', Object.assign({ collection: collection }, warnUnknownQueryOptions('xl.storage.query', opts) || {})); },
      put: function () { return Promise.reject(new Error('storage write disabled on public site')); },
      delete: function () { return Promise.reject(new Error('storage write disabled on public site')); },
    },
    public: {
      query: function (collection, opts) { return call('xl.public.query', Object.assign({ collection: collection }, warnUnknownQueryOptions('xl.public.query', opts) || {})); },
      get: function (collection, docId) { return call('xl.public.get', { collection: collection, docId: docId }); },
      create: function (collection, data) { return call('xl.public.create', { collection: collection, data: data == null ? {} : data }); },
      crm: {
        me: function () { return call('xl.public.crm.me', {}); },
        findOrCreate: function (input) { return call('xl.public.crm.findOrCreate', input || {}); },
        attachRecord: function (input) { return call('xl.public.crm.attachRecord', input || {}); },
      },
      scenarios: {
        emit: function (eventKind, data, opts) { return call('xl.public.scenarios.emit', { eventKind: eventKind, studentId: opts && opts.studentId, data: data == null ? {} : data }); },
      },
    },
    learner: {
      courses: function () { return call('xl.learner.courses', {}); },
      lessons: function (opts) { return call('xl.learner.lessons', { courseId: opts && opts.courseId }); },
    },
    state: {
      get: function (key) { return call('xl.state.get', { key: String(key) }); },
      set: function (key, value, opts) { return call('xl.state.set', { key: String(key), value: value, ttlSec: opts && opts.ttlSec }); },
    },
    config: { submit: function () {}, cancel: function () {} },
    ui: { toast: function () {}, openLink: function (u) { window.open(u, '_blank'); }, resize: function (h) { window.parent.postMessage({ kind: 'xl.ui.resize', height: h }, '*'); } },
  };
  window.parent.postMessage({ kind: 'xl.init' }, '*');
  var __lastH = 0;
  function __reportH() { var h = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight, document.body.offsetHeight); if (h && Math.abs(h - __lastH) > 1) { __lastH = h; window.parent.postMessage({ kind: 'xl.ui.resize', height: h }, '*'); } }
  if (typeof ResizeObserver !== 'undefined') { try { var __ro = new ResizeObserver(__reportH); __ro.observe(document.body); __ro.observe(document.documentElement); } catch (e) {} }
  if (typeof MutationObserver !== 'undefined') { try { new MutationObserver(__reportH).observe(document.body, { childList: true, subtree: true, attributes: true }); } catch (e) {} }
  window.addEventListener('load', __reportH); window.addEventListener('resize', __reportH);
  setTimeout(__reportH, 250); setTimeout(__reportH, 900); setTimeout(__reportH, 2500);
})();
<\/script>
`, appStateKey = (t, e) => `xl:appstate:${t}:${e}`, readAppState = (t, e) => {
  if (!e) return null;
  try {
    const r = window.localStorage.getItem(appStateKey(t, e));
    if (!r) return null;
    const n = JSON.parse(r);
    return n.expiresAt && Date.now() > n.expiresAt ? (window.localStorage.removeItem(appStateKey(t, e)), null) : n.value ?? null;
  } catch {
    return null;
  }
}, writeAppState = (t, e, r, n) => {
  if (e)
    try {
      if (r == null) {
        window.localStorage.removeItem(appStateKey(t, e));
        return;
      }
      const a = n && n > 0 ? Date.now() + n * 1e3 : void 0;
      window.localStorage.setItem(appStateKey(t, e), JSON.stringify({ value: r, expiresAt: a }));
    } catch {
      return;
    }
}, neutralizeStyleTag = (t) => t.replace(/<\s*\/\s*style/gi, "<\\/style"), assemble = (t, e) => {
  const r = e && e.trim() ? e : typeof t == "string" ? "" : t.css || "";
  if (typeof t == "string") {
    if (e && e.trim()) {
      const o = t.replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, ""), c = `<style data-source="block-override">${neutralizeStyleTag(e)}</style>`;
      return /<head\b[^>]*>/i.test(o) ? o.replace(/<head\b[^>]*>/i, (p) => p + c) : c + o;
    }
    return t;
  }
  const n = r ? `<style data-source="${e ? "block-override" : "vendor"}">${neutralizeStyleTag(r)}</style>` : "", a = t.js ? `<script>${t.js}<\/script>` : "";
  return `<!DOCTYPE html><html><head><meta charset="utf-8">${n}</head><body>${t.html || ""}${a}</body></html>`;
}, initOne = async (t, e, r) => {
  if (t.querySelector("iframe.xl-vendor-block")) return;
  if (t.innerHTML = "", !e.appSlug) {
    t.innerHTML = `<div style="padding:30px;text-align:center;color:#999;border:1px dashed #ddd;border-radius:8px">${r.notConfigured}</div>`;
    return;
  }
  if (!e.schoolLinkId) {
    t.innerHTML = `<div style="padding:30px;text-align:center;color:#999;border:1px dashed #ddd;border-radius:8px">${r.noInstance}</div>`;
    return;
  }
  const n = `/api/v1/public/marketplace/site-block?schoolLinkId=${encodeURIComponent(e.schoolLinkId)}&surfaceKind=${encodeURIComponent(e.surfaceKind)}&appSlug=${encodeURIComponent(e.appSlug || "")}`;
  try {
    const o = (await (await fetch(n, { credentials: "include" })).json())?.body;
    if (!o || !o.surface) {
      t.innerHTML += `<div style="padding:20px;text-align:center;color:#dc2626">${r.unavailable}: ${e.appSlug}</div>`;
      return;
    }
    const c = assemble(o.surface, e.cssOverride), p = document.createElement("iframe");
    p.className = "xl-vendor-block", p.setAttribute("sandbox", "allow-scripts allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox"), p.setAttribute("allow", "fullscreen"), p.setAttribute("allowfullscreen", "true"), p.setAttribute("scrolling", "no"), p.style.cssText = `width:100%;height:${e.minHeight || 200}px;min-height:${e.minHeight || 0}px;border:0;display:block;border-radius:8px;overflow:hidden`, p.srcdoc = RUNTIME_SDK + c, t.appendChild(p);
    const _ = `/api/v1/public/application-vendor/${encodeURIComponent(o.installId || "")}`, E = `/api/v1/application-vendor-learner/${encodeURIComponent(o.installId || "")}`, A = async (L, I, $, D) => {
      try {
        const m = await (await fetch(L, { credentials: "include", ...I })).json(), h = m?.errors?.[0];
        if (h)
          p.contentWindow.postMessage({ kind: "xl.rpc.error", rpcId: $, code: (h.type || "UNKNOWN").toUpperCase(), message: h.message || "" }, "*");
        else {
          const d = m?.body;
          D && d && typeof d == "object" && D(d), p.contentWindow.postMessage({ kind: "xl.rpc.ok", rpcId: $, result: d ?? null }, "*");
        }
      } catch (m) {
        p.contentWindow.postMessage({ kind: "xl.rpc.error", rpcId: $, code: "FETCH", message: m.message }, "*");
      }
    }, S = (L, I, $, D) => A(L, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(I) }, $, D), C = () => {
      const L = getVisitor();
      return {
        user: L.isAuthorized ? { id: L.contactId, name: r.guest, email: null, role: "student" } : { id: "guest", name: r.guest, email: null, role: "guest" },
        school: { id: o.schoolId || "", name: "", locale: o.locale || "ru", currency: o.currency || "RUB", timezone: o.timezone ?? null },
        app: { slug: o.slug || e.appSlug, installId: o.installId || "", title: o.appTitle || "", settings: o.settings || {}, permissions: o.permissions || [] },
        surface: { kind: e.surfaceKind, config: e.config }
      };
    }, x = () => p.contentWindow.postMessage({ kind: "xl.ready", protocolVersion: 1, context: C() }, "*"), z = (L) => {
      const I = typeof L.studentId == "string" ? L.studentId : "";
      !I || getVisitor().contactId === I || (rememberVisitor(I), x());
    };
    window.addEventListener("message", (L) => {
      if (L.source !== p.contentWindow) return;
      const I = L.data;
      if (I)
        if (I.kind === "xl.init")
          x();
        else if (I.kind === "xl.ui.resize") {
          const $ = Math.max(120, Math.min(Number(I.height) || 0, 6e3));
          $ && (p.style.height = Math.max($, e.minHeight || 0) + "px");
        } else (I.kind === "xl.storage.query" || I.kind === "xl.public.query") && I.rpcId ? A(`${_}/collection/${encodeURIComponent(I.collection || "")}?${collectionQuery(I)}`, {}, I.rpcId) : (I.kind === "xl.storage.get" || I.kind === "xl.public.get") && I.rpcId ? A(`${_}/collection/${encodeURIComponent(I.collection || "")}/${encodeURIComponent(I.docId || "")}`, {}, I.rpcId) : I.kind === "xl.public.create" && I.rpcId ? S(`${_}/collection/${encodeURIComponent(I.collection || "")}`, { data: I.data || {} }, I.rpcId) : I.kind === "xl.public.scenarios.emit" && I.rpcId ? S(`${_}/scenario/emit`, { eventKind: I.eventKind, studentId: I.studentId, data: I.data || {} }, I.rpcId) : I.kind === "xl.learner.courses" && I.rpcId ? A(`${E}/course`, {}, I.rpcId) : I.kind === "xl.learner.lessons" && I.rpcId ? A(`${E}/lesson?courseId=${encodeURIComponent(I.courseId || "")}`, {}, I.rpcId) : I.kind === "xl.state.get" && I.rpcId ? p.contentWindow.postMessage({ kind: "xl.rpc.ok", rpcId: I.rpcId, result: readAppState(e.schoolLinkId, I.key || "") }, "*") : I.kind === "xl.state.set" && I.rpcId ? (writeAppState(e.schoolLinkId, I.key || "", I.value, I.ttlSec), p.contentWindow.postMessage({ kind: "xl.rpc.ok", rpcId: I.rpcId, result: { ok: !0 } }, "*")) : I.kind === "xl.public.crm.me" && I.rpcId ? A(`${_}/crm/me`, {}, I.rpcId) : I.kind === "xl.public.crm.findOrCreate" && I.rpcId ? S(`${_}/crm/contact`, { email: I.email, phone: I.phone, firstName: I.firstName, lastName: I.lastName, readOnly: I.readOnly }, I.rpcId, z) : I.kind === "xl.public.crm.attachRecord" && I.rpcId && S(`${_}/crm/attached-record`, { studentId: I.studentId, kind: I.recordKind, refDocId: I.refDocId, snapshot: I.snapshot }, I.rpcId);
    });
  } catch (a) {
    t.innerHTML += `<div style="padding:20px;text-align:center;color:#dc2626">${r.loadError}: ${a.message || a}</div>`;
  }
}, initVendorAppBlocks = (t) => {
  const r = (document.querySelector(t) || document.body).querySelectorAll("[data-ez-vendorapp]"), n = getWords();
  r.forEach((a) => initOne(a, parseProps(a), n));
};
function initEZTimers(t) {
  for (var e = document.querySelectorAll(`${t} .ez-timer`), r = 0; r < e.length; r++)
    EZTimerInit(e[r]);
}
function EZTimerInit(t) {
  if (!t.timer) {
    t.targetLengthCache = t.getAttribute(
      "lengthSec"
      /* targetLengthSec */
    );
    var e = setInterval(() => {
      if (!t.parentElement) {
        clearInterval(e);
        return;
      }
      EZTimerPlay(t);
    }, 1e3);
    t.timer = e;
  }
}
function EZTimerPlay(t) {
  var e = t.getAttribute(
    "mode"
    /* mode */
  ), r = 0;
  switch (e) {
    case "length":
      var n = t.targetLengthCache != t.getAttribute(
        "lengthSec"
        /* targetLengthSec */
      );
      if (r = t.secondsLeft, !r || n) {
        var a = parseInt(t.getAttribute(
          "lengthSec"
          /* targetLengthSec */
        ) || "0");
        t.targetLengthCache = a.toString(), t.secondsLeft = a, r = t.secondsLeft;
      }
      break;
    case "date":
      try {
        var o = t.getAttribute(
          "dateTime"
          /* targetDateTime */
        ), c = new Date(o);
        r = Math.floor((c.getTime() - Date.now()) / 1e3), r < 0 && (r = 0);
      } catch {
        r = 0;
      }
  }
  var p = Math.floor(r / 86400), _ = Math.floor(r % 86400 / 3600), E = Math.floor(r % 3600 / 60), A = r % 60, S = t.querySelector(".dd");
  if (S) {
    var C = S.querySelector(".n");
    C && (C.innerHTML = p < 10 ? "0" + p : "" + p);
  }
  var x = t.querySelector(".hh");
  if (x) {
    var C = x.querySelector(".n");
    C && (C.innerHTML = _ < 10 ? "0" + _ : "" + _);
  }
  var z = t.querySelector(".mm");
  if (z) {
    var C = z.querySelector(".n");
    C && (C.innerHTML = E < 10 ? "0" + E : "" + E);
  }
  var L = t.querySelector(".ss");
  if (L) {
    var C = L.querySelector(".n");
    C && (C.innerHTML = A < 10 ? "0" + A : "" + A);
  }
  t.secondsLeft && (t.secondsLeft -= 1);
}
const EVENT_PREFIX = "video", START_EVENT = "start", PERCENT_MILESTONES = [25, 50, 75, 100], sentEvents = [], initedCounterIds = [];
let analyticsStarted = !1;
const initVideoAnalytics = () => {
  analyticsStarted || (analyticsStarted = !0, onPlayerMessage((t) => {
    const e = t.videoId;
    if (!e || !hasAnyTarget(t.analytics))
      return;
    if (t.event == "onStart") {
      sendEvent(START_EVENT, e, t);
      return;
    }
    if (t.event != "onProgress" || t.value?.playing != !0)
      return;
    const r = t.value?.watchedPercent;
    typeof r == "number" && PERCENT_MILESTONES.filter((n) => r >= n).forEach((n) => sendEvent(n.toString(), e, t));
  }));
}, sendEvent = (t, e, r) => {
  const n = `${e}:${t}`;
  if (sentEvents.indexOf(n) > -1)
    return;
  sentEvents.push(n);
  const a = `${r.analytics?.eventPrefix || EVENT_PREFIX}_${t}`, o = r.videoTitle || e;
  r.analytics?.metrika && sendToMetrika(a, e, o, r.metrikaCounterId), r.analytics?.googleAnalytics && sendToGoogleAnalytics(a, e, o, r.analytics.googleAnalyticsMeasurementId), r.analytics?.meta && sendToMeta(a, e, o, r.analytics.metaPixelId);
}, hasAnyTarget = (t) => t?.metrika == !0 || t?.googleAnalytics == !0 || t?.meta == !0, sendToMetrika = (t, e, r, n) => {
  const a = getVideoCounterIds(n) ?? getCounterIds(), o = {
    videoId: e,
    video: { [r]: t }
  };
  a.forEach((c) => {
    try {
      ym(c, "reachGoal", t, o);
    } catch {
    }
  });
}, sendToGoogleAnalytics = (t, e, r, n) => {
  if (typeof gtag != "function")
    return;
  const a = {
    video_id: e,
    video_title: r
  };
  n && (a.send_to = n);
  try {
    gtag("event", t, a);
  } catch {
  }
}, sendToMeta = (t, e, r, n) => {
  if (typeof fbq != "function")
    return;
  const a = {
    video_id: e,
    video_title: r
  };
  try {
    n ? fbq("trackSingleCustom", n, t, a) : fbq("trackCustom", t, a);
  } catch {
  }
}, getVideoCounterIds = (t) => {
  if (!t || typeof ym != "function")
    return null;
  const e = parseInt(t, 10);
  if (isNaN(e))
    return null;
  if (initedCounterIds.indexOf(e) == -1 && getCounterIds().indexOf(e) == -1) {
    initedCounterIds.push(e);
    try {
      ym(e, "init", { defer: !0 });
    } catch {
    }
  }
  return [e];
}, getCounterIds = () => {
  if (typeof ym != "function")
    return [];
  try {
    const t = typeof AXLMetrikaCounterIds < "u" ? AXLMetrikaCounterIds : null;
    if (Array.isArray(t) && t.length > 0)
      return t;
    const e = typeof Ya < "u" ? Ya?._metrika : void 0, r = e?.getCounters ? e.getCounters() : e?.counters;
    return Array.isArray(r) ? r.map((n) => n?.id).filter((n) => n != null) : [];
  } catch {
    return [];
  }
}, PSEUDO_CLICK_ATTR = "ezclick", ACTION_ATTR = "ezactions", CONDITION_ATTR = "ez-show-hide", WRAPPER_CLASS = "ez-wrapper";
let axl_base_uri = "", axl_clickActions = {}, axl_fileDownloadUrl = () => `${axl_base_uri}/file/download`, axl_userIsInFilter = async (t, e) => !1, axl_contactId = () => "", axl_contactQueryStringParam, axl_guestId = () => "", axl_guestQueryStringParam;
const ezInitMain = (t) => {
  (t.holderSelector == "" || !t.holderSelector) && (t.holderSelector = "body"), t.baseUrl && (axl_base_uri = t.baseUrl), t.clickActions && (axl_clickActions = t.clickActions), t.userIsInFilter && (axl_userIsInFilter = t.userIsInFilter), typeof t.contactId == "function" && (axl_contactId = t.contactId), axl_contactQueryStringParam = t.contactQueryStringParam, typeof t.questId == "function" && (axl_guestId = t.questId), axl_guestQueryStringParam = t.guestQueryStringParam, makeIframesLazy(), initHtmlEmbeds(t.holderSelector), initPseudoClicks(t.holderSelector), initClicks(t.holderSelector), initConditions(t.holderSelector), initMenuToggle(t.holderSelector), initAudios(t.holderSelector), initPopupTimers(t.holderSelector), initQuiz(t.holderSelector), initSlider(t.holderSelector), initAccordion(t.holderSelector), initVendorAppBlocks(t.holderSelector), initEZTimers(t.holderSelector), initVideoTracking(), initVideoAnalytics(), initVideoMiniPlayer(), initTimecodeLinks(t.holderSelector, t.videoWords), document.querySelectorAll(`.${WRAPPER_CLASS}`).forEach((n) => {
    n.classList.add("live");
  });
  var r = window.AXLWebsite;
  r && (r.showPopup = (n) => showPopup(n), r.hidePopup = () => hidePopup(), r.zoomImage = (n, a) => {
    var o = a || document.getElementsByClassName("ez-wrapper")[0];
    o && n && n.length > 0 && zoomImage(n, o);
  });
}, URL_PARAM_REGEX = /[{#]URL\.Param\(([^#]+?)\)[}#]/;
function normalizeUrlParamName(t) {
  if (!t)
    return "";
  let e = t.trim().replace(/&quot;/gi, '"').replace(/&#0*39;/g, "'").replace(/&apos;/gi, "'").replace(/&#0*34;/g, '"');
  return (e.startsWith('"') && e.endsWith('"') || e.startsWith("'") && e.endsWith("'")) && (e = e.slice(1, -1)), e.trim().replace(/^"+|"+$/g, "").replace(/^'+|'+$/g, "");
}
function tryParseUrlParamTag(t) {
  if (!t)
    return null;
  const e = t.trim(), r = URL_PARAM_REGEX.exec(e);
  return !r || r[0] !== e ? null : normalizeUrlParamName(r[1]) || null;
}
function resolveUrlParamValue(t) {
  if (!t)
    return t ?? "";
  const e = tryParseUrlParamTag(t);
  if (!e)
    return t;
  try {
    return new URLSearchParams(window.location.search).get(e) ?? "";
  } catch {
    return "";
  }
}
function applyUrlParamToHiddenField(t) {
  if (t.type?.toLowerCase() !== "hidden" || !t.value)
    return;
  const e = resolveUrlParamValue(t.value);
  e !== t.value && (t.value = e);
}
function applyUrlParamToHiddenFields(t) {
  for (let e = 0; e < t.length; e++) {
    const r = t[e];
    r?.type?.toLowerCase() === "hidden" && applyUrlParamToHiddenField(r);
  }
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production;
function requireReactJsxRuntime_production() {
  if (hasRequiredReactJsxRuntime_production) return reactJsxRuntime_production;
  hasRequiredReactJsxRuntime_production = 1;
  var t = Symbol.for("react.transitional.element"), e = Symbol.for("react.fragment");
  function r(n, a, o) {
    var c = null;
    if (o !== void 0 && (c = "" + o), a.key !== void 0 && (c = "" + a.key), "key" in a) {
      o = {};
      for (var p in a)
        p !== "key" && (o[p] = a[p]);
    } else o = a;
    return a = o.ref, {
      $$typeof: t,
      type: n,
      key: c,
      ref: a !== void 0 ? a : null,
      props: o
    };
  }
  return reactJsxRuntime_production.Fragment = e, reactJsxRuntime_production.jsx = r, reactJsxRuntime_production.jsxs = r, reactJsxRuntime_production;
}
var reactJsxRuntime_development = {}, react = { exports: {} }, react_production = {};
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReact_production;
function requireReact_production() {
  if (hasRequiredReact_production) return react_production;
  hasRequiredReact_production = 1;
  var t = Symbol.for("react.transitional.element"), e = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), c = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), _ = Symbol.for("react.suspense"), E = Symbol.for("react.memo"), A = Symbol.for("react.lazy"), S = Symbol.iterator;
  function C(l) {
    return l === null || typeof l != "object" ? null : (l = S && l[S] || l["@@iterator"], typeof l == "function" ? l : null);
  }
  var x = {
    isMounted: function() {
      return !1;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, z = Object.assign, L = {};
  function I(l, b, R) {
    this.props = l, this.context = b, this.refs = L, this.updater = R || x;
  }
  I.prototype.isReactComponent = {}, I.prototype.setState = function(l, b) {
    if (typeof l != "object" && typeof l != "function" && l != null)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, l, b, "setState");
  }, I.prototype.forceUpdate = function(l) {
    this.updater.enqueueForceUpdate(this, l, "forceUpdate");
  };
  function $() {
  }
  $.prototype = I.prototype;
  function D(l, b, R) {
    this.props = l, this.context = b, this.refs = L, this.updater = R || x;
  }
  var m = D.prototype = new $();
  m.constructor = D, z(m, I.prototype), m.isPureReactComponent = !0;
  var h = Array.isArray, d = { H: null, A: null, T: null, S: null, V: null }, s = Object.prototype.hasOwnProperty;
  function u(l, b, R, k, F, G) {
    return R = G.ref, {
      $$typeof: t,
      type: l,
      key: b,
      ref: R !== void 0 ? R : null,
      props: G
    };
  }
  function f(l, b) {
    return u(
      l.type,
      b,
      void 0,
      void 0,
      void 0,
      l.props
    );
  }
  function v(l) {
    return typeof l == "object" && l !== null && l.$$typeof === t;
  }
  function y(l) {
    var b = { "=": "=0", ":": "=2" };
    return "$" + l.replace(/[=:]/g, function(R) {
      return b[R];
    });
  }
  var w = /\/+/g;
  function O(l, b) {
    return typeof l == "object" && l !== null && l.key != null ? y("" + l.key) : b.toString(36);
  }
  function U() {
  }
  function M(l) {
    switch (l.status) {
      case "fulfilled":
        return l.value;
      case "rejected":
        throw l.reason;
      default:
        switch (typeof l.status == "string" ? l.then(U, U) : (l.status = "pending", l.then(
          function(b) {
            l.status === "pending" && (l.status = "fulfilled", l.value = b);
          },
          function(b) {
            l.status === "pending" && (l.status = "rejected", l.reason = b);
          }
        )), l.status) {
          case "fulfilled":
            return l.value;
          case "rejected":
            throw l.reason;
        }
    }
    throw l;
  }
  function H(l, b, R, k, F) {
    var G = typeof l;
    (G === "undefined" || G === "boolean") && (l = null);
    var q = !1;
    if (l === null) q = !0;
    else
      switch (G) {
        case "bigint":
        case "string":
        case "number":
          q = !0;
          break;
        case "object":
          switch (l.$$typeof) {
            case t:
            case e:
              q = !0;
              break;
            case A:
              return q = l._init, H(
                q(l._payload),
                b,
                R,
                k,
                F
              );
          }
      }
    if (q)
      return F = F(l), q = k === "" ? "." + O(l, 0) : k, h(F) ? (R = "", q != null && (R = q.replace(w, "$&/") + "/"), H(F, b, R, "", function(ee) {
        return ee;
      })) : F != null && (v(F) && (F = f(
        F,
        R + (F.key == null || l && l.key === F.key ? "" : ("" + F.key).replace(
          w,
          "$&/"
        ) + "/") + q
      )), b.push(F)), 1;
    q = 0;
    var J = k === "" ? "." : k + ":";
    if (h(l))
      for (var j = 0; j < l.length; j++)
        k = l[j], G = J + O(k, j), q += H(
          k,
          b,
          R,
          G,
          F
        );
    else if (j = C(l), typeof j == "function")
      for (l = j.call(l), j = 0; !(k = l.next()).done; )
        k = k.value, G = J + O(k, j++), q += H(
          k,
          b,
          R,
          G,
          F
        );
    else if (G === "object") {
      if (typeof l.then == "function")
        return H(
          M(l),
          b,
          R,
          k,
          F
        );
      throw b = String(l), Error(
        "Objects are not valid as a React child (found: " + (b === "[object Object]" ? "object with keys {" + Object.keys(l).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return q;
  }
  function K(l, b, R) {
    if (l == null) return l;
    var k = [], F = 0;
    return H(l, k, "", "", function(G) {
      return b.call(R, G, F++);
    }), k;
  }
  function Q(l) {
    if (l._status === -1) {
      var b = l._result;
      b = b(), b.then(
        function(R) {
          (l._status === 0 || l._status === -1) && (l._status = 1, l._result = R);
        },
        function(R) {
          (l._status === 0 || l._status === -1) && (l._status = 2, l._result = R);
        }
      ), l._status === -1 && (l._status = 0, l._result = b);
    }
    if (l._status === 1) return l._result.default;
    throw l._result;
  }
  var X = typeof reportError == "function" ? reportError : function(l) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var b = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof l == "object" && l !== null && typeof l.message == "string" ? String(l.message) : String(l),
        error: l
      });
      if (!window.dispatchEvent(b)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", l);
      return;
    }
    console.error(l);
  };
  function re() {
  }
  return react_production.Children = {
    map: K,
    forEach: function(l, b, R) {
      K(
        l,
        function() {
          b.apply(this, arguments);
        },
        R
      );
    },
    count: function(l) {
      var b = 0;
      return K(l, function() {
        b++;
      }), b;
    },
    toArray: function(l) {
      return K(l, function(b) {
        return b;
      }) || [];
    },
    only: function(l) {
      if (!v(l))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return l;
    }
  }, react_production.Component = I, react_production.Fragment = r, react_production.Profiler = a, react_production.PureComponent = D, react_production.StrictMode = n, react_production.Suspense = _, react_production.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = d, react_production.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(l) {
      return d.H.useMemoCache(l);
    }
  }, react_production.cache = function(l) {
    return function() {
      return l.apply(null, arguments);
    };
  }, react_production.cloneElement = function(l, b, R) {
    if (l == null)
      throw Error(
        "The argument must be a React element, but you passed " + l + "."
      );
    var k = z({}, l.props), F = l.key, G = void 0;
    if (b != null)
      for (q in b.ref !== void 0 && (G = void 0), b.key !== void 0 && (F = "" + b.key), b)
        !s.call(b, q) || q === "key" || q === "__self" || q === "__source" || q === "ref" && b.ref === void 0 || (k[q] = b[q]);
    var q = arguments.length - 2;
    if (q === 1) k.children = R;
    else if (1 < q) {
      for (var J = Array(q), j = 0; j < q; j++)
        J[j] = arguments[j + 2];
      k.children = J;
    }
    return u(l.type, F, void 0, void 0, G, k);
  }, react_production.createContext = function(l) {
    return l = {
      $$typeof: c,
      _currentValue: l,
      _currentValue2: l,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }, l.Provider = l, l.Consumer = {
      $$typeof: o,
      _context: l
    }, l;
  }, react_production.createElement = function(l, b, R) {
    var k, F = {}, G = null;
    if (b != null)
      for (k in b.key !== void 0 && (G = "" + b.key), b)
        s.call(b, k) && k !== "key" && k !== "__self" && k !== "__source" && (F[k] = b[k]);
    var q = arguments.length - 2;
    if (q === 1) F.children = R;
    else if (1 < q) {
      for (var J = Array(q), j = 0; j < q; j++)
        J[j] = arguments[j + 2];
      F.children = J;
    }
    if (l && l.defaultProps)
      for (k in q = l.defaultProps, q)
        F[k] === void 0 && (F[k] = q[k]);
    return u(l, G, void 0, void 0, null, F);
  }, react_production.createRef = function() {
    return { current: null };
  }, react_production.forwardRef = function(l) {
    return { $$typeof: p, render: l };
  }, react_production.isValidElement = v, react_production.lazy = function(l) {
    return {
      $$typeof: A,
      _payload: { _status: -1, _result: l },
      _init: Q
    };
  }, react_production.memo = function(l, b) {
    return {
      $$typeof: E,
      type: l,
      compare: b === void 0 ? null : b
    };
  }, react_production.startTransition = function(l) {
    var b = d.T, R = {};
    d.T = R;
    try {
      var k = l(), F = d.S;
      F !== null && F(R, k), typeof k == "object" && k !== null && typeof k.then == "function" && k.then(re, X);
    } catch (G) {
      X(G);
    } finally {
      d.T = b;
    }
  }, react_production.unstable_useCacheRefresh = function() {
    return d.H.useCacheRefresh();
  }, react_production.use = function(l) {
    return d.H.use(l);
  }, react_production.useActionState = function(l, b, R) {
    return d.H.useActionState(l, b, R);
  }, react_production.useCallback = function(l, b) {
    return d.H.useCallback(l, b);
  }, react_production.useContext = function(l) {
    return d.H.useContext(l);
  }, react_production.useDebugValue = function() {
  }, react_production.useDeferredValue = function(l, b) {
    return d.H.useDeferredValue(l, b);
  }, react_production.useEffect = function(l, b, R) {
    var k = d.H;
    if (typeof R == "function")
      throw Error(
        "useEffect CRUD overload is not enabled in this build of React."
      );
    return k.useEffect(l, b);
  }, react_production.useId = function() {
    return d.H.useId();
  }, react_production.useImperativeHandle = function(l, b, R) {
    return d.H.useImperativeHandle(l, b, R);
  }, react_production.useInsertionEffect = function(l, b) {
    return d.H.useInsertionEffect(l, b);
  }, react_production.useLayoutEffect = function(l, b) {
    return d.H.useLayoutEffect(l, b);
  }, react_production.useMemo = function(l, b) {
    return d.H.useMemo(l, b);
  }, react_production.useOptimistic = function(l, b) {
    return d.H.useOptimistic(l, b);
  }, react_production.useReducer = function(l, b, R) {
    return d.H.useReducer(l, b, R);
  }, react_production.useRef = function(l) {
    return d.H.useRef(l);
  }, react_production.useState = function(l) {
    return d.H.useState(l);
  }, react_production.useSyncExternalStore = function(l, b, R) {
    return d.H.useSyncExternalStore(
      l,
      b,
      R
    );
  }, react_production.useTransition = function() {
    return d.H.useTransition();
  }, react_production.version = "19.1.0", react_production;
}
var react_development = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
react_development.exports;
var hasRequiredReact_development;
function requireReact_development() {
  return hasRequiredReact_development || (hasRequiredReact_development = 1, function(t, e) {
    process.env.NODE_ENV !== "production" && function() {
      function r(i, g) {
        Object.defineProperty(o.prototype, i, {
          get: function() {
            console.warn(
              "%s(...) is deprecated in plain JavaScript React classes. %s",
              g[0],
              g[1]
            );
          }
        });
      }
      function n(i) {
        return i === null || typeof i != "object" ? null : (i = ae && i[ae] || i["@@iterator"], typeof i == "function" ? i : null);
      }
      function a(i, g) {
        i = (i = i.constructor) && (i.displayName || i.name) || "ReactClass";
        var T = i + "." + g;
        he[T] || (console.error(
          "Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.",
          g,
          i
        ), he[T] = !0);
      }
      function o(i, g, T) {
        this.props = i, this.context = g, this.refs = fe, this.updater = T || me;
      }
      function c() {
      }
      function p(i, g, T) {
        this.props = i, this.context = g, this.refs = fe, this.updater = T || me;
      }
      function _(i) {
        return "" + i;
      }
      function E(i) {
        try {
          _(i);
          var g = !1;
        } catch {
          g = !0;
        }
        if (g) {
          g = console;
          var T = g.error, P = typeof Symbol == "function" && Symbol.toStringTag && i[Symbol.toStringTag] || i.constructor.name || "Object";
          return T.call(
            g,
            "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
            P
          ), _(i);
        }
      }
      function A(i) {
        if (i == null) return null;
        if (typeof i == "function")
          return i.$$typeof === Te ? null : i.displayName || i.name || null;
        if (typeof i == "string") return i;
        switch (i) {
          case l:
            return "Fragment";
          case R:
            return "Profiler";
          case b:
            return "StrictMode";
          case q:
            return "Suspense";
          case J:
            return "SuspenseList";
          case oe:
            return "Activity";
        }
        if (typeof i == "object")
          switch (typeof i.tag == "number" && console.error(
            "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
          ), i.$$typeof) {
            case re:
              return "Portal";
            case F:
              return (i.displayName || "Context") + ".Provider";
            case k:
              return (i._context.displayName || "Context") + ".Consumer";
            case G:
              var g = i.render;
              return i = i.displayName, i || (i = g.displayName || g.name || "", i = i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef"), i;
            case j:
              return g = i.displayName || null, g !== null ? g : A(i.type) || "Memo";
            case ee:
              g = i._payload, i = i._init;
              try {
                return A(i(g));
              } catch {
              }
          }
        return null;
      }
      function S(i) {
        if (i === l) return "<>";
        if (typeof i == "object" && i !== null && i.$$typeof === ee)
          return "<...>";
        try {
          var g = A(i);
          return g ? "<" + g + ">" : "<...>";
        } catch {
          return "<...>";
        }
      }
      function C() {
        var i = V.A;
        return i === null ? null : i.getOwner();
      }
      function x() {
        return Error("react-stack-top-frame");
      }
      function z(i) {
        if (le.call(i, "key")) {
          var g = Object.getOwnPropertyDescriptor(i, "key").get;
          if (g && g.isReactWarning) return !1;
        }
        return i.key !== void 0;
      }
      function L(i, g) {
        function T() {
          _e || (_e = !0, console.error(
            "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
            g
          ));
        }
        T.isReactWarning = !0, Object.defineProperty(i, "key", {
          get: T,
          configurable: !0
        });
      }
      function I() {
        var i = A(this.type);
        return we[i] || (we[i] = !0, console.error(
          "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
        )), i = this.props.ref, i !== void 0 ? i : null;
      }
      function $(i, g, T, P, N, Y, B, Z) {
        return T = Y.ref, i = {
          $$typeof: X,
          type: i,
          key: g,
          props: Y,
          _owner: N
        }, (T !== void 0 ? T : null) !== null ? Object.defineProperty(i, "ref", {
          enumerable: !1,
          get: I
        }) : Object.defineProperty(i, "ref", { enumerable: !1, value: null }), i._store = {}, Object.defineProperty(i._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: 0
        }), Object.defineProperty(i, "_debugInfo", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: null
        }), Object.defineProperty(i, "_debugStack", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: B
        }), Object.defineProperty(i, "_debugTask", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: Z
        }), Object.freeze && (Object.freeze(i.props), Object.freeze(i)), i;
      }
      function D(i, g) {
        return g = $(
          i.type,
          g,
          void 0,
          void 0,
          i._owner,
          i.props,
          i._debugStack,
          i._debugTask
        ), i._store && (g._store.validated = i._store.validated), g;
      }
      function m(i) {
        return typeof i == "object" && i !== null && i.$$typeof === X;
      }
      function h(i) {
        var g = { "=": "=0", ":": "=2" };
        return "$" + i.replace(/[=:]/g, function(T) {
          return g[T];
        });
      }
      function d(i, g) {
        return typeof i == "object" && i !== null && i.key != null ? (E(i.key), h("" + i.key)) : g.toString(36);
      }
      function s() {
      }
      function u(i) {
        switch (i.status) {
          case "fulfilled":
            return i.value;
          case "rejected":
            throw i.reason;
          default:
            switch (typeof i.status == "string" ? i.then(s, s) : (i.status = "pending", i.then(
              function(g) {
                i.status === "pending" && (i.status = "fulfilled", i.value = g);
              },
              function(g) {
                i.status === "pending" && (i.status = "rejected", i.reason = g);
              }
            )), i.status) {
              case "fulfilled":
                return i.value;
              case "rejected":
                throw i.reason;
            }
        }
        throw i;
      }
      function f(i, g, T, P, N) {
        var Y = typeof i;
        (Y === "undefined" || Y === "boolean") && (i = null);
        var B = !1;
        if (i === null) B = !0;
        else
          switch (Y) {
            case "bigint":
            case "string":
            case "number":
              B = !0;
              break;
            case "object":
              switch (i.$$typeof) {
                case X:
                case re:
                  B = !0;
                  break;
                case ee:
                  return B = i._init, f(
                    B(i._payload),
                    g,
                    T,
                    P,
                    N
                  );
              }
          }
        if (B) {
          B = i, N = N(B);
          var Z = P === "" ? "." + d(B, 0) : P;
          return ve(N) ? (T = "", Z != null && (T = Z.replace(Ie, "$&/") + "/"), f(N, g, T, "", function(ne) {
            return ne;
          })) : N != null && (m(N) && (N.key != null && (B && B.key === N.key || E(N.key)), T = D(
            N,
            T + (N.key == null || B && B.key === N.key ? "" : ("" + N.key).replace(
              Ie,
              "$&/"
            ) + "/") + Z
          ), P !== "" && B != null && m(B) && B.key == null && B._store && !B._store.validated && (T._store.validated = 2), N = T), g.push(N)), 1;
        }
        if (B = 0, Z = P === "" ? "." : P + ":", ve(i))
          for (var W = 0; W < i.length; W++)
            P = i[W], Y = Z + d(P, W), B += f(
              P,
              g,
              T,
              Y,
              N
            );
        else if (W = n(i), typeof W == "function")
          for (W === i.entries && (Ee || console.warn(
            "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
          ), Ee = !0), i = W.call(i), W = 0; !(P = i.next()).done; )
            P = P.value, Y = Z + d(P, W++), B += f(
              P,
              g,
              T,
              Y,
              N
            );
        else if (Y === "object") {
          if (typeof i.then == "function")
            return f(
              u(i),
              g,
              T,
              P,
              N
            );
          throw g = String(i), Error(
            "Objects are not valid as a React child (found: " + (g === "[object Object]" ? "object with keys {" + Object.keys(i).join(", ") + "}" : g) + "). If you meant to render a collection of children, use an array instead."
          );
        }
        return B;
      }
      function v(i, g, T) {
        if (i == null) return i;
        var P = [], N = 0;
        return f(i, P, "", "", function(Y) {
          return g.call(T, Y, N++);
        }), P;
      }
      function y(i) {
        if (i._status === -1) {
          var g = i._result;
          g = g(), g.then(
            function(T) {
              (i._status === 0 || i._status === -1) && (i._status = 1, i._result = T);
            },
            function(T) {
              (i._status === 0 || i._status === -1) && (i._status = 2, i._result = T);
            }
          ), i._status === -1 && (i._status = 0, i._result = g);
        }
        if (i._status === 1)
          return g = i._result, g === void 0 && console.error(
            `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`,
            g
          ), "default" in g || console.error(
            `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`,
            g
          ), g.default;
        throw i._result;
      }
      function w() {
        var i = V.H;
        return i === null && console.error(
          `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
        ), i;
      }
      function O() {
      }
      function U(i) {
        if (ce === null)
          try {
            var g = ("require" + Math.random()).slice(0, 7);
            ce = (t && t[g]).call(
              t,
              "timers"
            ).setImmediate;
          } catch {
            ce = function(P) {
              Se === !1 && (Se = !0, typeof MessageChannel > "u" && console.error(
                "This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."
              ));
              var N = new MessageChannel();
              N.port1.onmessage = P, N.port2.postMessage(void 0);
            };
          }
        return ce(i);
      }
      function M(i) {
        return 1 < i.length && typeof AggregateError == "function" ? new AggregateError(i) : i[0];
      }
      function H(i, g) {
        g !== ue - 1 && console.error(
          "You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "
        ), ue = g;
      }
      function K(i, g, T) {
        var P = V.actQueue;
        if (P !== null)
          if (P.length !== 0)
            try {
              Q(P), U(function() {
                return K(i, g, T);
              });
              return;
            } catch (N) {
              V.thrownErrors.push(N);
            }
          else V.actQueue = null;
        0 < V.thrownErrors.length ? (P = M(V.thrownErrors), V.thrownErrors.length = 0, T(P)) : g(i);
      }
      function Q(i) {
        if (!pe) {
          pe = !0;
          var g = 0;
          try {
            for (; g < i.length; g++) {
              var T = i[g];
              do {
                V.didUsePromise = !1;
                var P = T(!1);
                if (P !== null) {
                  if (V.didUsePromise) {
                    i[g] = T, i.splice(0, g);
                    return;
                  }
                  T = P;
                } else break;
              } while (!0);
            }
            i.length = 0;
          } catch (N) {
            i.splice(0, g + 1), V.thrownErrors.push(N);
          } finally {
            pe = !1;
          }
        }
      }
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
      var X = Symbol.for("react.transitional.element"), re = Symbol.for("react.portal"), l = Symbol.for("react.fragment"), b = Symbol.for("react.strict_mode"), R = Symbol.for("react.profiler"), k = Symbol.for("react.consumer"), F = Symbol.for("react.context"), G = Symbol.for("react.forward_ref"), q = Symbol.for("react.suspense"), J = Symbol.for("react.suspense_list"), j = Symbol.for("react.memo"), ee = Symbol.for("react.lazy"), oe = Symbol.for("react.activity"), ae = Symbol.iterator, he = {}, me = {
        isMounted: function() {
          return !1;
        },
        enqueueForceUpdate: function(i) {
          a(i, "forceUpdate");
        },
        enqueueReplaceState: function(i) {
          a(i, "replaceState");
        },
        enqueueSetState: function(i) {
          a(i, "setState");
        }
      }, ge = Object.assign, fe = {};
      Object.freeze(fe), o.prototype.isReactComponent = {}, o.prototype.setState = function(i, g) {
        if (typeof i != "object" && typeof i != "function" && i != null)
          throw Error(
            "takes an object of state variables to update or a function which returns an object of state variables."
          );
        this.updater.enqueueSetState(this, i, g, "setState");
      }, o.prototype.forceUpdate = function(i) {
        this.updater.enqueueForceUpdate(this, i, "forceUpdate");
      };
      var te = {
        isMounted: [
          "isMounted",
          "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
          "replaceState",
          "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
      }, se;
      for (se in te)
        te.hasOwnProperty(se) && r(se, te[se]);
      c.prototype = o.prototype, te = p.prototype = new c(), te.constructor = p, ge(te, o.prototype), te.isPureReactComponent = !0;
      var ve = Array.isArray, Te = Symbol.for("react.client.reference"), V = {
        H: null,
        A: null,
        T: null,
        S: null,
        V: null,
        actQueue: null,
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1,
        didUsePromise: !1,
        thrownErrors: [],
        getCurrentStack: null,
        recentlyCreatedOwnerStacks: 0
      }, le = Object.prototype.hasOwnProperty, ye = console.createTask ? console.createTask : function() {
        return null;
      };
      te = {
        "react-stack-bottom-frame": function(i) {
          return i();
        }
      };
      var _e, be, we = {}, Re = te["react-stack-bottom-frame"].bind(te, x)(), Pe = ye(S(x)), Ee = !1, Ie = /\/+/g, Ce = typeof reportError == "function" ? reportError : function(i) {
        if (typeof window == "object" && typeof window.ErrorEvent == "function") {
          var g = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: typeof i == "object" && i !== null && typeof i.message == "string" ? String(i.message) : String(i),
            error: i
          });
          if (!window.dispatchEvent(g)) return;
        } else if (typeof process == "object" && typeof process.emit == "function") {
          process.emit("uncaughtException", i);
          return;
        }
        console.error(i);
      }, Se = !1, ce = null, ue = 0, de = !1, pe = !1, Ae = typeof queueMicrotask == "function" ? function(i) {
        queueMicrotask(function() {
          return queueMicrotask(i);
        });
      } : U;
      te = Object.freeze({
        __proto__: null,
        c: function(i) {
          return w().useMemoCache(i);
        }
      }), e.Children = {
        map: v,
        forEach: function(i, g, T) {
          v(
            i,
            function() {
              g.apply(this, arguments);
            },
            T
          );
        },
        count: function(i) {
          var g = 0;
          return v(i, function() {
            g++;
          }), g;
        },
        toArray: function(i) {
          return v(i, function(g) {
            return g;
          }) || [];
        },
        only: function(i) {
          if (!m(i))
            throw Error(
              "React.Children.only expected to receive a single React element child."
            );
          return i;
        }
      }, e.Component = o, e.Fragment = l, e.Profiler = R, e.PureComponent = p, e.StrictMode = b, e.Suspense = q, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = V, e.__COMPILER_RUNTIME = te, e.act = function(i) {
        var g = V.actQueue, T = ue;
        ue++;
        var P = V.actQueue = g !== null ? g : [], N = !1;
        try {
          var Y = i();
        } catch (W) {
          V.thrownErrors.push(W);
        }
        if (0 < V.thrownErrors.length)
          throw H(g, T), i = M(V.thrownErrors), V.thrownErrors.length = 0, i;
        if (Y !== null && typeof Y == "object" && typeof Y.then == "function") {
          var B = Y;
          return Ae(function() {
            N || de || (de = !0, console.error(
              "You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"
            ));
          }), {
            then: function(W, ne) {
              N = !0, B.then(
                function(ie) {
                  if (H(g, T), T === 0) {
                    try {
                      Q(P), U(function() {
                        return K(
                          ie,
                          W,
                          ne
                        );
                      });
                    } catch (Le) {
                      V.thrownErrors.push(Le);
                    }
                    if (0 < V.thrownErrors.length) {
                      var ke = M(
                        V.thrownErrors
                      );
                      V.thrownErrors.length = 0, ne(ke);
                    }
                  } else W(ie);
                },
                function(ie) {
                  H(g, T), 0 < V.thrownErrors.length && (ie = M(
                    V.thrownErrors
                  ), V.thrownErrors.length = 0), ne(ie);
                }
              );
            }
          };
        }
        var Z = Y;
        if (H(g, T), T === 0 && (Q(P), P.length !== 0 && Ae(function() {
          N || de || (de = !0, console.error(
            "A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"
          ));
        }), V.actQueue = null), 0 < V.thrownErrors.length)
          throw i = M(V.thrownErrors), V.thrownErrors.length = 0, i;
        return {
          then: function(W, ne) {
            N = !0, T === 0 ? (V.actQueue = P, U(function() {
              return K(
                Z,
                W,
                ne
              );
            })) : W(Z);
          }
        };
      }, e.cache = function(i) {
        return function() {
          return i.apply(null, arguments);
        };
      }, e.captureOwnerStack = function() {
        var i = V.getCurrentStack;
        return i === null ? null : i();
      }, e.cloneElement = function(i, g, T) {
        if (i == null)
          throw Error(
            "The argument must be a React element, but you passed " + i + "."
          );
        var P = ge({}, i.props), N = i.key, Y = i._owner;
        if (g != null) {
          var B;
          e: {
            if (le.call(g, "ref") && (B = Object.getOwnPropertyDescriptor(
              g,
              "ref"
            ).get) && B.isReactWarning) {
              B = !1;
              break e;
            }
            B = g.ref !== void 0;
          }
          B && (Y = C()), z(g) && (E(g.key), N = "" + g.key);
          for (Z in g)
            !le.call(g, Z) || Z === "key" || Z === "__self" || Z === "__source" || Z === "ref" && g.ref === void 0 || (P[Z] = g[Z]);
        }
        var Z = arguments.length - 2;
        if (Z === 1) P.children = T;
        else if (1 < Z) {
          B = Array(Z);
          for (var W = 0; W < Z; W++)
            B[W] = arguments[W + 2];
          P.children = B;
        }
        for (P = $(
          i.type,
          N,
          void 0,
          void 0,
          Y,
          P,
          i._debugStack,
          i._debugTask
        ), N = 2; N < arguments.length; N++)
          Y = arguments[N], m(Y) && Y._store && (Y._store.validated = 1);
        return P;
      }, e.createContext = function(i) {
        return i = {
          $$typeof: F,
          _currentValue: i,
          _currentValue2: i,
          _threadCount: 0,
          Provider: null,
          Consumer: null
        }, i.Provider = i, i.Consumer = {
          $$typeof: k,
          _context: i
        }, i._currentRenderer = null, i._currentRenderer2 = null, i;
      }, e.createElement = function(i, g, T) {
        for (var P = 2; P < arguments.length; P++) {
          var N = arguments[P];
          m(N) && N._store && (N._store.validated = 1);
        }
        if (P = {}, N = null, g != null)
          for (W in be || !("__self" in g) || "key" in g || (be = !0, console.warn(
            "Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform"
          )), z(g) && (E(g.key), N = "" + g.key), g)
            le.call(g, W) && W !== "key" && W !== "__self" && W !== "__source" && (P[W] = g[W]);
        var Y = arguments.length - 2;
        if (Y === 1) P.children = T;
        else if (1 < Y) {
          for (var B = Array(Y), Z = 0; Z < Y; Z++)
            B[Z] = arguments[Z + 2];
          Object.freeze && Object.freeze(B), P.children = B;
        }
        if (i && i.defaultProps)
          for (W in Y = i.defaultProps, Y)
            P[W] === void 0 && (P[W] = Y[W]);
        N && L(
          P,
          typeof i == "function" ? i.displayName || i.name || "Unknown" : i
        );
        var W = 1e4 > V.recentlyCreatedOwnerStacks++;
        return $(
          i,
          N,
          void 0,
          void 0,
          C(),
          P,
          W ? Error("react-stack-top-frame") : Re,
          W ? ye(S(i)) : Pe
        );
      }, e.createRef = function() {
        var i = { current: null };
        return Object.seal(i), i;
      }, e.forwardRef = function(i) {
        i != null && i.$$typeof === j ? console.error(
          "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))."
        ) : typeof i != "function" ? console.error(
          "forwardRef requires a render function but was given %s.",
          i === null ? "null" : typeof i
        ) : i.length !== 0 && i.length !== 2 && console.error(
          "forwardRef render functions accept exactly two parameters: props and ref. %s",
          i.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."
        ), i != null && i.defaultProps != null && console.error(
          "forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?"
        );
        var g = { $$typeof: G, render: i }, T;
        return Object.defineProperty(g, "displayName", {
          enumerable: !1,
          configurable: !0,
          get: function() {
            return T;
          },
          set: function(P) {
            T = P, i.name || i.displayName || (Object.defineProperty(i, "name", { value: P }), i.displayName = P);
          }
        }), g;
      }, e.isValidElement = m, e.lazy = function(i) {
        return {
          $$typeof: ee,
          _payload: { _status: -1, _result: i },
          _init: y
        };
      }, e.memo = function(i, g) {
        i == null && console.error(
          "memo: The first argument must be a component. Instead received: %s",
          i === null ? "null" : typeof i
        ), g = {
          $$typeof: j,
          type: i,
          compare: g === void 0 ? null : g
        };
        var T;
        return Object.defineProperty(g, "displayName", {
          enumerable: !1,
          configurable: !0,
          get: function() {
            return T;
          },
          set: function(P) {
            T = P, i.name || i.displayName || (Object.defineProperty(i, "name", { value: P }), i.displayName = P);
          }
        }), g;
      }, e.startTransition = function(i) {
        var g = V.T, T = {};
        V.T = T, T._updatedFibers = /* @__PURE__ */ new Set();
        try {
          var P = i(), N = V.S;
          N !== null && N(T, P), typeof P == "object" && P !== null && typeof P.then == "function" && P.then(O, Ce);
        } catch (Y) {
          Ce(Y);
        } finally {
          g === null && T._updatedFibers && (i = T._updatedFibers.size, T._updatedFibers.clear(), 10 < i && console.warn(
            "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
          )), V.T = g;
        }
      }, e.unstable_useCacheRefresh = function() {
        return w().useCacheRefresh();
      }, e.use = function(i) {
        return w().use(i);
      }, e.useActionState = function(i, g, T) {
        return w().useActionState(
          i,
          g,
          T
        );
      }, e.useCallback = function(i, g) {
        return w().useCallback(i, g);
      }, e.useContext = function(i) {
        var g = w();
        return i.$$typeof === k && console.error(
          "Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?"
        ), g.useContext(i);
      }, e.useDebugValue = function(i, g) {
        return w().useDebugValue(i, g);
      }, e.useDeferredValue = function(i, g) {
        return w().useDeferredValue(i, g);
      }, e.useEffect = function(i, g, T) {
        i == null && console.warn(
          "React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?"
        );
        var P = w();
        if (typeof T == "function")
          throw Error(
            "useEffect CRUD overload is not enabled in this build of React."
          );
        return P.useEffect(i, g);
      }, e.useId = function() {
        return w().useId();
      }, e.useImperativeHandle = function(i, g, T) {
        return w().useImperativeHandle(i, g, T);
      }, e.useInsertionEffect = function(i, g) {
        return i == null && console.warn(
          "React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?"
        ), w().useInsertionEffect(i, g);
      }, e.useLayoutEffect = function(i, g) {
        return i == null && console.warn(
          "React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?"
        ), w().useLayoutEffect(i, g);
      }, e.useMemo = function(i, g) {
        return w().useMemo(i, g);
      }, e.useOptimistic = function(i, g) {
        return w().useOptimistic(i, g);
      }, e.useReducer = function(i, g, T) {
        return w().useReducer(i, g, T);
      }, e.useRef = function(i) {
        return w().useRef(i);
      }, e.useState = function(i) {
        return w().useState(i);
      }, e.useSyncExternalStore = function(i, g, T) {
        return w().useSyncExternalStore(
          i,
          g,
          T
        );
      }, e.useTransition = function() {
        return w().useTransition();
      }, e.version = "19.1.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    }();
  }(react_development, react_development.exports)), react_development.exports;
}
var hasRequiredReact;
function requireReact() {
  return hasRequiredReact || (hasRequiredReact = 1, process.env.NODE_ENV === "production" ? react.exports = requireReact_production() : react.exports = requireReact_development()), react.exports;
}
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && function() {
    function t(l) {
      if (l == null) return null;
      if (typeof l == "function")
        return l.$$typeof === y ? null : l.displayName || l.name || null;
      if (typeof l == "string") return l;
      switch (l) {
        case L:
          return "Fragment";
        case $:
          return "Profiler";
        case I:
          return "StrictMode";
        case d:
          return "Suspense";
        case s:
          return "SuspenseList";
        case v:
          return "Activity";
      }
      if (typeof l == "object")
        switch (typeof l.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), l.$$typeof) {
          case z:
            return "Portal";
          case m:
            return (l.displayName || "Context") + ".Provider";
          case D:
            return (l._context.displayName || "Context") + ".Consumer";
          case h:
            var b = l.render;
            return l = l.displayName, l || (l = b.displayName || b.name || "", l = l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef"), l;
          case u:
            return b = l.displayName || null, b !== null ? b : t(l.type) || "Memo";
          case f:
            b = l._payload, l = l._init;
            try {
              return t(l(b));
            } catch {
            }
        }
      return null;
    }
    function e(l) {
      return "" + l;
    }
    function r(l) {
      try {
        e(l);
        var b = !1;
      } catch {
        b = !0;
      }
      if (b) {
        b = console;
        var R = b.error, k = typeof Symbol == "function" && Symbol.toStringTag && l[Symbol.toStringTag] || l.constructor.name || "Object";
        return R.call(
          b,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          k
        ), e(l);
      }
    }
    function n(l) {
      if (l === L) return "<>";
      if (typeof l == "object" && l !== null && l.$$typeof === f)
        return "<...>";
      try {
        var b = t(l);
        return b ? "<" + b + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function a() {
      var l = w.A;
      return l === null ? null : l.getOwner();
    }
    function o() {
      return Error("react-stack-top-frame");
    }
    function c(l) {
      if (O.call(l, "key")) {
        var b = Object.getOwnPropertyDescriptor(l, "key").get;
        if (b && b.isReactWarning) return !1;
      }
      return l.key !== void 0;
    }
    function p(l, b) {
      function R() {
        H || (H = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          b
        ));
      }
      R.isReactWarning = !0, Object.defineProperty(l, "key", {
        get: R,
        configurable: !0
      });
    }
    function _() {
      var l = t(this.type);
      return K[l] || (K[l] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), l = this.props.ref, l !== void 0 ? l : null;
    }
    function E(l, b, R, k, F, G, q, J) {
      return R = G.ref, l = {
        $$typeof: x,
        type: l,
        key: b,
        props: G,
        _owner: F
      }, (R !== void 0 ? R : null) !== null ? Object.defineProperty(l, "ref", {
        enumerable: !1,
        get: _
      }) : Object.defineProperty(l, "ref", { enumerable: !1, value: null }), l._store = {}, Object.defineProperty(l._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(l, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(l, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: q
      }), Object.defineProperty(l, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: J
      }), Object.freeze && (Object.freeze(l.props), Object.freeze(l)), l;
    }
    function A(l, b, R, k, F, G, q, J) {
      var j = b.children;
      if (j !== void 0)
        if (k)
          if (U(j)) {
            for (k = 0; k < j.length; k++)
              S(j[k]);
            Object.freeze && Object.freeze(j);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else S(j);
      if (O.call(b, "key")) {
        j = t(l);
        var ee = Object.keys(b).filter(function(ae) {
          return ae !== "key";
        });
        k = 0 < ee.length ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}", re[j + k] || (ee = 0 < ee.length ? "{" + ee.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          k,
          j,
          ee,
          j
        ), re[j + k] = !0);
      }
      if (j = null, R !== void 0 && (r(R), j = "" + R), c(b) && (r(b.key), j = "" + b.key), "key" in b) {
        R = {};
        for (var oe in b)
          oe !== "key" && (R[oe] = b[oe]);
      } else R = b;
      return j && p(
        R,
        typeof l == "function" ? l.displayName || l.name || "Unknown" : l
      ), E(
        l,
        j,
        G,
        F,
        a(),
        R,
        q,
        J
      );
    }
    function S(l) {
      typeof l == "object" && l !== null && l.$$typeof === x && l._store && (l._store.validated = 1);
    }
    var C = requireReact(), x = Symbol.for("react.transitional.element"), z = Symbol.for("react.portal"), L = Symbol.for("react.fragment"), I = Symbol.for("react.strict_mode"), $ = Symbol.for("react.profiler"), D = Symbol.for("react.consumer"), m = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), s = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), v = Symbol.for("react.activity"), y = Symbol.for("react.client.reference"), w = C.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, O = Object.prototype.hasOwnProperty, U = Array.isArray, M = console.createTask ? console.createTask : function() {
      return null;
    };
    C = {
      "react-stack-bottom-frame": function(l) {
        return l();
      }
    };
    var H, K = {}, Q = C["react-stack-bottom-frame"].bind(
      C,
      o
    )(), X = M(n(o)), re = {};
    reactJsxRuntime_development.Fragment = L, reactJsxRuntime_development.jsx = function(l, b, R, k, F) {
      var G = 1e4 > w.recentlyCreatedOwnerStacks++;
      return A(
        l,
        b,
        R,
        !1,
        k,
        F,
        G ? Error("react-stack-top-frame") : Q,
        G ? M(n(l)) : X
      );
    }, reactJsxRuntime_development.jsxs = function(l, b, R, k, F) {
      var G = 1e4 > w.recentlyCreatedOwnerStacks++;
      return A(
        l,
        b,
        R,
        !0,
        k,
        F,
        G ? Error("react-stack-top-frame") : Q,
        G ? M(n(l)) : X
      );
    };
  }()), reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  return hasRequiredJsxRuntime || (hasRequiredJsxRuntime = 1, process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production() : jsxRuntime.exports = requireReactJsxRuntime_development()), jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime(), reactExports = requireReact();
const React = /* @__PURE__ */ getDefaultExportFromCjs(reactExports);
let ezViewerInstanceCounter = 0;
class EZEditorView extends React.Component {
  constructor() {
    super(...arguments), this.wrapperID = `ez-wrapper-content-${++ezViewerInstanceCounter}`, this.gotoStepAttribute = "goToCourseStep", this.wrapperDom = React.createRef();
  }
  componentDidMount() {
    if (this.wrapperDom.current != null) {
      const r = this.finalHtml();
      this.wrapperDom.current.innerHTML = r;
      var e = this.wrapperDom.current.querySelectorAll("script");
      this.buildScript(e, 0);
    }
    ezInitMain({
      holderSelector: "#" + this.wrapperID,
      baseUrl: this.props.baseUrl,
      clickActions: this.props.clickActions,
      contactId: this.props.currentUserId,
      userIsInFilter: this.props.userIsInFilter,
      videoWords: this.props.videoWords
    }), ezInitForms(this.props.formProps, () => this.props.currentUserId?.() != null), this.props.onCourseItemClick != null && document.querySelectorAll(`[${this.gotoStepAttribute}]`).forEach((r) => {
      r.addEventListener("click", () => {
        const n = r.getAttribute(this.gotoStepAttribute);
        n && this.props.onCourseItemClick?.(n);
      });
    }), window[this.gotoStepAttribute] = this.props.onCourseItemClick;
  }
  finalHtml() {
    let e = this.props.html ?? "";
    const r = new RegExp('href="download:([^"]+)"', "g");
    if (e = e.replace(r, (n, a) => `href="${this.props.baseUrl}/file/download/${a}"`), this.props.onCourseItemClick != null) {
      const n = new RegExp('href="step:([^"]+)"', "g");
      e = e.replace(n, (a, o) => `${this.gotoStepAttribute}="${o}"`);
    }
    return e;
  }
  //this thing below is needed for script execution
  //need to do them in order load one after another.
  //e.g. load jquery and then using $(document).ready() in this case will work
  buildScript(e, r) {
    const n = e[r];
    if (!n)
      return !0;
    const a = document.createElement("script");
    Array.from(n.attributes).forEach((c) => a.setAttribute(c.name, c.value));
    const o = !a.hasAttribute("src");
    o || (a.onload = () => this.buildScript(e, r + 1)), a.appendChild(document.createTextNode(n.innerHTML)), n.parentNode && n.parentNode.replaceChild(a, n), o && this.buildScript(e, r + 1);
  }
  render() {
    const e = ["ez-wrapper"];
    return this.props.noCopy && e.push("no-copy"), /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("style", { children: this.props.style }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: this.wrapperDom, id: this.wrapperID, className: e.join(" "), style: this.props.wrapperStyle, children: " " })
    ] });
  }
}
export {
  CountryCookieName,
  EZEditorView,
  applyUrlParamToHiddenField,
  applyUrlParamToHiddenFields,
  buildPlayerEmbedCode,
  emulateClick,
  ezInitForms,
  ezInitMain,
  formatTimecode,
  getPlayerParam,
  getPlayerVideoIds,
  isInsideWidget,
  isOurPlayerEmbed,
  makeIframesLazy,
  onPlayerMessage,
  parseTimecode,
  parseVideoMomentSettings,
  resolveUrlParamValue,
  setPlayerParam,
  toVideoMomentSettings
};
//# sourceMappingURL=index.js.map
